(function () {
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
//Bootstrap JS

(function($) {
    var defaults = {
        // GENERAL
        mode: "horizontal",
        slideSelector: "",
        infiniteLoop: true,
        hideControlOnEnd: false,
        speed: 500,
        easing: null,
        slideMargin: 0,
        startSlide: 0,
        randomStart: false,
        captions: false,
        ticker: false,
        tickerHover: false,
        adaptiveHeight: false,
        adaptiveHeightSpeed: 500,
        video: false,
        useCSS: true,
        preloadImages: "visible",
        responsive: true,
        slideZIndex: 50,
        wrapperClass: "bx-wrapper",
        // TOUCH
        touchEnabled: true,
        swipeThreshold: 50,
        oneToOneTouch: true,
        preventDefaultSwipeX: true,
        preventDefaultSwipeY: false,
        // ACCESSIBILITY
        ariaLive: true,
        ariaHidden: true,
        // KEYBOARD
        keyboardEnabled: false,
        // PAGER
        pager: true,
        pagerType: "full",
        pagerShortSeparator: " / ",
        pagerSelector: null,
        buildPager: null,
        pagerCustom: null,
        // CONTROLS
        controls: true,
        nextText: "Next",
        prevText: "Prev",
        nextSelector: null,
        prevSelector: null,
        autoControls: false,
        startText: "Start",
        stopText: "Stop",
        autoControlsCombine: false,
        autoControlsSelector: null,
        // AUTO
        auto: false,
        pause: 4000,
        autoStart: true,
        autoDirection: "next",
        stopAutoOnClick: false,
        autoHover: false,
        autoDelay: 0,
        autoSlideForOnePage: false,
        // CAROUSEL
        minSlides: 1,
        maxSlides: 1,
        moveSlides: 0,
        slideWidth: 0,
        shrinkItems: false,
        // CALLBACKS
        onSliderLoad: function() {
            return true;
        },
        onSlideBefore: function() {
            return true;
        },
        onSlideAfter: function() {
            return true;
        },
        onSlideNext: function() {
            return true;
        },
        onSlidePrev: function() {
            return true;
        },
        onSliderResize: function() {
            return true;
        }
    };
    $.fn.bxSlider = function(options) {
        if (this.length === 0) return this;
        // support multiple elements
        if (this.length > 1) {
            this.each(function() {
                $(this).bxSlider(options);
            });
            return this;
        }
        // create a namespace to be used throughout the plugin
        var slider = {}, // set a reference to our slider element
        el = this, // get the original window dimens (thanks a lot IE)
        windowWidth = $(window).width(), windowHeight = $(window).height();
        // Return if slider is already initialized
        if ($(el).data("bxSlider")) return;
        /**
     * ===================================================================================
     * = PRIVATE FUNCTIONS
     * ===================================================================================
     */ /**
     * Initializes namespace settings to be used throughout plugin
     */ var init = function() {
            // Return if slider is already initialized
            if ($(el).data("bxSlider")) return;
            // merge user-supplied options with the defaults
            slider.settings = $.extend({}, defaults, options);
            // parse slideWidth setting
            slider.settings.slideWidth = parseInt(slider.settings.slideWidth);
            // store the original children
            slider.children = el.children(slider.settings.slideSelector);
            // check if actual number of slides is less than minSlides / maxSlides
            if (slider.children.length < slider.settings.minSlides) slider.settings.minSlides = slider.children.length;
            if (slider.children.length < slider.settings.maxSlides) slider.settings.maxSlides = slider.children.length;
            // if random start, set the startSlide setting to random number
            if (slider.settings.randomStart) slider.settings.startSlide = Math.floor(Math.random() * slider.children.length);
            // store active slide information
            slider.active = {
                index: slider.settings.startSlide
            };
            // store if the slider is in carousel mode (displaying / moving multiple slides)
            slider.carousel = slider.settings.minSlides > 1 || slider.settings.maxSlides > 1 ? true : false;
            // if carousel, force preloadImages = 'all'
            if (slider.carousel) slider.settings.preloadImages = "all";
            // calculate the min / max width thresholds based on min / max number of slides
            // used to setup and update carousel slides dimensions
            slider.minThreshold = slider.settings.minSlides * slider.settings.slideWidth + (slider.settings.minSlides - 1) * slider.settings.slideMargin;
            slider.maxThreshold = slider.settings.maxSlides * slider.settings.slideWidth + (slider.settings.maxSlides - 1) * slider.settings.slideMargin;
            // store the current state of the slider (if currently animating, working is true)
            slider.working = false;
            // initialize the controls object
            slider.controls = {};
            // initialize an auto interval
            slider.interval = null;
            // determine which property to use for transitions
            slider.animProp = slider.settings.mode === "vertical" ? "top" : "left";
            // determine if hardware acceleration can be used
            slider.usingCSS = slider.settings.useCSS && slider.settings.mode !== "fade" && function() {
                // create our test div element
                var div = document.createElement("div"), // css transition properties
                props = [
                    "WebkitPerspective",
                    "MozPerspective",
                    "OPerspective",
                    "msPerspective"
                ];
                // test for each property
                for(i = 0; i < props.length; i++)if (div.style[props[i]] !== undefined) {
                    slider.cssPrefix = props[i].replace("Perspective", "").toLowerCase();
                    slider.animProp = "-" + slider.cssPrefix + "-transform";
                    return true;
                }
                return false;
            }();
            // if vertical mode always make maxSlides and minSlides equal
            if (slider.settings.mode === "vertical") slider.settings.maxSlides = slider.settings.minSlides;
            // save original style data
            el.data("origStyle", el.attr("style"));
            el.children(slider.settings.slideSelector).each(function() {
                $(this).data("origStyle", $(this).attr("style"));
            });
            // perform all DOM / CSS modifications
            setup();
        };
        /**
     * Performs all DOM and CSS modifications
     */ var setup = function() {
            var preloadSelector = slider.children.eq(slider.settings.startSlide); // set the default preload selector (visible)
            // wrap el in a wrapper
            el.wrap('<div class="' + slider.settings.wrapperClass + '"><div class="bx-viewport"></div></div>');
            // store a namespace reference to .bx-viewport
            slider.viewport = el.parent();
            // add aria-live if the setting is enabled and ticker mode is disabled
            if (slider.settings.ariaLive && !slider.settings.ticker) slider.viewport.attr("aria-live", "polite");
            // add a loading div to display while images are loading
            slider.loader = $('<div class="bx-loading" />');
            slider.viewport.prepend(slider.loader);
            // set el to a massive width, to hold any needed slides
            // also strip any margin and padding from el
            el.css({
                width: slider.settings.mode === "horizontal" ? slider.children.length * 1000 + 215 + "%" : "auto",
                position: "relative"
            });
            // if using CSS, add the easing property
            if (slider.usingCSS && slider.settings.easing) el.css("-" + slider.cssPrefix + "-transition-timing-function", slider.settings.easing);
            else if (!slider.settings.easing) slider.settings.easing = "swing";
            // make modifications to the viewport (.bx-viewport)
            slider.viewport.css({
                width: "100%",
                overflow: "hidden",
                position: "relative"
            });
            slider.viewport.parent().css({
                maxWidth: getViewportMaxWidth()
            });
            // make modification to the wrapper (.bx-wrapper)
            if (!slider.settings.pager && !slider.settings.controls) slider.viewport.parent().css({
                margin: "0 auto 0px"
            });
            // apply css to all slider children
            slider.children.css({
                float: slider.settings.mode === "horizontal" ? "left" : "none",
                listStyle: "none",
                position: "relative"
            });
            // apply the calculated width after the float is applied to prevent scrollbar interference
            slider.children.css("width", getSlideWidth());
            // if slideMargin is supplied, add the css
            if (slider.settings.mode === "horizontal" && slider.settings.slideMargin > 0) slider.children.css("marginRight", slider.settings.slideMargin);
            if (slider.settings.mode === "vertical" && slider.settings.slideMargin > 0) slider.children.css("marginBottom", slider.settings.slideMargin);
            // if "fade" mode, add positioning and z-index CSS
            if (slider.settings.mode === "fade") {
                slider.children.css({
                    position: "absolute",
                    zIndex: 0,
                    display: "none"
                });
                // prepare the z-index on the showing element
                slider.children.eq(slider.settings.startSlide).css({
                    zIndex: slider.settings.slideZIndex,
                    display: "block"
                });
            }
            // create an element to contain all slider controls (pager, start / stop, etc)
            slider.controls.el = $('<div class="bx-controls" />');
            // if captions are requested, add them
            if (slider.settings.captions) appendCaptions();
            // check if startSlide is last slide
            slider.active.last = slider.settings.startSlide === getPagerQty() - 1;
            // if video is true, set up the fitVids plugin
            if (slider.settings.video) el.fitVids();
            if (slider.settings.preloadImages === "all" || slider.settings.ticker) preloadSelector = slider.children;
            // only check for control addition if not in "ticker" mode
            if (!slider.settings.ticker) {
                // if controls are requested, add them
                if (slider.settings.controls) appendControls();
                // if auto is true, and auto controls are requested, add them
                if (slider.settings.auto && slider.settings.autoControls) appendControlsAuto();
                // if pager is requested, add it
                if (slider.settings.pager) appendPager();
                // if any control option is requested, add the controls wrapper
                if (slider.settings.controls || slider.settings.autoControls || slider.settings.pager) slider.viewport.after(slider.controls.el);
            // if ticker mode, do not allow a pager
            } else slider.settings.pager = false;
            loadElements(preloadSelector, start);
        };
        var loadElements = function(selector, callback) {
            var total = selector.find('img:not([src=""]), iframe').length, count = 0;
            if (total === 0) {
                callback();
                return;
            }
            selector.find('img:not([src=""]), iframe').each(function() {
                $(this).one("load error", function() {
                    if (++count === total) callback();
                }).each(function() {
                    if (this.complete) $(this).load();
                });
            });
        };
        /**
     * Start the slider
     */ var start = function() {
            // if infinite loop, prepare additional slides
            if (slider.settings.infiniteLoop && slider.settings.mode !== "fade" && !slider.settings.ticker) {
                var slice = slider.settings.mode === "vertical" ? slider.settings.minSlides : slider.settings.maxSlides, sliceAppend = slider.children.slice(0, slice).clone(true).addClass("bx-clone"), slicePrepend = slider.children.slice(-slice).clone(true).addClass("bx-clone");
                if (slider.settings.ariaHidden) {
                    sliceAppend.attr("aria-hidden", true);
                    slicePrepend.attr("aria-hidden", true);
                }
                el.append(sliceAppend).prepend(slicePrepend);
            }
            // remove the loading DOM element
            slider.loader.remove();
            // set the left / top position of "el"
            setSlidePosition();
            // if "vertical" mode, always use adaptiveHeight to prevent odd behavior
            if (slider.settings.mode === "vertical") slider.settings.adaptiveHeight = true;
            // set the viewport height
            slider.viewport.height(getViewportHeight());
            // make sure everything is positioned just right (same as a window resize)
            el.redrawSlider();
            // onSliderLoad callback
            slider.settings.onSliderLoad.call(el, slider.active.index);
            // slider has been fully initialized
            slider.initialized = true;
            // bind the resize call to the window
            if (slider.settings.responsive) $(window).bind("resize", resizeWindow);
            // if auto is true and has more than 1 page, start the show
            if (slider.settings.auto && slider.settings.autoStart && (getPagerQty() > 1 || slider.settings.autoSlideForOnePage)) initAuto();
            // if ticker is true, start the ticker
            if (slider.settings.ticker) initTicker();
            // if pager is requested, make the appropriate pager link active
            if (slider.settings.pager) updatePagerActive(slider.settings.startSlide);
            // check for any updates to the controls (like hideControlOnEnd updates)
            if (slider.settings.controls) updateDirectionControls();
            // if touchEnabled is true, setup the touch events
            if (slider.settings.touchEnabled && !slider.settings.ticker) initTouch();
            // if keyboardEnabled is true, setup the keyboard events
            if (slider.settings.keyboardEnabled && !slider.settings.ticker) $(document).keydown(keyPress);
        };
        /**
     * Returns the calculated height of the viewport, used to determine either adaptiveHeight or the maxHeight value
     */ var getViewportHeight = function() {
            var height = el.outerHeight(), currentIndex = null, // first determine which children (slides) should be used in our height calculation
            children = $();
            // if mode is not "vertical" and adaptiveHeight is false, include all children
            if (slider.settings.mode !== "vertical" && !slider.settings.adaptiveHeight) children = slider.children;
            else // if not carousel, return the single active child
            if (!slider.carousel) children = slider.children.eq(slider.active.index);
            else {
                // get the individual slide index
                currentIndex = slider.settings.moveSlides === 1 ? slider.active.index : slider.active.index * getMoveBy();
                // add the current slide to the children
                children = slider.children.eq(currentIndex);
                // cycle through the remaining "showing" slides
                for(i = 1; i <= slider.settings.maxSlides - 1; i++)// if looped back to the start
                if (currentIndex + i >= slider.children.length) children = children.add(slider.children.eq(currentIndex + i - slider.children.length));
                else children = children.add(slider.children.eq(currentIndex + i));
            }
            // if "vertical" mode, calculate the sum of the heights of the children
            if (slider.settings.mode === "vertical") {
                children.each(function(index) {
                    height += $(this).outerHeight();
                });
                // add user-supplied margins
                if (slider.settings.slideMargin > 0) height += slider.settings.slideMargin * (slider.settings.minSlides - 1);
            // if not "vertical" mode, calculate the max height of the children
            } else height = Math.max.apply(Math, children.map(function() {
                return $(this).outerHeight(false);
            }).get());
            if (slider.viewport.css("box-sizing") === "border-box") height += parseFloat(slider.viewport.css("padding-top")) + parseFloat(slider.viewport.css("padding-bottom")) + parseFloat(slider.viewport.css("border-top-width")) + parseFloat(slider.viewport.css("border-bottom-width"));
            else if (slider.viewport.css("box-sizing") === "padding-box") height += parseFloat(slider.viewport.css("padding-top")) + parseFloat(slider.viewport.css("padding-bottom"));
            return height;
        };
        /**
     * Returns the calculated width to be used for the outer wrapper / viewport
     */ var getViewportMaxWidth = function() {
            var width = "100%";
            if (slider.settings.slideWidth > 0) {
                if (slider.settings.mode === "horizontal") width = slider.settings.maxSlides * slider.settings.slideWidth + (slider.settings.maxSlides - 1) * slider.settings.slideMargin;
                else width = slider.settings.slideWidth;
            }
            return width;
        };
        /**
     * Returns the calculated width to be applied to each slide
     */ var getSlideWidth = function() {
            var newElWidth = slider.settings.slideWidth, wrapWidth = slider.viewport.width(); // get the current viewport width
            // if slide width was not supplied, or is larger than the viewport use the viewport width
            if (slider.settings.slideWidth === 0 || slider.settings.slideWidth > wrapWidth && !slider.carousel || slider.settings.mode === "vertical") newElWidth = wrapWidth;
            else if (slider.settings.maxSlides > 1 && slider.settings.mode === "horizontal") {
                if (wrapWidth > slider.maxThreshold) return newElWidth;
                else if (wrapWidth < slider.minThreshold) newElWidth = (wrapWidth - slider.settings.slideMargin * (slider.settings.minSlides - 1)) / slider.settings.minSlides;
                else if (slider.settings.shrinkItems) newElWidth = Math.floor((wrapWidth + slider.settings.slideMargin) / Math.ceil((wrapWidth + slider.settings.slideMargin) / (newElWidth + slider.settings.slideMargin)) - slider.settings.slideMargin);
            }
            return newElWidth;
        };
        /**
     * Returns the number of slides currently visible in the viewport (includes partially visible slides)
     */ var getNumberSlidesShowing = function() {
            var slidesShowing = 1, childWidth = null;
            if (slider.settings.mode === "horizontal" && slider.settings.slideWidth > 0) {
                // if viewport is smaller than minThreshold, return minSlides
                if (slider.viewport.width() < slider.minThreshold) slidesShowing = slider.settings.minSlides;
                else if (slider.viewport.width() > slider.maxThreshold) slidesShowing = slider.settings.maxSlides;
                else {
                    childWidth = slider.children.first().width() + slider.settings.slideMargin;
                    slidesShowing = Math.floor((slider.viewport.width() + slider.settings.slideMargin) / childWidth);
                }
            // if "vertical" mode, slides showing will always be minSlides
            } else if (slider.settings.mode === "vertical") slidesShowing = slider.settings.minSlides;
            return slidesShowing;
        };
        /**
     * Returns the number of pages (one full viewport of slides is one "page")
     */ var getPagerQty = function() {
            var pagerQty = 0, breakPoint = 0, counter = 0;
            // if moveSlides is specified by the user
            if (slider.settings.moveSlides > 0) {
                if (slider.settings.infiniteLoop) pagerQty = Math.ceil(slider.children.length / getMoveBy());
                else // when breakpoint goes above children length, counter is the number of pages
                while(breakPoint < slider.children.length){
                    ++pagerQty;
                    breakPoint = counter + getNumberSlidesShowing();
                    counter += slider.settings.moveSlides <= getNumberSlidesShowing() ? slider.settings.moveSlides : getNumberSlidesShowing();
                }
            // if moveSlides is 0 (auto) divide children length by sides showing, then round up
            } else pagerQty = Math.ceil(slider.children.length / getNumberSlidesShowing());
            return pagerQty;
        };
        /**
     * Returns the number of individual slides by which to shift the slider
     */ var getMoveBy = function() {
            // if moveSlides was set by the user and moveSlides is less than number of slides showing
            if (slider.settings.moveSlides > 0 && slider.settings.moveSlides <= getNumberSlidesShowing()) return slider.settings.moveSlides;
            // if moveSlides is 0 (auto)
            return getNumberSlidesShowing();
        };
        /**
     * Sets the slider's (el) left or top position
     */ var setSlidePosition = function() {
            var position, lastChild, lastShowingIndex;
            // if last slide, not infinite loop, and number of children is larger than specified maxSlides
            if (slider.children.length > slider.settings.maxSlides && slider.active.last && !slider.settings.infiniteLoop) {
                if (slider.settings.mode === "horizontal") {
                    // get the last child's position
                    lastChild = slider.children.last();
                    position = lastChild.position();
                    // set the left position
                    setPositionProperty(-(position.left - (slider.viewport.width() - lastChild.outerWidth())), "reset", 0);
                } else if (slider.settings.mode === "vertical") {
                    // get the last showing index's position
                    lastShowingIndex = slider.children.length - slider.settings.minSlides;
                    position = slider.children.eq(lastShowingIndex).position();
                    // set the top position
                    setPositionProperty(-position.top, "reset", 0);
                }
            // if not last slide
            } else {
                // get the position of the first showing slide
                position = slider.children.eq(slider.active.index * getMoveBy()).position();
                // check for last slide
                if (slider.active.index === getPagerQty() - 1) slider.active.last = true;
                // set the respective position
                if (position !== undefined) {
                    if (slider.settings.mode === "horizontal") setPositionProperty(-position.left, "reset", 0);
                    else if (slider.settings.mode === "vertical") setPositionProperty(-position.top, "reset", 0);
                }
            }
        };
        /**
     * Sets the el's animating property position (which in turn will sometimes animate el).
     * If using CSS, sets the transform property. If not using CSS, sets the top / left property.
     *
     * @param value (int)
     *  - the animating property's value
     *
     * @param type (string) 'slide', 'reset', 'ticker'
     *  - the type of instance for which the function is being
     *
     * @param duration (int)
     *  - the amount of time (in ms) the transition should occupy
     *
     * @param params (array) optional
     *  - an optional parameter containing any variables that need to be passed in
     */ var setPositionProperty = function(value, type, duration, params) {
            var animateObj, propValue;
            // use CSS transform
            if (slider.usingCSS) {
                // determine the translate3d value
                propValue = slider.settings.mode === "vertical" ? "translate3d(0, " + value + "px, 0)" : "translate3d(" + value + "px, 0, 0)";
                // add the CSS transition-duration
                el.css("-" + slider.cssPrefix + "-transition-duration", duration / 1000 + "s");
                if (type === "slide") {
                    // set the property value
                    el.css(slider.animProp, propValue);
                    // bind a callback method - executes when CSS transition completes
                    el.bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function(e) {
                        //make sure it's the correct one
                        if (!$(e.target).is(el)) return;
                        // unbind the callback
                        el.unbind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd");
                        updateAfterSlideTransition();
                    });
                } else if (type === "reset") el.css(slider.animProp, propValue);
                else if (type === "ticker") {
                    // make the transition use 'linear'
                    el.css("-" + slider.cssPrefix + "-transition-timing-function", "linear");
                    el.css(slider.animProp, propValue);
                    // bind a callback method - executes when CSS transition completes
                    el.bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd", function(e) {
                        //make sure it's the correct one
                        if (!$(e.target).is(el)) return;
                        // unbind the callback
                        el.unbind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd");
                        // reset the position
                        setPositionProperty(params.resetValue, "reset", 0);
                        // start the loop again
                        tickerLoop();
                    });
                }
            // use JS animate
            } else {
                animateObj = {};
                animateObj[slider.animProp] = value;
                if (type === "slide") el.animate(animateObj, duration, slider.settings.easing, function() {
                    updateAfterSlideTransition();
                });
                else if (type === "reset") el.css(slider.animProp, value);
                else if (type === "ticker") el.animate(animateObj, duration, "linear", function() {
                    setPositionProperty(params.resetValue, "reset", 0);
                    // run the recursive loop after animation
                    tickerLoop();
                });
            }
        };
        /**
     * Populates the pager with proper amount of pages
     */ var populatePager = function() {
            var pagerHtml = "", linkContent = "", pagerQty = getPagerQty();
            // loop through each pager item
            for(i = 0; i < pagerQty; i++){
                linkContent = "";
                // if a buildPager function is supplied, use it to get pager link value, else use index + 1
                if (slider.settings.buildPager && $.isFunction(slider.settings.buildPager) || slider.settings.pagerCustom) {
                    linkContent = slider.settings.buildPager(i);
                    slider.pagerEl.addClass("bx-custom-pager");
                } else {
                    linkContent = i + 1;
                    slider.pagerEl.addClass("bx-default-pager");
                }
                // var linkContent = slider.settings.buildPager && $.isFunction(slider.settings.buildPager) ? slider.settings.buildPager(i) : i + 1;
                // add the markup to the string
                pagerHtml += '<div class="bx-pager-item"><a href="" data-slide-index="' + i + '" class="bx-pager-link">' + linkContent + "</a></div>";
            }
            // populate the pager element with pager links
            slider.pagerEl.html(pagerHtml);
        };
        /**
     * Appends the pager to the controls element
     */ var appendPager = function() {
            if (!slider.settings.pagerCustom) {
                // create the pager DOM element
                slider.pagerEl = $('<div class="bx-pager" />');
                // if a pager selector was supplied, populate it with the pager
                if (slider.settings.pagerSelector) $(slider.settings.pagerSelector).html(slider.pagerEl);
                else slider.controls.el.addClass("bx-has-pager").append(slider.pagerEl);
                // populate the pager
                populatePager();
            } else slider.pagerEl = $(slider.settings.pagerCustom);
            // assign the pager click binding
            slider.pagerEl.on("click touchend", "a", clickPagerBind);
        };
        /**
     * Appends prev / next controls to the controls element
     */ var appendControls = function() {
            slider.controls.next = $('<a class="bx-next" href="">' + slider.settings.nextText + "</a>");
            slider.controls.prev = $('<a class="bx-prev" href="">' + slider.settings.prevText + "</a>");
            // bind click actions to the controls
            slider.controls.next.bind("click touchend", clickNextBind);
            slider.controls.prev.bind("click touchend", clickPrevBind);
            // if nextSelector was supplied, populate it
            if (slider.settings.nextSelector) $(slider.settings.nextSelector).append(slider.controls.next);
            // if prevSelector was supplied, populate it
            if (slider.settings.prevSelector) $(slider.settings.prevSelector).append(slider.controls.prev);
            // if no custom selectors were supplied
            if (!slider.settings.nextSelector && !slider.settings.prevSelector) {
                // add the controls to the DOM
                slider.controls.directionEl = $('<div class="bx-controls-direction" />');
                // add the control elements to the directionEl
                slider.controls.directionEl.append(slider.controls.prev).append(slider.controls.next);
                // slider.viewport.append(slider.controls.directionEl);
                slider.controls.el.addClass("bx-has-controls-direction").append(slider.controls.directionEl);
            }
        };
        /**
     * Appends start / stop auto controls to the controls element
     */ var appendControlsAuto = function() {
            slider.controls.start = $('<div class="bx-controls-auto-item"><a class="bx-start" href="">' + slider.settings.startText + "</a></div>");
            slider.controls.stop = $('<div class="bx-controls-auto-item"><a class="bx-stop" href="">' + slider.settings.stopText + "</a></div>");
            // add the controls to the DOM
            slider.controls.autoEl = $('<div class="bx-controls-auto" />');
            // bind click actions to the controls
            slider.controls.autoEl.on("click", ".bx-start", clickStartBind);
            slider.controls.autoEl.on("click", ".bx-stop", clickStopBind);
            // if autoControlsCombine, insert only the "start" control
            if (slider.settings.autoControlsCombine) slider.controls.autoEl.append(slider.controls.start);
            else slider.controls.autoEl.append(slider.controls.start).append(slider.controls.stop);
            // if auto controls selector was supplied, populate it with the controls
            if (slider.settings.autoControlsSelector) $(slider.settings.autoControlsSelector).html(slider.controls.autoEl);
            else slider.controls.el.addClass("bx-has-controls-auto").append(slider.controls.autoEl);
            // update the auto controls
            updateAutoControls(slider.settings.autoStart ? "stop" : "start");
        };
        /**
     * Appends image captions to the DOM
     */ var appendCaptions = function() {
            // cycle through each child
            slider.children.each(function(index) {
                // get the image title attribute
                var title = $(this).find("img:first").attr("title");
                // append the caption
                if (title !== undefined && ("" + title).length) $(this).append('<div class="bx-caption"><span>' + title + "</span></div>");
            });
        };
        /**
     * Click next binding
     *
     * @param e (event)
     *  - DOM event object
     */ var clickNextBind = function(e) {
            e.preventDefault();
            if (slider.controls.el.hasClass("disabled")) return;
            // if auto show is running, stop it
            if (slider.settings.auto && slider.settings.stopAutoOnClick) el.stopAuto();
            el.goToNextSlide();
        };
        /**
     * Click prev binding
     *
     * @param e (event)
     *  - DOM event object
     */ var clickPrevBind = function(e) {
            e.preventDefault();
            if (slider.controls.el.hasClass("disabled")) return;
            // if auto show is running, stop it
            if (slider.settings.auto && slider.settings.stopAutoOnClick) el.stopAuto();
            el.goToPrevSlide();
        };
        /**
     * Click start binding
     *
     * @param e (event)
     *  - DOM event object
     */ var clickStartBind = function(e) {
            el.startAuto();
            e.preventDefault();
        };
        /**
     * Click stop binding
     *
     * @param e (event)
     *  - DOM event object
     */ var clickStopBind = function(e) {
            el.stopAuto();
            e.preventDefault();
        };
        /**
     * Click pager binding
     *
     * @param e (event)
     *  - DOM event object
     */ var clickPagerBind = function(e) {
            var pagerLink, pagerIndex;
            e.preventDefault();
            if (slider.controls.el.hasClass("disabled")) return;
            // if auto show is running, stop it
            if (slider.settings.auto && slider.settings.stopAutoOnClick) el.stopAuto();
            pagerLink = $(e.currentTarget);
            if (pagerLink.attr("data-slide-index") !== undefined) {
                pagerIndex = parseInt(pagerLink.attr("data-slide-index"));
                // if clicked pager link is not active, continue with the goToSlide call
                if (pagerIndex !== slider.active.index) el.goToSlide(pagerIndex);
            }
        };
        /**
     * Updates the pager links with an active class
     *
     * @param slideIndex (int)
     *  - index of slide to make active
     */ var updatePagerActive = function(slideIndex) {
            // if "short" pager type
            var len = slider.children.length; // nb of children
            if (slider.settings.pagerType === "short") {
                if (slider.settings.maxSlides > 1) len = Math.ceil(slider.children.length / slider.settings.maxSlides);
                slider.pagerEl.html(slideIndex + 1 + slider.settings.pagerShortSeparator + len);
                return;
            }
            // remove all pager active classes
            slider.pagerEl.find("a").removeClass("active");
            // apply the active class for all pagers
            slider.pagerEl.each(function(i1, el) {
                $(el).find("a").eq(slideIndex).addClass("active");
            });
        };
        /**
     * Performs needed actions after a slide transition
     */ var updateAfterSlideTransition = function() {
            // if infinite loop is true
            if (slider.settings.infiniteLoop) {
                var position = "";
                // first slide
                if (slider.active.index === 0) // set the new position
                position = slider.children.eq(0).position();
                else if (slider.active.index === getPagerQty() - 1 && slider.carousel) position = slider.children.eq((getPagerQty() - 1) * getMoveBy()).position();
                else if (slider.active.index === slider.children.length - 1) position = slider.children.eq(slider.children.length - 1).position();
                if (position) {
                    if (slider.settings.mode === "horizontal") setPositionProperty(-position.left, "reset", 0.01);
                    else if (slider.settings.mode === "vertical") setPositionProperty(-position.top, "reset", 0.01);
                }
            }
            // declare that the transition is complete
            slider.working = false;
            // onSlideAfter callback
            slider.settings.onSlideAfter.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index);
        };
        /**
     * Updates the auto controls state (either active, or combined switch)
     *
     * @param state (string) "start", "stop"
     *  - the new state of the auto show
     */ var updateAutoControls = function(state) {
            // if autoControlsCombine is true, replace the current control with the new state
            if (slider.settings.autoControlsCombine) slider.controls.autoEl.html(slider.controls[state]);
            else {
                slider.controls.autoEl.find("a").removeClass("active");
                slider.controls.autoEl.find("a:not(.bx-" + state + ")").addClass("active");
            }
        };
        /**
     * Updates the direction controls (checks if either should be hidden)
     */ var updateDirectionControls = function() {
            if (getPagerQty() === 1) {
                slider.controls.prev.addClass("disabled");
                slider.controls.next.addClass("disabled");
            } else if (!slider.settings.infiniteLoop && slider.settings.hideControlOnEnd) {
                // if first slide
                if (slider.active.index === 0) {
                    slider.controls.prev.addClass("disabled");
                    slider.controls.next.removeClass("disabled");
                // if last slide
                } else if (slider.active.index === getPagerQty() - 1) {
                    slider.controls.next.addClass("disabled");
                    slider.controls.prev.removeClass("disabled");
                // if any slide in the middle
                } else {
                    slider.controls.prev.removeClass("disabled");
                    slider.controls.next.removeClass("disabled");
                }
            }
        };
        /**
     * Initializes the auto process
     */ var initAuto = function() {
            // if autoDelay was supplied, launch the auto show using a setTimeout() call
            if (slider.settings.autoDelay > 0) var timeout = setTimeout(el.startAuto, slider.settings.autoDelay);
            else {
                el.startAuto();
                //add focus and blur events to ensure its running if timeout gets paused
                $(window).focus(function() {
                    el.startAuto();
                }).blur(function() {
                    el.stopAuto();
                });
            }
            // if autoHover is requested
            if (slider.settings.autoHover) // on el hover
            el.hover(function() {
                // if the auto show is currently playing (has an active interval)
                if (slider.interval) {
                    // stop the auto show and pass true argument which will prevent control update
                    el.stopAuto(true);
                    // create a new autoPaused value which will be used by the relative "mouseout" event
                    slider.autoPaused = true;
                }
            }, function() {
                // if the autoPaused value was created be the prior "mouseover" event
                if (slider.autoPaused) {
                    // start the auto show and pass true argument which will prevent control update
                    el.startAuto(true);
                    // reset the autoPaused value
                    slider.autoPaused = null;
                }
            });
        };
        /**
     * Initializes the ticker process
     */ var initTicker = function() {
            var startPosition = 0, position, transform, value, idx, ratio, property, newSpeed, totalDimens;
            // if autoDirection is "next", append a clone of the entire slider
            if (slider.settings.autoDirection === "next") el.append(slider.children.clone().addClass("bx-clone"));
            else {
                el.prepend(slider.children.clone().addClass("bx-clone"));
                position = slider.children.first().position();
                startPosition = slider.settings.mode === "horizontal" ? -position.left : -position.top;
            }
            setPositionProperty(startPosition, "reset", 0);
            // do not allow controls in ticker mode
            slider.settings.pager = false;
            slider.settings.controls = false;
            slider.settings.autoControls = false;
            // if autoHover is requested
            if (slider.settings.tickerHover) {
                if (slider.usingCSS) {
                    idx = slider.settings.mode === "horizontal" ? 4 : 5;
                    slider.viewport.hover(function() {
                        transform = el.css("-" + slider.cssPrefix + "-transform");
                        value = parseFloat(transform.split(",")[idx]);
                        setPositionProperty(value, "reset", 0);
                    }, function() {
                        totalDimens = 0;
                        slider.children.each(function(index) {
                            totalDimens += slider.settings.mode === "horizontal" ? $(this).outerWidth(true) : $(this).outerHeight(true);
                        });
                        // calculate the speed ratio (used to determine the new speed to finish the paused animation)
                        ratio = slider.settings.speed / totalDimens;
                        // determine which property to use
                        property = slider.settings.mode === "horizontal" ? "left" : "top";
                        // calculate the new speed
                        newSpeed = ratio * (totalDimens - Math.abs(parseInt(value)));
                        tickerLoop(newSpeed);
                    });
                } else // on el hover
                slider.viewport.hover(function() {
                    el.stop();
                }, function() {
                    // calculate the total width of children (used to calculate the speed ratio)
                    totalDimens = 0;
                    slider.children.each(function(index) {
                        totalDimens += slider.settings.mode === "horizontal" ? $(this).outerWidth(true) : $(this).outerHeight(true);
                    });
                    // calculate the speed ratio (used to determine the new speed to finish the paused animation)
                    ratio = slider.settings.speed / totalDimens;
                    // determine which property to use
                    property = slider.settings.mode === "horizontal" ? "left" : "top";
                    // calculate the new speed
                    newSpeed = ratio * (totalDimens - Math.abs(parseInt(el.css(property))));
                    tickerLoop(newSpeed);
                });
            }
            // start the ticker loop
            tickerLoop();
        };
        /**
     * Runs a continuous loop, news ticker-style
     */ var tickerLoop = function(resumeSpeed) {
            var speed = resumeSpeed ? resumeSpeed : slider.settings.speed, position = {
                left: 0,
                top: 0
            }, reset = {
                left: 0,
                top: 0
            }, animateProperty, resetValue, params;
            // if "next" animate left position to last child, then reset left to 0
            if (slider.settings.autoDirection === "next") position = el.find(".bx-clone").first().position();
            else reset = slider.children.first().position();
            animateProperty = slider.settings.mode === "horizontal" ? -position.left : -position.top;
            resetValue = slider.settings.mode === "horizontal" ? -reset.left : -reset.top;
            params = {
                resetValue: resetValue
            };
            setPositionProperty(animateProperty, "ticker", speed, params);
        };
        /**
     * Check if el is on screen
     */ var isOnScreen = function(el) {
            var win = $(window), viewport = {
                top: win.scrollTop(),
                left: win.scrollLeft()
            }, bounds = el.offset();
            viewport.right = viewport.left + win.width();
            viewport.bottom = viewport.top + win.height();
            bounds.right = bounds.left + el.outerWidth();
            bounds.bottom = bounds.top + el.outerHeight();
            return !(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom);
        };
        /**
     * Initializes keyboard events
     */ var keyPress = function(e) {
            var activeElementTag = document.activeElement.tagName.toLowerCase(), tagFilters = "input|textarea", p = new RegExp(activeElementTag, [
                "i"
            ]), result = p.exec(tagFilters);
            if (result == null && isOnScreen(el)) {
                if (e.keyCode === 39) {
                    clickNextBind(e);
                    return false;
                } else if (e.keyCode === 37) {
                    clickPrevBind(e);
                    return false;
                }
            }
        };
        /**
     * Initializes touch events
     */ var initTouch = function() {
            // initialize object to contain all touch values
            slider.touch = {
                start: {
                    x: 0,
                    y: 0
                },
                end: {
                    x: 0,
                    y: 0
                }
            };
            slider.viewport.bind("touchstart MSPointerDown pointerdown", onTouchStart);
            //for browsers that have implemented pointer events and fire a click after
            //every pointerup regardless of whether pointerup is on same screen location as pointerdown or not
            slider.viewport.on("click", ".bxslider a", function(e) {
                if (slider.viewport.hasClass("click-disabled")) {
                    e.preventDefault();
                    slider.viewport.removeClass("click-disabled");
                }
            });
        };
        /**
     * Event handler for "touchstart"
     *
     * @param e (event)
     *  - DOM event object
     */ var onTouchStart = function(e) {
            //disable slider controls while user is interacting with slides to avoid slider freeze that happens on touch devices when a slide swipe happens immediately after interacting with slider controls
            slider.controls.el.addClass("disabled");
            if (slider.working) {
                e.preventDefault();
                slider.controls.el.removeClass("disabled");
            } else {
                // record the original position when touch starts
                slider.touch.originalPos = el.position();
                var orig = e.originalEvent, touchPoints = typeof orig.changedTouches !== "undefined" ? orig.changedTouches : [
                    orig
                ];
                // record the starting touch x, y coordinates
                slider.touch.start.x = touchPoints[0].pageX;
                slider.touch.start.y = touchPoints[0].pageY;
                if (slider.viewport.get(0).setPointerCapture) {
                    slider.pointerId = orig.pointerId;
                    slider.viewport.get(0).setPointerCapture(slider.pointerId);
                }
                // bind a "touchmove" event to the viewport
                slider.viewport.bind("touchmove MSPointerMove pointermove", onTouchMove);
                // bind a "touchend" event to the viewport
                slider.viewport.bind("touchend MSPointerUp pointerup", onTouchEnd);
                slider.viewport.bind("MSPointerCancel pointercancel", onPointerCancel);
            }
        };
        /**
     * Cancel Pointer for Windows Phone
     *
     * @param e (event)
     *  - DOM event object
     */ var onPointerCancel = function(e) {
            /* onPointerCancel handler is needed to deal with situations when a touchend
      doesn't fire after a touchstart (this happens on windows phones only) */ setPositionProperty(slider.touch.originalPos.left, "reset", 0);
            //remove handlers
            slider.controls.el.removeClass("disabled");
            slider.viewport.unbind("MSPointerCancel pointercancel", onPointerCancel);
            slider.viewport.unbind("touchmove MSPointerMove pointermove", onTouchMove);
            slider.viewport.unbind("touchend MSPointerUp pointerup", onTouchEnd);
            if (slider.viewport.get(0).releasePointerCapture) slider.viewport.get(0).releasePointerCapture(slider.pointerId);
        };
        /**
     * Event handler for "touchmove"
     *
     * @param e (event)
     *  - DOM event object
     */ var onTouchMove = function(e) {
            var orig = e.originalEvent, touchPoints = typeof orig.changedTouches !== "undefined" ? orig.changedTouches : [
                orig
            ], // if scrolling on y axis, do not prevent default
            xMovement = Math.abs(touchPoints[0].pageX - slider.touch.start.x), yMovement = Math.abs(touchPoints[0].pageY - slider.touch.start.y), value = 0, change = 0;
            // x axis swipe
            if (xMovement * 3 > yMovement && slider.settings.preventDefaultSwipeX) e.preventDefault();
            else if (yMovement * 3 > xMovement && slider.settings.preventDefaultSwipeY) e.preventDefault();
            if (slider.settings.mode !== "fade" && slider.settings.oneToOneTouch) {
                // if horizontal, drag along x axis
                if (slider.settings.mode === "horizontal") {
                    change = touchPoints[0].pageX - slider.touch.start.x;
                    value = slider.touch.originalPos.left + change;
                // if vertical, drag along y axis
                } else {
                    change = touchPoints[0].pageY - slider.touch.start.y;
                    value = slider.touch.originalPos.top + change;
                }
                setPositionProperty(value, "reset", 0);
            }
        };
        /**
     * Event handler for "touchend"
     *
     * @param e (event)
     *  - DOM event object
     */ var onTouchEnd = function(e) {
            slider.viewport.unbind("touchmove MSPointerMove pointermove", onTouchMove);
            //enable slider controls as soon as user stops interacing with slides
            slider.controls.el.removeClass("disabled");
            var orig = e.originalEvent, touchPoints = typeof orig.changedTouches !== "undefined" ? orig.changedTouches : [
                orig
            ], value = 0, distance = 0;
            // record end x, y positions
            slider.touch.end.x = touchPoints[0].pageX;
            slider.touch.end.y = touchPoints[0].pageY;
            // if fade mode, check if absolute x distance clears the threshold
            if (slider.settings.mode === "fade") {
                distance = Math.abs(slider.touch.start.x - slider.touch.end.x);
                if (distance >= slider.settings.swipeThreshold) {
                    if (slider.touch.start.x > slider.touch.end.x) el.goToNextSlide();
                    else el.goToPrevSlide();
                    el.stopAuto();
                }
            // not fade mode
            } else {
                // calculate distance and el's animate property
                if (slider.settings.mode === "horizontal") {
                    distance = slider.touch.end.x - slider.touch.start.x;
                    value = slider.touch.originalPos.left;
                } else {
                    distance = slider.touch.end.y - slider.touch.start.y;
                    value = slider.touch.originalPos.top;
                }
                // if not infinite loop and first / last slide, do not attempt a slide transition
                if (!slider.settings.infiniteLoop && (slider.active.index === 0 && distance > 0 || slider.active.last && distance < 0)) setPositionProperty(value, "reset", 200);
                else // check if distance clears threshold
                if (Math.abs(distance) >= slider.settings.swipeThreshold) {
                    if (distance < 0) el.goToNextSlide();
                    else el.goToPrevSlide();
                    el.stopAuto();
                } else // el.animate(property, 200);
                setPositionProperty(value, "reset", 200);
            }
            slider.viewport.unbind("touchend MSPointerUp pointerup", onTouchEnd);
            if (slider.viewport.get(0).releasePointerCapture) slider.viewport.get(0).releasePointerCapture(slider.pointerId);
        };
        /**
     * Window resize event callback
     */ var resizeWindow = function(e) {
            // don't do anything if slider isn't initialized.
            if (!slider.initialized) return;
            // Delay if slider working.
            if (slider.working) window.setTimeout(resizeWindow, 10);
            else {
                // get the new window dimens (again, thank you IE)
                var windowWidthNew = $(window).width(), windowHeightNew = $(window).height();
                // make sure that it is a true window resize
                // *we must check this because our dinosaur friend IE fires a window resize event when certain DOM elements
                // are resized. Can you just die already?*
                if (windowWidth !== windowWidthNew || windowHeight !== windowHeightNew) {
                    // set the new window dimens
                    windowWidth = windowWidthNew;
                    windowHeight = windowHeightNew;
                    // update all dynamic elements
                    el.redrawSlider();
                    // Call user resize handler
                    slider.settings.onSliderResize.call(el, slider.active.index);
                }
            }
        };
        /**
     * Adds an aria-hidden=true attribute to each element
     *
     * @param startVisibleIndex (int)
     *  - the first visible element's index
     */ var applyAriaHiddenAttributes = function(startVisibleIndex) {
            var numberOfSlidesShowing = getNumberSlidesShowing();
            // only apply attributes if the setting is enabled and not in ticker mode
            if (slider.settings.ariaHidden && !slider.settings.ticker) {
                // add aria-hidden=true to all elements
                slider.children.attr("aria-hidden", "true");
                // get the visible elements and change to aria-hidden=false
                slider.children.slice(startVisibleIndex, startVisibleIndex + numberOfSlidesShowing).attr("aria-hidden", "false");
            }
        };
        /**
     * ===================================================================================
     * = PUBLIC FUNCTIONS
     * ===================================================================================
     */ /**
     * Performs slide transition to the specified slide
     *
     * @param slideIndex (int)
     *  - the destination slide's index (zero-based)
     *
     * @param direction (string)
     *  - INTERNAL USE ONLY - the direction of travel ("prev" / "next")
     */ el.goToSlide = function(slideIndex, direction) {
            // onSlideBefore, onSlideNext, onSlidePrev callbacks
            // Allow transition canceling based on returned value
            var performTransition = true, moveBy = 0, position = {
                left: 0,
                top: 0
            }, lastChild = null, lastShowingIndex, eq, value, requestEl;
            // if plugin is currently in motion, ignore request
            if (slider.working || slider.active.index === slideIndex) return;
            // declare that plugin is in motion
            slider.working = true;
            // store the old index
            slider.oldIndex = slider.active.index;
            // if slideIndex is less than zero, set active index to last child (this happens during infinite loop)
            if (slideIndex < 0) slider.active.index = getPagerQty() - 1;
            else if (slideIndex >= getPagerQty()) slider.active.index = 0;
            else slider.active.index = slideIndex;
            performTransition = slider.settings.onSlideBefore.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index);
            if (typeof performTransition !== "undefined" && !performTransition) {
                slider.active.index = slider.oldIndex; // restore old index
                slider.working = false; // is not in motion
                return;
            }
            if (direction === "next") // Prevent canceling in future functions or lack there-of from negating previous commands to cancel
            {
                if (!slider.settings.onSlideNext.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index)) performTransition = false;
            } else if (direction === "prev") // Prevent canceling in future functions or lack there-of from negating previous commands to cancel
            {
                if (!slider.settings.onSlidePrev.call(el, slider.children.eq(slider.active.index), slider.oldIndex, slider.active.index)) performTransition = false;
            }
            // If transitions canceled, reset and return
            if (typeof performTransition !== "undefined" && !performTransition) {
                slider.active.index = slider.oldIndex; // restore old index
                slider.working = false; // is not in motion
                return;
            }
            // check if last slide
            slider.active.last = slider.active.index >= getPagerQty() - 1;
            // update the pager with active class
            if (slider.settings.pager || slider.settings.pagerCustom) updatePagerActive(slider.active.index);
            // // check for direction control update
            if (slider.settings.controls) updateDirectionControls();
            // if slider is set to mode: "fade"
            if (slider.settings.mode === "fade") {
                // if adaptiveHeight is true and next height is different from current height, animate to the new height
                if (slider.settings.adaptiveHeight && slider.viewport.height() !== getViewportHeight()) slider.viewport.animate({
                    height: getViewportHeight()
                }, slider.settings.adaptiveHeightSpeed);
                // fade out the visible child and reset its z-index value
                slider.children.filter(":visible").fadeOut(slider.settings.speed).css({
                    zIndex: 0
                });
                // fade in the newly requested slide
                slider.children.eq(slider.active.index).css("zIndex", slider.settings.slideZIndex + 1).fadeIn(slider.settings.speed, function() {
                    $(this).css("zIndex", slider.settings.slideZIndex);
                    updateAfterSlideTransition();
                });
            // slider mode is not "fade"
            } else {
                // if adaptiveHeight is true and next height is different from current height, animate to the new height
                if (slider.settings.adaptiveHeight && slider.viewport.height() !== getViewportHeight()) slider.viewport.animate({
                    height: getViewportHeight()
                }, slider.settings.adaptiveHeightSpeed);
                // if carousel and not infinite loop
                if (!slider.settings.infiniteLoop && slider.carousel && slider.active.last) {
                    if (slider.settings.mode === "horizontal") {
                        // get the last child position
                        lastChild = slider.children.eq(slider.children.length - 1);
                        position = lastChild.position();
                        // calculate the position of the last slide
                        moveBy = slider.viewport.width() - lastChild.outerWidth();
                    } else {
                        // get last showing index position
                        lastShowingIndex = slider.children.length - slider.settings.minSlides;
                        position = slider.children.eq(lastShowingIndex).position();
                    }
                } else if (slider.carousel && slider.active.last && direction === "prev") {
                    // get the last child position
                    eq = slider.settings.moveSlides === 1 ? slider.settings.maxSlides - getMoveBy() : (getPagerQty() - 1) * getMoveBy() - (slider.children.length - slider.settings.maxSlides);
                    lastChild = el.children(".bx-clone").eq(eq);
                    position = lastChild.position();
                // if infinite loop and "Next" is clicked on the last slide
                } else if (direction === "next" && slider.active.index === 0) {
                    // get the last clone position
                    position = el.find("> .bx-clone").eq(slider.settings.maxSlides).position();
                    slider.active.last = false;
                // normal non-zero requests
                } else if (slideIndex >= 0) {
                    requestEl = slideIndex * getMoveBy();
                    position = slider.children.eq(requestEl).position();
                }
                value = slider.settings.mode === "horizontal" ? -(position.left - moveBy) : -position.top;
                // plugin values to be animated
                setPositionProperty(value, "slide", slider.settings.speed);
            }
            if (slider.settings.ariaHidden) applyAriaHiddenAttributes(slider.active.index * getMoveBy());
        };
        /**
     * Transitions to the next slide in the show
     */ el.goToNextSlide = function() {
            // if infiniteLoop is false and last page is showing, disregard call
            if (!slider.settings.infiniteLoop && slider.active.last) return;
            var pagerIndex = parseInt(slider.active.index) + 1;
            el.goToSlide(pagerIndex, "next");
        };
        /**
     * Transitions to the prev slide in the show
     */ el.goToPrevSlide = function() {
            // if infiniteLoop is false and last page is showing, disregard call
            if (!slider.settings.infiniteLoop && slider.active.index === 0) return;
            var pagerIndex = parseInt(slider.active.index) - 1;
            el.goToSlide(pagerIndex, "prev");
        };
        /**
     * Starts the auto show
     *
     * @param preventControlUpdate (boolean)
     *  - if true, auto controls state will not be updated
     */ el.startAuto = function(preventControlUpdate) {
            // if an interval already exists, disregard call
            if (slider.interval) return;
            // create an interval
            slider.interval = setInterval(function() {
                if (slider.settings.autoDirection === "next") el.goToNextSlide();
                else el.goToPrevSlide();
            }, slider.settings.pause);
            // if auto controls are displayed and preventControlUpdate is not true
            if (slider.settings.autoControls && preventControlUpdate !== true) updateAutoControls("stop");
        };
        /**
     * Stops the auto show
     *
     * @param preventControlUpdate (boolean)
     *  - if true, auto controls state will not be updated
     */ el.stopAuto = function(preventControlUpdate) {
            // if no interval exists, disregard call
            if (!slider.interval) return;
            // clear the interval
            clearInterval(slider.interval);
            slider.interval = null;
            // if auto controls are displayed and preventControlUpdate is not true
            if (slider.settings.autoControls && preventControlUpdate !== true) updateAutoControls("start");
        };
        /**
     * Returns current slide index (zero-based)
     */ el.getCurrentSlide = function() {
            return slider.active.index;
        };
        /**
     * Returns current slide element
     */ el.getCurrentSlideElement = function() {
            return slider.children.eq(slider.active.index);
        };
        /**
     * Returns a slide element
     * @param index (int)
     *  - The index (zero-based) of the element you want returned.
     */ el.getSlideElement = function(index) {
            return slider.children.eq(index);
        };
        /**
     * Returns number of slides in show
     */ el.getSlideCount = function() {
            return slider.children.length;
        };
        /**
     * Return slider.working variable
     */ el.isWorking = function() {
            return slider.working;
        };
        /**
     * Update all dynamic slider elements
     */ el.redrawSlider = function() {
            // resize all children in ratio to new screen size
            slider.children.add(el.find(".bx-clone")).outerWidth(getSlideWidth());
            // adjust the height
            slider.viewport.css("height", getViewportHeight());
            // update the slide position
            if (!slider.settings.ticker) setSlidePosition();
            // if active.last was true before the screen resize, we want
            // to keep it last no matter what screen size we end on
            if (slider.active.last) slider.active.index = getPagerQty() - 1;
            // if the active index (page) no longer exists due to the resize, simply set the index as last
            if (slider.active.index >= getPagerQty()) slider.active.last = true;
            // if a pager is being displayed and a custom pager is not being used, update it
            if (slider.settings.pager && !slider.settings.pagerCustom) {
                populatePager();
                updatePagerActive(slider.active.index);
            }
            if (slider.settings.ariaHidden) applyAriaHiddenAttributes(slider.active.index * getMoveBy());
        };
        /**
     * Destroy the current instance of the slider (revert everything back to original state)
     */ el.destroySlider = function() {
            // don't do anything if slider has already been destroyed
            if (!slider.initialized) return;
            slider.initialized = false;
            $(".bx-clone", this).remove();
            slider.children.each(function() {
                if ($(this).data("origStyle") !== undefined) $(this).attr("style", $(this).data("origStyle"));
                else $(this).removeAttr("style");
            });
            if ($(this).data("origStyle") !== undefined) this.attr("style", $(this).data("origStyle"));
            else $(this).removeAttr("style");
            $(this).unwrap().unwrap();
            if (slider.controls.el) slider.controls.el.remove();
            if (slider.controls.next) slider.controls.next.remove();
            if (slider.controls.prev) slider.controls.prev.remove();
            if (slider.pagerEl && slider.settings.controls && !slider.settings.pagerCustom) slider.pagerEl.remove();
            $(".bx-caption", this).remove();
            if (slider.controls.autoEl) slider.controls.autoEl.remove();
            clearInterval(slider.interval);
            if (slider.settings.responsive) $(window).unbind("resize", resizeWindow);
            if (slider.settings.keyboardEnabled) $(document).unbind("keydown", keyPress);
            //remove self reference in data
            $(this).removeData("bxSlider");
        };
        /**
     * Reload the slider (revert all DOM changes, and re-initialize)
     */ el.reloadSlider = function(settings) {
            if (settings !== undefined) options = settings;
            el.destroySlider();
            init();
            //store reference to self in order to access public functions later
            $(el).data("bxSlider", this);
        };
        init();
        $(el).data("bxSlider", this);
        // returns the current jQuery object
        return this;
    };
})(jQuery);


/**
 * History.js jQuery Adapter
 * @author Benjamin Arthur Lupton <contact@balupton.com>
 * @copyright 2010-2011 Benjamin Arthur Lupton <contact@balupton.com>
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */ // Closure
(function(window1, undefined) {
    "use strict";
    // Localise Globals
    var History = window1.History = window1.History || {}, jQuery = window1.jQuery;
    // Check Existence
    if (typeof History.Adapter !== "undefined") throw new Error("History.js Adapter has already been loaded...");
    // Add the Adapter
    History.Adapter = {
        /**
		 * History.Adapter.bind(el,event,callback)
		 * @param {Element|string} el
		 * @param {string} event - custom and standard events
		 * @param {function} callback
		 * @return {void}
		 */ bind: function(el, event, callback) {
            jQuery(el).bind(event, callback);
        },
        /**
		 * History.Adapter.trigger(el,event)
		 * @param {Element|string} el
		 * @param {string} event - custom and standard events
		 * @param {Object=} extra - a object of extra event data (optional)
		 * @return {void}
		 */ trigger: function(el, event, extra) {
            jQuery(el).trigger(event, extra);
        },
        /**
		 * History.Adapter.extractEventData(key,event,extra)
		 * @param {string} key - key for the event data to extract
		 * @param {string} event - custom and standard events
		 * @param {Object=} extra - a object of extra event data (optional)
		 * @return {mixed}
		 */ extractEventData: function(key, event, extra) {
            // jQuery Native then jQuery Custom
            var result = event && event.originalEvent && event.originalEvent[key] || extra && extra[key] || undefined;
            // Return
            return result;
        },
        /**
		 * History.Adapter.onDomLoad(callback)
		 * @param {function} callback
		 * @return {void}
		 */ onDomLoad: function(callback) {
            jQuery(callback);
        }
    };
    // Try and Initialise History
    if (typeof History.init !== "undefined") History.init();
})(window);
/**
 * History.js Core
 * @author Benjamin Arthur Lupton <contact@balupton.com>
 * @copyright 2010-2011 Benjamin Arthur Lupton <contact@balupton.com>
 * @license New BSD License <http://creativecommons.org/licenses/BSD/>
 */ (function(window1, undefined) {
    "use strict";
    // ========================================================================
    // Initialise
    // Localise Globals
    var console = window1.console || undefined, document = window1.document, navigator = window1.navigator, sessionStorage = false, setTimeout = window1.setTimeout, clearTimeout = window1.clearTimeout, setInterval = window1.setInterval, clearInterval = window1.clearInterval, JSON = window1.JSON, alert = window1.alert, History = window1.History = window1.History || {}, history = window1.history; // Old History Object
    try {
        sessionStorage = window1.sessionStorage; // This will throw an exception in some browsers when cookies/localStorage are explicitly disabled (i.e. Chrome)
        sessionStorage.setItem("TEST", "1");
        sessionStorage.removeItem("TEST");
    } catch (e) {
        sessionStorage = false;
    }
    // MooTools Compatibility
    JSON.stringify = JSON.stringify || JSON.encode;
    JSON.parse = JSON.parse || JSON.decode;
    // Check Existence
    if (typeof History.init !== "undefined") throw new Error("History.js Core has already been loaded...");
    // Initialise History
    History.init = function(options) {
        // Check Load Status of Adapter
        if (typeof History.Adapter === "undefined") return false;
        // Check Load Status of Core
        if (typeof History.initCore !== "undefined") History.initCore();
        // Check Load Status of HTML4 Support
        if (typeof History.initHtml4 !== "undefined") History.initHtml4();
        // Return true
        return true;
    };
    // ========================================================================
    // Initialise Core
    // Initialise Core
    History.initCore = function(options) {
        // Initialise
        if (typeof History.initCore.initialized !== "undefined") // Already Loaded
        return false;
        else History.initCore.initialized = true;
        // ====================================================================
        // Options
        /**
		 * History.options
		 * Configurable options
		 */ History.options = History.options || {};
        /**
		 * History.options.hashChangeInterval
		 * How long should the interval be before hashchange checks
		 */ History.options.hashChangeInterval = History.options.hashChangeInterval || 100;
        /**
		 * History.options.safariPollInterval
		 * How long should the interval be before safari poll checks
		 */ History.options.safariPollInterval = History.options.safariPollInterval || 500;
        /**
		 * History.options.doubleCheckInterval
		 * How long should the interval be before we perform a double check
		 */ History.options.doubleCheckInterval = History.options.doubleCheckInterval || 500;
        /**
		 * History.options.disableSuid
		 * Force History not to append suid
		 */ History.options.disableSuid = History.options.disableSuid || false;
        /**
		 * History.options.storeInterval
		 * How long should we wait between store calls
		 */ History.options.storeInterval = History.options.storeInterval || 1000;
        /**
		 * History.options.busyDelay
		 * How long should we wait between busy events
		 */ History.options.busyDelay = History.options.busyDelay || 250;
        /**
		 * History.options.debug
		 * If true will enable debug messages to be logged
		 */ History.options.debug = History.options.debug || false;
        /**
		 * History.options.initialTitle
		 * What is the title of the initial state
		 */ History.options.initialTitle = History.options.initialTitle || document.title;
        /**
		 * History.options.html4Mode
		 * If true, will force HTMl4 mode (hashtags)
		 */ History.options.html4Mode = History.options.html4Mode || false;
        /**
		 * History.options.delayInit
		 * Want to override default options and call init manually.
		 */ History.options.delayInit = History.options.delayInit || false;
        // ====================================================================
        // Interval record
        /**
		 * History.intervalList
		 * List of intervals set, to be cleared when document is unloaded.
		 */ History.intervalList = [];
        /**
		 * History.clearAllIntervals
		 * Clears all setInterval instances.
		 */ History.clearAllIntervals = function() {
            var i, il = History.intervalList;
            if (typeof il !== "undefined" && il !== null) {
                for(i = 0; i < il.length; i++)clearInterval(il[i]);
                History.intervalList = null;
            }
        };
        // ====================================================================
        // Debug
        /**
		 * History.debug(message,...)
		 * Logs the passed arguments if debug enabled
		 */ History.debug = function() {
            if (History.options.debug || false) History.log.apply(History, arguments);
        };
        /**
		 * History.log(message,...)
		 * Logs the passed arguments
		 */ History.log = function() {
            // Prepare
            var consoleExists = !(typeof console === "undefined" || typeof console.log === "undefined" || typeof console.log.apply === "undefined"), textarea = document.getElementById("log"), message, i, n, args, arg;
            // Write to Console
            if (consoleExists) {
                args = Array.prototype.slice.call(arguments);
                message = args.shift();
                if (typeof console.debug !== "undefined") console.debug.apply(console, [
                    message,
                    args
                ]);
                else console.log.apply(console, [
                    message,
                    args
                ]);
            } else message = "\n" + arguments[0] + "\n";
            // Write to log
            for(i = 1, n = arguments.length; i < n; ++i){
                arg = arguments[i];
                if (typeof arg === "object" && typeof JSON !== "undefined") try {
                    arg = JSON.stringify(arg);
                } catch (Exception) {
                // Recursive Object
                }
                message += "\n" + arg + "\n";
            }
            // Textarea
            if (textarea) {
                textarea.value += message + "\n-----\n";
                textarea.scrollTop = textarea.scrollHeight - textarea.clientHeight;
            } else if (!consoleExists) alert(message);
            // Return true
            return true;
        };
        // ====================================================================
        // Emulated Status
        /**
		 * History.getInternetExplorerMajorVersion()
		 * Get's the major version of Internet Explorer
		 * @return {integer}
		 * @license Public Domain
		 * @author Benjamin Arthur Lupton <contact@balupton.com>
		 * @author James Padolsey <https://gist.github.com/527683>
		 */ History.getInternetExplorerMajorVersion = function() {
            var result = History.getInternetExplorerMajorVersion.cached = typeof History.getInternetExplorerMajorVersion.cached !== "undefined" ? History.getInternetExplorerMajorVersion.cached : function() {
                var v = 3, div = document.createElement("div"), all = div.getElementsByTagName("i");
                while(div.innerHTML = "<!--[if gt IE " + ++v + "]><i></i><![endif]-->", all[0]);
                return v > 4 ? v : false;
            }();
            return result;
        };
        /**
		 * History.isInternetExplorer()
		 * Are we using Internet Explorer?
		 * @return {boolean}
		 * @license Public Domain
		 * @author Benjamin Arthur Lupton <contact@balupton.com>
		 */ History.isInternetExplorer = function() {
            var result = History.isInternetExplorer.cached = typeof History.isInternetExplorer.cached !== "undefined" ? History.isInternetExplorer.cached : Boolean(History.getInternetExplorerMajorVersion());
            return result;
        };
        /**
		 * History.emulated
		 * Which features require emulating?
		 */ if (History.options.html4Mode) History.emulated = {
            pushState: true,
            hashChange: true
        };
        else History.emulated = {
            pushState: !Boolean(window1.history && window1.history.pushState && window1.history.replaceState && !(/ Mobile\/([1-7][a-z]|(8([abcde]|f(1[0-8]))))/i.test(navigator.userAgent) || /AppleWebKit\/5([0-2]|3[0-2])/i.test(navigator.userAgent))),
            hashChange: Boolean(!("onhashchange" in window1 || "onhashchange" in document) || History.isInternetExplorer() && History.getInternetExplorerMajorVersion() < 8)
        };
        /**
		 * History.enabled
		 * Is History enabled?
		 */ History.enabled = !History.emulated.pushState;
        /**
		 * History.bugs
		 * Which bugs are present
		 */ History.bugs = {
            /**
			 * Safari 5 and Safari iOS 4 fail to return to the correct state once a hash is replaced by a `replaceState` call
			 * https://bugs.webkit.org/show_bug.cgi?id=56249
			 */ setHash: Boolean(!History.emulated.pushState && navigator.vendor === "Apple Computer, Inc." && /AppleWebKit\/5([0-2]|3[0-3])/.test(navigator.userAgent)),
            /**
			 * Safari 5 and Safari iOS 4 sometimes fail to apply the state change under busy conditions
			 * https://bugs.webkit.org/show_bug.cgi?id=42940
			 */ safariPoll: Boolean(!History.emulated.pushState && navigator.vendor === "Apple Computer, Inc." && /AppleWebKit\/5([0-2]|3[0-3])/.test(navigator.userAgent)),
            /**
			 * MSIE 6 and 7 sometimes do not apply a hash even it was told to (requiring a second call to the apply function)
			 */ ieDoubleCheck: Boolean(History.isInternetExplorer() && History.getInternetExplorerMajorVersion() < 8),
            /**
			 * MSIE 6 requires the entire hash to be encoded for the hashes to trigger the onHashChange event
			 */ hashEscape: Boolean(History.isInternetExplorer() && History.getInternetExplorerMajorVersion() < 7)
        };
        /**
		 * History.isEmptyObject(obj)
		 * Checks to see if the Object is Empty
		 * @param {Object} obj
		 * @return {boolean}
		 */ History.isEmptyObject = function(obj) {
            for(var name in obj){
                if (obj.hasOwnProperty(name)) return false;
            }
            return true;
        };
        /**
		 * History.cloneObject(obj)
		 * Clones a object and eliminate all references to the original contexts
		 * @param {Object} obj
		 * @return {Object}
		 */ History.cloneObject = function(obj) {
            var hash, newObj;
            if (obj) {
                hash = JSON.stringify(obj);
                newObj = JSON.parse(hash);
            } else newObj = {};
            return newObj;
        };
        // ====================================================================
        // URL Helpers
        /**
		 * History.getRootUrl()
		 * Turns "http://mysite.com/dir/page.html?asd" into "http://mysite.com"
		 * @return {String} rootUrl
		 */ History.getRootUrl = function() {
            // Create
            var rootUrl = document.location.protocol + "//" + (document.location.hostname || document.location.host);
            if (document.location.port || false) rootUrl += ":" + document.location.port;
            rootUrl += "/";
            // Return
            return rootUrl;
        };
        /**
		 * History.getBaseHref()
		 * Fetches the `href` attribute of the `<base href="...">` element if it exists
		 * @return {String} baseHref
		 */ History.getBaseHref = function() {
            // Create
            var baseElements = document.getElementsByTagName("base"), baseElement = null, baseHref = "";
            // Test for Base Element
            if (baseElements.length === 1) {
                // Prepare for Base Element
                baseElement = baseElements[0];
                baseHref = baseElement.href.replace(/[^\/]+$/, "");
            }
            // Adjust trailing slash
            baseHref = baseHref.replace(/\/+$/, "");
            if (baseHref) baseHref += "/";
            // Return
            return baseHref;
        };
        /**
		 * History.getBaseUrl()
		 * Fetches the baseHref or basePageUrl or rootUrl (whichever one exists first)
		 * @return {String} baseUrl
		 */ History.getBaseUrl = function() {
            // Create
            var baseUrl = History.getBaseHref() || History.getBasePageUrl() || History.getRootUrl();
            // Return
            return baseUrl;
        };
        /**
		 * History.getPageUrl()
		 * Fetches the URL of the current page
		 * @return {String} pageUrl
		 */ History.getPageUrl = function() {
            // Fetch
            var State = History.getState(false, false), stateUrl = (State || {}).url || History.getLocationHref(), pageUrl;
            // Create
            pageUrl = stateUrl.replace(/\/+$/, "").replace(/[^\/]+$/, function(part, index, string) {
                return /\./.test(part) ? part : part + "/";
            });
            // Return
            return pageUrl;
        };
        /**
		 * History.getBasePageUrl()
		 * Fetches the Url of the directory of the current page
		 * @return {String} basePageUrl
		 */ History.getBasePageUrl = function() {
            // Create
            var basePageUrl = History.getLocationHref().replace(/[#\?].*/, "").replace(/[^\/]+$/, function(part, index, string) {
                return /[^\/]$/.test(part) ? "" : part;
            }).replace(/\/+$/, "") + "/";
            // Return
            return basePageUrl;
        };
        /**
		 * History.getFullUrl(url)
		 * Ensures that we have an absolute URL and not a relative URL
		 * @param {string} url
		 * @param {Boolean} allowBaseHref
		 * @return {string} fullUrl
		 */ History.getFullUrl = function(url, allowBaseHref) {
            // Prepare
            var fullUrl = url, firstChar = url.substring(0, 1);
            allowBaseHref = typeof allowBaseHref === "undefined" ? true : allowBaseHref;
            // Check
            if (/[a-z]+\:\/\//.test(url)) ;
            else if (firstChar === "/") // Root URL
            fullUrl = History.getRootUrl() + url.replace(/^\/+/, "");
            else if (firstChar === "#") // Anchor URL
            fullUrl = History.getPageUrl().replace(/#.*/, "") + url;
            else if (firstChar === "?") // Query URL
            fullUrl = History.getPageUrl().replace(/[\?#].*/, "") + url;
            else // Relative URL
            if (allowBaseHref) fullUrl = History.getBaseUrl() + url.replace(/^(\.\/)+/, "");
            else fullUrl = History.getBasePageUrl() + url.replace(/^(\.\/)+/, "");
            // Return
            return fullUrl.replace(/\#$/, "");
        };
        /**
		 * History.getShortUrl(url)
		 * Ensures that we have a relative URL and not a absolute URL
		 * @param {string} url
		 * @return {string} url
		 */ History.getShortUrl = function(url) {
            // Prepare
            var shortUrl = url, baseUrl = History.getBaseUrl(), rootUrl = History.getRootUrl();
            // Trim baseUrl
            if (History.emulated.pushState) // We are in a if statement as when pushState is not emulated
            // The actual url these short urls are relative to can change
            // So within the same session, we the url may end up somewhere different
            shortUrl = shortUrl.replace(baseUrl, "");
            // Trim rootUrl
            shortUrl = shortUrl.replace(rootUrl, "/");
            // Ensure we can still detect it as a state
            if (History.isTraditionalAnchor(shortUrl)) shortUrl = "./" + shortUrl;
            // Clean It
            shortUrl = shortUrl.replace(/^(\.\/)+/g, "./").replace(/\#$/, "");
            // Return
            return shortUrl;
        };
        /**
		 * History.getLocationHref(document)
		 * Returns a normalized version of document.location.href
		 * accounting for browser inconsistencies, etc.
		 *
		 * This URL will be URI-encoded and will include the hash
		 *
		 * @param {object} document
		 * @return {string} url
		 */ History.getLocationHref = function(doc) {
            doc = doc || document;
            // most of the time, this will be true
            if (doc.URL === doc.location.href) return doc.location.href;
            // some versions of webkit URI-decode document.location.href
            // but they leave document.URL in an encoded state
            if (doc.location.href === decodeURIComponent(doc.URL)) return doc.URL;
            // FF 3.6 only updates document.URL when a page is reloaded
            // document.location.href is updated correctly
            if (doc.location.hash && decodeURIComponent(doc.location.href.replace(/^[^#]+/, "")) === doc.location.hash) return doc.location.href;
            if (doc.URL.indexOf("#") == -1 && doc.location.href.indexOf("#") != -1) return doc.location.href;
            return doc.URL || doc.location.href;
        };
        // ====================================================================
        // State Storage
        /**
		 * History.store
		 * The store for all session specific data
		 */ History.store = {};
        /**
		 * History.idToState
		 * 1-1: State ID to State Object
		 */ History.idToState = History.idToState || {};
        /**
		 * History.stateToId
		 * 1-1: State String to State ID
		 */ History.stateToId = History.stateToId || {};
        /**
		 * History.urlToId
		 * 1-1: State URL to State ID
		 */ History.urlToId = History.urlToId || {};
        /**
		 * History.storedStates
		 * Store the states in an array
		 */ History.storedStates = History.storedStates || [];
        /**
		 * History.savedStates
		 * Saved the states in an array
		 */ History.savedStates = History.savedStates || [];
        /**
		 * History.noramlizeStore()
		 * Noramlize the store by adding necessary values
		 */ History.normalizeStore = function() {
            History.store.idToState = History.store.idToState || {};
            History.store.urlToId = History.store.urlToId || {};
            History.store.stateToId = History.store.stateToId || {};
        };
        /**
		 * History.getState()
		 * Get an object containing the data, title and url of the current state
		 * @param {Boolean} friendly
		 * @param {Boolean} create
		 * @return {Object} State
		 */ History.getState = function(friendly, create) {
            // Prepare
            if (typeof friendly === "undefined") friendly = true;
            if (typeof create === "undefined") create = true;
            // Fetch
            var State = History.getLastSavedState();
            // Create
            if (!State && create) State = History.createStateObject();
            // Adjust
            if (friendly) {
                State = History.cloneObject(State);
                State.url = State.cleanUrl || State.url;
            }
            // Return
            return State;
        };
        /**
		 * History.getIdByState(State)
		 * Gets a ID for a State
		 * @param {State} newState
		 * @return {String} id
		 */ History.getIdByState = function(newState) {
            // Fetch ID
            var id = History.extractId(newState.url), str;
            if (!id) {
                // Find ID via State String
                str = History.getStateString(newState);
                if (typeof History.stateToId[str] !== "undefined") id = History.stateToId[str];
                else if (typeof History.store.stateToId[str] !== "undefined") id = History.store.stateToId[str];
                else {
                    // Generate a new ID
                    while(true){
                        id = new Date().getTime() + String(Math.random()).replace(/\D/g, "");
                        if (typeof History.idToState[id] === "undefined" && typeof History.store.idToState[id] === "undefined") break;
                    }
                    // Apply the new State to the ID
                    History.stateToId[str] = id;
                    History.idToState[id] = newState;
                }
            }
            // Return ID
            return id;
        };
        /**
		 * History.normalizeState(State)
		 * Expands a State Object
		 * @param {object} State
		 * @return {object}
		 */ History.normalizeState = function(oldState) {
            // Variables
            var newState, dataNotEmpty;
            // Prepare
            if (!oldState || typeof oldState !== "object") oldState = {};
            // Check
            if (typeof oldState.normalized !== "undefined") return oldState;
            // Adjust
            if (!oldState.data || typeof oldState.data !== "object") oldState.data = {};
            // ----------------------------------------------------------------
            // Create
            newState = {};
            newState.normalized = true;
            newState.title = oldState.title || "";
            newState.url = History.getFullUrl(oldState.url ? oldState.url : History.getLocationHref());
            newState.hash = History.getShortUrl(newState.url);
            newState.data = History.cloneObject(oldState.data);
            // Fetch ID
            newState.id = History.getIdByState(newState);
            // ----------------------------------------------------------------
            // Clean the URL
            newState.cleanUrl = newState.url.replace(/\??\&_suid.*/, "");
            newState.url = newState.cleanUrl;
            // Check to see if we have more than just a url
            dataNotEmpty = !History.isEmptyObject(newState.data);
            // Apply
            if ((newState.title || dataNotEmpty) && History.options.disableSuid !== true) {
                // Add ID to Hash
                newState.hash = History.getShortUrl(newState.url).replace(/\??\&_suid.*/, "");
                if (!/\?/.test(newState.hash)) newState.hash += "?";
                newState.hash += "&_suid=" + newState.id;
            }
            // Create the Hashed URL
            newState.hashedUrl = History.getFullUrl(newState.hash);
            // ----------------------------------------------------------------
            // Update the URL if we have a duplicate
            if ((History.emulated.pushState || History.bugs.safariPoll) && History.hasUrlDuplicate(newState)) newState.url = newState.hashedUrl;
            // ----------------------------------------------------------------
            // Return
            return newState;
        };
        /**
		 * History.createStateObject(data,title,url)
		 * Creates a object based on the data, title and url state params
		 * @param {object} data
		 * @param {string} title
		 * @param {string} url
		 * @return {object}
		 */ History.createStateObject = function(data, title, url) {
            // Hashify
            var State = {
                "data": data,
                "title": title,
                "url": url
            };
            // Expand the State
            State = History.normalizeState(State);
            // Return object
            return State;
        };
        /**
		 * History.getStateById(id)
		 * Get a state by it's UID
		 * @param {String} id
		 */ History.getStateById = function(id) {
            // Prepare
            id = String(id);
            // Retrieve
            var State = History.idToState[id] || History.store.idToState[id] || undefined;
            // Return State
            return State;
        };
        /**
		 * Get a State's String
		 * @param {State} passedState
		 */ History.getStateString = function(passedState) {
            // Prepare
            var State, cleanedState, str;
            // Fetch
            State = History.normalizeState(passedState);
            // Clean
            cleanedState = {
                data: State.data,
                title: passedState.title,
                url: passedState.url
            };
            // Fetch
            str = JSON.stringify(cleanedState);
            // Return
            return str;
        };
        /**
		 * Get a State's ID
		 * @param {State} passedState
		 * @return {String} id
		 */ History.getStateId = function(passedState) {
            // Prepare
            var State, id;
            // Fetch
            State = History.normalizeState(passedState);
            // Fetch
            id = State.id;
            // Return
            return id;
        };
        /**
		 * History.getHashByState(State)
		 * Creates a Hash for the State Object
		 * @param {State} passedState
		 * @return {String} hash
		 */ History.getHashByState = function(passedState) {
            // Prepare
            var State, hash;
            // Fetch
            State = History.normalizeState(passedState);
            // Hash
            hash = State.hash;
            // Return
            return hash;
        };
        /**
		 * History.extractId(url_or_hash)
		 * Get a State ID by it's URL or Hash
		 * @param {string} url_or_hash
		 * @return {string} id
		 */ History.extractId = function(url_or_hash) {
            // Prepare
            var id, parts, url, tmp;
            // Extract
            // If the URL has a #, use the id from before the #
            if (url_or_hash.indexOf("#") != -1) tmp = url_or_hash.split("#")[0];
            else tmp = url_or_hash;
            parts = /(.*)\&_suid=([0-9]+)$/.exec(tmp);
            url = parts ? parts[1] || url_or_hash : url_or_hash;
            id = parts ? String(parts[2] || "") : "";
            // Return
            return id || false;
        };
        /**
		 * History.isTraditionalAnchor
		 * Checks to see if the url is a traditional anchor or not
		 * @param {String} url_or_hash
		 * @return {Boolean}
		 */ History.isTraditionalAnchor = function(url_or_hash) {
            // Check
            var isTraditional = !/[\/\?\.]/.test(url_or_hash);
            // Return
            return isTraditional;
        };
        /**
		 * History.extractState
		 * Get a State by it's URL or Hash
		 * @param {String} url_or_hash
		 * @return {State|null}
		 */ History.extractState = function(url_or_hash, create) {
            // Prepare
            var State = null, id, url;
            create = create || false;
            // Fetch SUID
            id = History.extractId(url_or_hash);
            if (id) State = History.getStateById(id);
            // Fetch SUID returned no State
            if (!State) {
                // Fetch URL
                url = History.getFullUrl(url_or_hash);
                // Check URL
                id = History.getIdByUrl(url) || false;
                if (id) State = History.getStateById(id);
                // Create State
                if (!State && create && !History.isTraditionalAnchor(url_or_hash)) State = History.createStateObject(null, null, url);
            }
            // Return
            return State;
        };
        /**
		 * History.getIdByUrl()
		 * Get a State ID by a State URL
		 */ History.getIdByUrl = function(url) {
            // Fetch
            var id = History.urlToId[url] || History.store.urlToId[url] || undefined;
            // Return
            return id;
        };
        /**
		 * History.getLastSavedState()
		 * Get an object containing the data, title and url of the current state
		 * @return {Object} State
		 */ History.getLastSavedState = function() {
            return History.savedStates[History.savedStates.length - 1] || undefined;
        };
        /**
		 * History.getLastStoredState()
		 * Get an object containing the data, title and url of the current state
		 * @return {Object} State
		 */ History.getLastStoredState = function() {
            return History.storedStates[History.storedStates.length - 1] || undefined;
        };
        /**
		 * History.hasUrlDuplicate
		 * Checks if a Url will have a url conflict
		 * @param {Object} newState
		 * @return {Boolean} hasDuplicate
		 */ History.hasUrlDuplicate = function(newState) {
            // Prepare
            var hasDuplicate = false, oldState;
            // Fetch
            oldState = History.extractState(newState.url);
            // Check
            hasDuplicate = oldState && oldState.id !== newState.id;
            // Return
            return hasDuplicate;
        };
        /**
		 * History.storeState
		 * Store a State
		 * @param {Object} newState
		 * @return {Object} newState
		 */ History.storeState = function(newState) {
            // Store the State
            History.urlToId[newState.url] = newState.id;
            // Push the State
            History.storedStates.push(History.cloneObject(newState));
            // Return newState
            return newState;
        };
        /**
		 * History.isLastSavedState(newState)
		 * Tests to see if the state is the last state
		 * @param {Object} newState
		 * @return {boolean} isLast
		 */ History.isLastSavedState = function(newState) {
            // Prepare
            var isLast = false, newId, oldState, oldId;
            // Check
            if (History.savedStates.length) {
                newId = newState.id;
                oldState = History.getLastSavedState();
                oldId = oldState.id;
                // Check
                isLast = newId === oldId;
            }
            // Return
            return isLast;
        };
        /**
		 * History.saveState
		 * Push a State
		 * @param {Object} newState
		 * @return {boolean} changed
		 */ History.saveState = function(newState) {
            // Check Hash
            if (History.isLastSavedState(newState)) return false;
            // Push the State
            History.savedStates.push(History.cloneObject(newState));
            // Return true
            return true;
        };
        /**
		 * History.getStateByIndex()
		 * Gets a state by the index
		 * @param {integer} index
		 * @return {Object}
		 */ History.getStateByIndex = function(index) {
            // Prepare
            var State = null;
            // Handle
            if (typeof index === "undefined") // Get the last inserted
            State = History.savedStates[History.savedStates.length - 1];
            else if (index < 0) // Get from the end
            State = History.savedStates[History.savedStates.length + index];
            else // Get from the beginning
            State = History.savedStates[index];
            // Return State
            return State;
        };
        /**
		 * History.getCurrentIndex()
		 * Gets the current index
		 * @return (integer)
		*/ History.getCurrentIndex = function() {
            // Prepare
            var index = null;
            // No states saved
            if (History.savedStates.length < 1) index = 0;
            else index = History.savedStates.length - 1;
            return index;
        };
        // ====================================================================
        // Hash Helpers
        /**
		 * History.getHash()
		 * @param {Location=} location
		 * Gets the current document hash
		 * Note: unlike location.hash, this is guaranteed to return the escaped hash in all browsers
		 * @return {string}
		 */ History.getHash = function(doc) {
            var url = History.getLocationHref(doc), hash;
            hash = History.getHashByUrl(url);
            return hash;
        };
        /**
		 * History.unescapeHash()
		 * normalize and Unescape a Hash
		 * @param {String} hash
		 * @return {string}
		 */ History.unescapeHash = function(hash) {
            // Prepare
            var result = History.normalizeHash(hash);
            // Unescape hash
            result = decodeURIComponent(result);
            // Return result
            return result;
        };
        /**
		 * History.normalizeHash()
		 * normalize a hash across browsers
		 * @return {string}
		 */ History.normalizeHash = function(hash) {
            // Prepare
            var result = hash.replace(/[^#]*#/, "").replace(/#.*/, "");
            // Return result
            return result;
        };
        /**
		 * History.setHash(hash)
		 * Sets the document hash
		 * @param {string} hash
		 * @return {History}
		 */ History.setHash = function(hash, queue) {
            // Prepare
            var State, pageUrl;
            // Handle Queueing
            if (queue !== false && History.busy()) {
                // Wait + Push to Queue
                //History.debug('History.setHash: we must wait', arguments);
                History.pushQueue({
                    scope: History,
                    callback: History.setHash,
                    args: arguments,
                    queue: queue
                });
                return false;
            }
            // Log
            //History.debug('History.setHash: called',hash);
            // Make Busy + Continue
            History.busy(true);
            // Check if hash is a state
            State = History.extractState(hash, true);
            if (State && !History.emulated.pushState) // Hash is a state so skip the setHash
            //History.debug('History.setHash: Hash is a state so skipping the hash set with a direct pushState call',arguments);
            // PushState
            History.pushState(State.data, State.title, State.url, false);
            else if (History.getHash() !== hash) {
                // Hash is a proper hash, so apply it
                // Handle browser bugs
                if (History.bugs.setHash) {
                    // Fix Safari Bug https://bugs.webkit.org/show_bug.cgi?id=56249
                    // Fetch the base page
                    pageUrl = History.getPageUrl();
                    // Safari hash apply
                    History.pushState(null, null, pageUrl + "#" + hash, false);
                } else // Normal hash apply
                document.location.hash = hash;
            }
            // Chain
            return History;
        };
        /**
		 * History.escape()
		 * normalize and Escape a Hash
		 * @return {string}
		 */ History.escapeHash = function(hash) {
            // Prepare
            var result = History.normalizeHash(hash);
            // Escape hash
            result = window1.encodeURIComponent(result);
            // IE6 Escape Bug
            if (!History.bugs.hashEscape) // Restore common parts
            result = result.replace(/\%21/g, "!").replace(/\%26/g, "&").replace(/\%3D/g, "=").replace(/\%3F/g, "?");
            // Return result
            return result;
        };
        /**
		 * History.getHashByUrl(url)
		 * Extracts the Hash from a URL
		 * @param {string} url
		 * @return {string} url
		 */ History.getHashByUrl = function(url) {
            // Extract the hash
            var hash = String(url).replace(/([^#]*)#?([^#]*)#?(.*)/, "$2");
            // Unescape hash
            hash = History.unescapeHash(hash);
            // Return hash
            return hash;
        };
        /**
		 * History.setTitle(title)
		 * Applies the title to the document
		 * @param {State} newState
		 * @return {Boolean}
		 */ History.setTitle = function(newState) {
            // Prepare
            var title = newState.title, firstState;
            // Initial
            if (!title) {
                firstState = History.getStateByIndex(0);
                if (firstState && firstState.url === newState.url) title = firstState.title || History.options.initialTitle;
            }
            // Apply
            try {
                document.getElementsByTagName("title")[0].innerHTML = title.replace("<", "&lt;").replace(">", "&gt;").replace(" & ", " &amp; ");
            } catch (Exception) {}
            document.title = title;
            // Chain
            return History;
        };
        // ====================================================================
        // Queueing
        /**
		 * History.queues
		 * The list of queues to use
		 * First In, First Out
		 */ History.queues = [];
        /**
		 * History.busy(value)
		 * @param {boolean} value [optional]
		 * @return {boolean} busy
		 */ History.busy = function(value) {
            // Apply
            if (typeof value !== "undefined") //History.debug('History.busy: changing ['+(History.busy.flag||false)+'] to ['+(value||false)+']', History.queues.length);
            History.busy.flag = value;
            else if (typeof History.busy.flag === "undefined") History.busy.flag = false;
            // Queue
            if (!History.busy.flag) {
                // Execute the next item in the queue
                clearTimeout(History.busy.timeout);
                var fireNext = function() {
                    var i, queue, item;
                    if (History.busy.flag) return;
                    for(i = History.queues.length - 1; i >= 0; --i){
                        queue = History.queues[i];
                        if (queue.length === 0) continue;
                        item = queue.shift();
                        History.fireQueueItem(item);
                        History.busy.timeout = setTimeout(fireNext, History.options.busyDelay);
                    }
                };
                History.busy.timeout = setTimeout(fireNext, History.options.busyDelay);
            }
            // Return
            return History.busy.flag;
        };
        /**
		 * History.busy.flag
		 */ History.busy.flag = false;
        /**
		 * History.fireQueueItem(item)
		 * Fire a Queue Item
		 * @param {Object} item
		 * @return {Mixed} result
		 */ History.fireQueueItem = function(item) {
            return item.callback.apply(item.scope || History, item.args || []);
        };
        /**
		 * History.pushQueue(callback,args)
		 * Add an item to the queue
		 * @param {Object} item [scope,callback,args,queue]
		 */ History.pushQueue = function(item) {
            // Prepare the queue
            History.queues[item.queue || 0] = History.queues[item.queue || 0] || [];
            // Add to the queue
            History.queues[item.queue || 0].push(item);
            // Chain
            return History;
        };
        /**
		 * History.queue (item,queue), (func,queue), (func), (item)
		 * Either firs the item now if not busy, or adds it to the queue
		 */ History.queue = function(item, queue) {
            // Prepare
            if (typeof item === "function") item = {
                callback: item
            };
            if (typeof queue !== "undefined") item.queue = queue;
            // Handle
            if (History.busy()) History.pushQueue(item);
            else History.fireQueueItem(item);
            // Chain
            return History;
        };
        /**
		 * History.clearQueue()
		 * Clears the Queue
		 */ History.clearQueue = function() {
            History.busy.flag = false;
            History.queues = [];
            return History;
        };
        // ====================================================================
        // IE Bug Fix
        /**
		 * History.stateChanged
		 * States whether or not the state has changed since the last double check was initialised
		 */ History.stateChanged = false;
        /**
		 * History.doubleChecker
		 * Contains the timeout used for the double checks
		 */ History.doubleChecker = false;
        /**
		 * History.doubleCheckComplete()
		 * Complete a double check
		 * @return {History}
		 */ History.doubleCheckComplete = function() {
            // Update
            History.stateChanged = true;
            // Clear
            History.doubleCheckClear();
            // Chain
            return History;
        };
        /**
		 * History.doubleCheckClear()
		 * Clear a double check
		 * @return {History}
		 */ History.doubleCheckClear = function() {
            // Clear
            if (History.doubleChecker) {
                clearTimeout(History.doubleChecker);
                History.doubleChecker = false;
            }
            // Chain
            return History;
        };
        /**
		 * History.doubleCheck()
		 * Create a double check
		 * @return {History}
		 */ History.doubleCheck = function(tryAgain) {
            // Reset
            History.stateChanged = false;
            History.doubleCheckClear();
            // Fix IE6,IE7 bug where calling history.back or history.forward does not actually change the hash (whereas doing it manually does)
            // Fix Safari 5 bug where sometimes the state does not change: https://bugs.webkit.org/show_bug.cgi?id=42940
            if (History.bugs.ieDoubleCheck) // Apply Check
            History.doubleChecker = setTimeout(function() {
                History.doubleCheckClear();
                if (!History.stateChanged) //History.debug('History.doubleCheck: State has not yet changed, trying again', arguments);
                // Re-Attempt
                tryAgain();
                return true;
            }, History.options.doubleCheckInterval);
            // Chain
            return History;
        };
        // ====================================================================
        // Safari Bug Fix
        /**
		 * History.safariStatePoll()
		 * Poll the current state
		 * @return {History}
		 */ History.safariStatePoll = function() {
            // Poll the URL
            // Get the Last State which has the new URL
            var urlState = History.extractState(History.getLocationHref()), newState;
            // Check for a difference
            if (!History.isLastSavedState(urlState)) newState = urlState;
            else return;
            // Check if we have a state with that url
            // If not create it
            if (!newState) //History.debug('History.safariStatePoll: new');
            newState = History.createStateObject();
            // Apply the New State
            //History.debug('History.safariStatePoll: trigger');
            History.Adapter.trigger(window1, "popstate");
            // Chain
            return History;
        };
        // ====================================================================
        // State Aliases
        /**
		 * History.back(queue)
		 * Send the browser history back one item
		 * @param {Integer} queue [optional]
		 */ History.back = function(queue) {
            //History.debug('History.back: called', arguments);
            // Handle Queueing
            if (queue !== false && History.busy()) {
                // Wait + Push to Queue
                //History.debug('History.back: we must wait', arguments);
                History.pushQueue({
                    scope: History,
                    callback: History.back,
                    args: arguments,
                    queue: queue
                });
                return false;
            }
            // Make Busy + Continue
            History.busy(true);
            // Fix certain browser bugs that prevent the state from changing
            History.doubleCheck(function() {
                History.back(false);
            });
            // Go back
            history.go(-1);
            // End back closure
            return true;
        };
        /**
		 * History.forward(queue)
		 * Send the browser history forward one item
		 * @param {Integer} queue [optional]
		 */ History.forward = function(queue) {
            //History.debug('History.forward: called', arguments);
            // Handle Queueing
            if (queue !== false && History.busy()) {
                // Wait + Push to Queue
                //History.debug('History.forward: we must wait', arguments);
                History.pushQueue({
                    scope: History,
                    callback: History.forward,
                    args: arguments,
                    queue: queue
                });
                return false;
            }
            // Make Busy + Continue
            History.busy(true);
            // Fix certain browser bugs that prevent the state from changing
            History.doubleCheck(function() {
                History.forward(false);
            });
            // Go forward
            history.go(1);
            // End forward closure
            return true;
        };
        /**
		 * History.go(index,queue)
		 * Send the browser history back or forward index times
		 * @param {Integer} queue [optional]
		 */ History.go = function(index, queue) {
            //History.debug('History.go: called', arguments);
            // Prepare
            var i;
            // Handle
            if (index > 0) // Forward
            for(i = 1; i <= index; ++i)History.forward(queue);
            else if (index < 0) // Backward
            for(i = -1; i >= index; --i)History.back(queue);
            else throw new Error("History.go: History.go requires a positive or negative integer passed.");
            // Chain
            return History;
        };
        // ====================================================================
        // HTML5 State Support
        // Non-Native pushState Implementation
        if (History.emulated.pushState) {
            /*
			 * Provide Skeleton for HTML4 Browsers
			 */ // Prepare
            var emptyFunction = function() {};
            History.pushState = History.pushState || emptyFunction;
            History.replaceState = History.replaceState || emptyFunction;
        } else {
            /*
			 * Use native HTML5 History API Implementation
			 */ /**
			 * History.onPopState(event,extra)
			 * Refresh the Current State
			 */ History.onPopState = function(event, extra) {
                // Prepare
                var stateId = false, newState = false, currentHash, currentState;
                // Reset the double check
                History.doubleCheckComplete();
                // Check for a Hash, and handle apporiatly
                currentHash = History.getHash();
                if (currentHash) {
                    // Expand Hash
                    currentState = History.extractState(currentHash || History.getLocationHref(), true);
                    if (currentState) // We were able to parse it, it must be a State!
                    // Let's forward to replaceState
                    //History.debug('History.onPopState: state anchor', currentHash, currentState);
                    History.replaceState(currentState.data, currentState.title, currentState.url, false);
                    else {
                        // Traditional Anchor
                        //History.debug('History.onPopState: traditional anchor', currentHash);
                        History.Adapter.trigger(window1, "anchorchange");
                        History.busy(false);
                    }
                    // We don't care for hashes
                    History.expectedStateId = false;
                    return false;
                }
                // Ensure
                stateId = History.Adapter.extractEventData("state", event, extra) || false;
                // Fetch State
                if (stateId) // Vanilla: Back/forward button was used
                newState = History.getStateById(stateId);
                else if (History.expectedStateId) // Vanilla: A new state was pushed, and popstate was called manually
                newState = History.getStateById(History.expectedStateId);
                else // Initial State
                newState = History.extractState(History.getLocationHref());
                // The State did not exist in our store
                if (!newState) // Regenerate the State
                newState = History.createStateObject(null, null, History.getLocationHref());
                // Clean
                History.expectedStateId = false;
                // Check if we are the same state
                if (History.isLastSavedState(newState)) {
                    // There has been no change (just the page's hash has finally propagated)
                    //History.debug('History.onPopState: no change', newState, History.savedStates);
                    History.busy(false);
                    return false;
                }
                // Store the State
                History.storeState(newState);
                History.saveState(newState);
                // Force update of the title
                History.setTitle(newState);
                // Fire Our Event
                History.Adapter.trigger(window1, "statechange");
                History.busy(false);
                // Return true
                return true;
            };
            History.Adapter.bind(window1, "popstate", History.onPopState);
            /**
			 * History.pushState(data,title,url)
			 * Add a new State to the history object, become it, and trigger onpopstate
			 * We have to trigger for HTML4 compatibility
			 * @param {object} data
			 * @param {string} title
			 * @param {string} url
			 * @return {true}
			 */ History.pushState = function(data, title, url, queue) {
                //History.debug('History.pushState: called', arguments);
                // Check the State
                if (History.getHashByUrl(url) && History.emulated.pushState) throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).");
                // Handle Queueing
                if (queue !== false && History.busy()) {
                    // Wait + Push to Queue
                    //History.debug('History.pushState: we must wait', arguments);
                    History.pushQueue({
                        scope: History,
                        callback: History.pushState,
                        args: arguments,
                        queue: queue
                    });
                    return false;
                }
                // Make Busy + Continue
                History.busy(true);
                // Create the newState
                var newState = History.createStateObject(data, title, url);
                // Check it
                if (History.isLastSavedState(newState)) // Won't be a change
                History.busy(false);
                else {
                    // Store the newState
                    History.storeState(newState);
                    History.expectedStateId = newState.id;
                    // Push the newState
                    history.pushState(newState.id, newState.title, newState.url);
                    // Fire HTML5 Event
                    History.Adapter.trigger(window1, "popstate");
                }
                // End pushState closure
                return true;
            };
            /**
			 * History.replaceState(data,title,url)
			 * Replace the State and trigger onpopstate
			 * We have to trigger for HTML4 compatibility
			 * @param {object} data
			 * @param {string} title
			 * @param {string} url
			 * @return {true}
			 */ History.replaceState = function(data, title, url, queue) {
                //History.debug('History.replaceState: called', arguments);
                // Check the State
                if (History.getHashByUrl(url) && History.emulated.pushState) throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).");
                // Handle Queueing
                if (queue !== false && History.busy()) {
                    // Wait + Push to Queue
                    //History.debug('History.replaceState: we must wait', arguments);
                    History.pushQueue({
                        scope: History,
                        callback: History.replaceState,
                        args: arguments,
                        queue: queue
                    });
                    return false;
                }
                // Make Busy + Continue
                History.busy(true);
                // Create the newState
                var newState = History.createStateObject(data, title, url);
                // Check it
                if (History.isLastSavedState(newState)) // Won't be a change
                History.busy(false);
                else {
                    // Store the newState
                    History.storeState(newState);
                    History.expectedStateId = newState.id;
                    // Push the newState
                    history.replaceState(newState.id, newState.title, newState.url);
                    // Fire HTML5 Event
                    History.Adapter.trigger(window1, "popstate");
                }
                // End replaceState closure
                return true;
            };
        } // !History.emulated.pushState
        // ====================================================================
        // Initialise
        /**
		 * Load the Store
		 */ if (sessionStorage) {
            // Fetch
            try {
                History.store = JSON.parse(sessionStorage.getItem("History.store")) || {};
            } catch (err) {
                History.store = {};
            }
            // Normalize
            History.normalizeStore();
        } else {
            // Default Load
            History.store = {};
            History.normalizeStore();
        }
        /**
		 * Clear Intervals on exit to prevent memory leaks
		 */ History.Adapter.bind(window1, "unload", History.clearAllIntervals);
        /**
		 * Create the initial State
		 */ History.saveState(History.storeState(History.extractState(History.getLocationHref(), true)));
        /**
		 * Bind for Saving Store
		 */ if (sessionStorage) {
            // When the page is closed
            History.onUnload = function() {
                // Prepare
                var currentStore, item, currentStoreString;
                // Fetch
                try {
                    currentStore = JSON.parse(sessionStorage.getItem("History.store")) || {};
                } catch (err) {
                    currentStore = {};
                }
                // Ensure
                currentStore.idToState = currentStore.idToState || {};
                currentStore.urlToId = currentStore.urlToId || {};
                currentStore.stateToId = currentStore.stateToId || {};
                // Sync
                for(item in History.idToState){
                    if (!History.idToState.hasOwnProperty(item)) continue;
                    currentStore.idToState[item] = History.idToState[item];
                }
                for(item in History.urlToId){
                    if (!History.urlToId.hasOwnProperty(item)) continue;
                    currentStore.urlToId[item] = History.urlToId[item];
                }
                for(item in History.stateToId){
                    if (!History.stateToId.hasOwnProperty(item)) continue;
                    currentStore.stateToId[item] = History.stateToId[item];
                }
                // Update
                History.store = currentStore;
                History.normalizeStore();
                // In Safari, going into Private Browsing mode causes the
                // Session Storage object to still exist but if you try and use
                // or set any property/function of it it throws the exception
                // "QUOTA_EXCEEDED_ERR: DOM Exception 22: An attempt was made to
                // add something to storage that exceeded the quota." infinitely
                // every second.
                currentStoreString = JSON.stringify(currentStore);
                try {
                    // Store
                    sessionStorage.setItem("History.store", currentStoreString);
                } catch (e) {
                    if (e.code === DOMException.QUOTA_EXCEEDED_ERR) {
                        if (sessionStorage.length) {
                            // Workaround for a bug seen on iPads. Sometimes the quota exceeded error comes up and simply
                            // removing/resetting the storage can work.
                            sessionStorage.removeItem("History.store");
                            sessionStorage.setItem("History.store", currentStoreString);
                        }
                    // Otherwise, we're probably private browsing in Safari, so we'll ignore the exception.
                    } else throw e;
                }
            };
            // For Internet Explorer
            History.intervalList.push(setInterval(History.onUnload, History.options.storeInterval));
            // For Other Browsers
            History.Adapter.bind(window1, "beforeunload", History.onUnload);
            History.Adapter.bind(window1, "unload", History.onUnload);
        // Both are enabled for consistency
        }
        // Non-Native pushState Implementation
        if (!History.emulated.pushState) {
            // Be aware, the following is only for native pushState implementations
            // If you are wanting to include something for all browsers
            // Then include it above this if block
            /**
			 * Setup Safari Fix
			 */ if (History.bugs.safariPoll) History.intervalList.push(setInterval(History.safariStatePoll, History.options.safariPollInterval));
            /**
			 * Ensure Cross Browser Compatibility
			 */ if (navigator.vendor === "Apple Computer, Inc." || (navigator.appCodeName || "") === "Mozilla") {
                /**
				 * Fix Safari HashChange Issue
				 */ // Setup Alias
                History.Adapter.bind(window1, "hashchange", function() {
                    History.Adapter.trigger(window1, "popstate");
                });
                // Initialise Alias
                if (History.getHash()) History.Adapter.onDomLoad(function() {
                    History.Adapter.trigger(window1, "hashchange");
                });
            }
        } // !History.emulated.pushState
    }; // History.initCore
    // Try to Initialise History
    if (!History.options || !History.options.delayInit) History.init();
})(window);


/**
 * @preserve
 * Sharer.js
 *
 * @description Create your own social share buttons
 * @version 0.5.1
 * @author Ellison Leao <ellisonleao@gmail.com>
 * @license MIT
 *
 */ (function(window1, document1) {
    "use strict";
    /**
   * @constructor
   */ var Sharer = function(elem) {
        this.elem = elem;
    };
    /**
   *  @function init
   *  @description bind the events for multiple sharer elements
   *  @returns {Empty}
   */ Sharer.init = function() {
        var elems = document1.querySelectorAll("[data-sharer]"), i, l = elems.length;
        for(i = 0; i < l; i++)elems[i].addEventListener("click", Sharer.add);
    };
    /**
   *  @function add
   *  @description bind the share event for a single dom element
   *  @returns {Empty}
   */ Sharer.add = function(elem) {
        var target = elem.currentTarget || elem.srcElement;
        var sharer = new Sharer(target);
        sharer.share();
    };
    // instance methods
    Sharer.prototype = {
        constructor: Sharer,
        /**
     *  @function getValue
     *  @description Helper to get the attribute of a DOM element
     *  @param {String} attr DOM element attribute
     *  @returns {String|Empty} returns the attr value or empty string
     */ getValue: function(attr) {
            var val = this.elem.getAttribute("data-" + attr);
            // handing facebook hashtag attribute
            if (val && attr === "hashtag") {
                if (!val.startsWith("#")) val = "#" + val;
            }
            return val === null ? "" : val;
        },
        /**
     * @event share
     * @description Main share event. Will pop a window or redirect to a link
     * based on the data-sharer attribute.
     */ share: function() {
            var sharer = this.getValue("sharer").toLowerCase(), sharers = {
                facebook: {
                    shareUrl: "https://www.facebook.com/sharer/sharer.php",
                    params: {
                        u: this.getValue("url"),
                        hashtag: this.getValue("hashtag"),
                        quote: this.getValue("quote")
                    }
                },
                linkedin: {
                    shareUrl: "https://www.linkedin.com/shareArticle",
                    params: {
                        url: this.getValue("url"),
                        mini: true
                    }
                },
                twitter: {
                    shareUrl: "https://twitter.com/intent/tweet/",
                    params: {
                        text: this.getValue("title"),
                        url: this.getValue("url"),
                        hashtags: this.getValue("hashtags"),
                        via: this.getValue("via")
                    }
                },
                email: {
                    shareUrl: "mailto:" + this.getValue("to"),
                    params: {
                        subject: this.getValue("subject"),
                        body: this.getValue("title") + "\n" + this.getValue("url")
                    }
                },
                whatsapp: {
                    shareUrl: this.getValue("web") === "true" ? "https://web.whatsapp.com/send" : "https://wa.me/",
                    params: {
                        phone: this.getValue("to"),
                        text: this.getValue("title") + " " + this.getValue("url")
                    }
                },
                telegram: {
                    shareUrl: "https://t.me/share",
                    params: {
                        text: this.getValue("title"),
                        url: this.getValue("url")
                    }
                },
                viber: {
                    shareUrl: "viber://forward",
                    params: {
                        text: this.getValue("title") + " " + this.getValue("url")
                    }
                },
                line: {
                    shareUrl: "http://line.me/R/msg/text/?" + encodeURIComponent(this.getValue("title") + " " + this.getValue("url"))
                },
                pinterest: {
                    shareUrl: "https://www.pinterest.com/pin/create/button/",
                    params: {
                        url: this.getValue("url"),
                        media: this.getValue("image"),
                        description: this.getValue("description")
                    }
                },
                tumblr: {
                    shareUrl: "http://tumblr.com/widgets/share/tool",
                    params: {
                        canonicalUrl: this.getValue("url"),
                        content: this.getValue("url"),
                        posttype: "link",
                        title: this.getValue("title"),
                        caption: this.getValue("caption"),
                        tags: this.getValue("tags")
                    }
                },
                hackernews: {
                    shareUrl: "https://news.ycombinator.com/submitlink",
                    params: {
                        u: this.getValue("url"),
                        t: this.getValue("title")
                    }
                },
                reddit: {
                    shareUrl: "https://www.reddit.com/submit",
                    params: {
                        url: this.getValue("url"),
                        title: this.getValue("title")
                    }
                },
                vk: {
                    shareUrl: "http://vk.com/share.php",
                    params: {
                        url: this.getValue("url"),
                        title: this.getValue("title"),
                        description: this.getValue("caption"),
                        image: this.getValue("image")
                    }
                },
                xing: {
                    shareUrl: "https://www.xing.com/social/share/spi",
                    params: {
                        url: this.getValue("url")
                    }
                },
                buffer: {
                    shareUrl: "https://buffer.com/add",
                    params: {
                        url: this.getValue("url"),
                        title: this.getValue("title"),
                        via: this.getValue("via"),
                        picture: this.getValue("picture")
                    }
                },
                instapaper: {
                    shareUrl: "http://www.instapaper.com/edit",
                    params: {
                        url: this.getValue("url"),
                        title: this.getValue("title"),
                        description: this.getValue("description")
                    }
                },
                pocket: {
                    shareUrl: "https://getpocket.com/save",
                    params: {
                        url: this.getValue("url")
                    }
                },
                mashable: {
                    shareUrl: "https://mashable.com/submit",
                    params: {
                        url: this.getValue("url"),
                        title: this.getValue("title")
                    }
                },
                mix: {
                    shareUrl: "https://mix.com/add",
                    params: {
                        url: this.getValue("url")
                    }
                },
                flipboard: {
                    shareUrl: "https://share.flipboard.com/bookmarklet/popout",
                    params: {
                        v: 2,
                        title: this.getValue("title"),
                        url: this.getValue("url"),
                        t: Date.now()
                    }
                },
                weibo: {
                    shareUrl: "http://service.weibo.com/share/share.php",
                    params: {
                        url: this.getValue("url"),
                        title: this.getValue("title"),
                        pic: this.getValue("image"),
                        appkey: this.getValue("appkey"),
                        ralateUid: this.getValue("ralateuid"),
                        language: "zh_cn"
                    }
                },
                blogger: {
                    shareUrl: "https://www.blogger.com/blog-this.g",
                    params: {
                        u: this.getValue("url"),
                        n: this.getValue("title"),
                        t: this.getValue("description")
                    }
                },
                baidu: {
                    shareUrl: "http://cang.baidu.com/do/add",
                    params: {
                        it: this.getValue("title"),
                        iu: this.getValue("url")
                    }
                },
                douban: {
                    shareUrl: "https://www.douban.com/share/service",
                    params: {
                        name: this.getValue("name"),
                        href: this.getValue("url"),
                        image: this.getValue("image"),
                        comment: this.getValue("description")
                    }
                },
                okru: {
                    shareUrl: "https://connect.ok.ru/dk",
                    params: {
                        "st.cmd": "WidgetSharePreview",
                        "st.shareUrl": this.getValue("url"),
                        title: this.getValue("title")
                    }
                },
                mailru: {
                    shareUrl: "http://connect.mail.ru/share",
                    params: {
                        share_url: this.getValue("url"),
                        linkname: this.getValue("title"),
                        linknote: this.getValue("description"),
                        type: "page"
                    }
                },
                evernote: {
                    shareUrl: "https://www.evernote.com/clip.action",
                    params: {
                        url: this.getValue("url"),
                        title: this.getValue("title")
                    }
                },
                skype: {
                    shareUrl: "https://web.skype.com/share",
                    params: {
                        url: this.getValue("url"),
                        title: this.getValue("title")
                    }
                },
                delicious: {
                    shareUrl: "https://del.icio.us/post",
                    params: {
                        url: this.getValue("url"),
                        title: this.getValue("title")
                    }
                },
                sms: {
                    shareUrl: "sms://",
                    params: {
                        body: this.getValue("body")
                    }
                },
                trello: {
                    shareUrl: "https://trello.com/add-card",
                    params: {
                        url: this.getValue("url"),
                        name: this.getValue("title"),
                        desc: this.getValue("description"),
                        mode: "popup"
                    }
                },
                messenger: {
                    shareUrl: "fb-messenger://share",
                    params: {
                        link: this.getValue("url")
                    }
                },
                odnoklassniki: {
                    shareUrl: "https://connect.ok.ru/dk",
                    params: {
                        st: {
                            cmd: "WidgetSharePreview",
                            deprecated: 1,
                            shareUrl: this.getValue("url")
                        }
                    }
                },
                meneame: {
                    shareUrl: "https://www.meneame.net/submit",
                    params: {
                        url: this.getValue("url")
                    }
                },
                diaspora: {
                    shareUrl: "https://share.diasporafoundation.org",
                    params: {
                        title: this.getValue("title"),
                        url: this.getValue("url")
                    }
                },
                googlebookmarks: {
                    shareUrl: "https://www.google.com/bookmarks/mark",
                    params: {
                        op: "edit",
                        bkmk: this.getValue("url"),
                        title: this.getValue("title")
                    }
                },
                qzone: {
                    shareUrl: "https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey",
                    params: {
                        url: this.getValue("url")
                    }
                },
                refind: {
                    shareUrl: "https://refind.com",
                    params: {
                        url: this.getValue("url")
                    }
                },
                surfingbird: {
                    shareUrl: "https://surfingbird.ru/share",
                    params: {
                        url: this.getValue("url"),
                        title: this.getValue("title"),
                        description: this.getValue("description")
                    }
                },
                yahoomail: {
                    shareUrl: "http://compose.mail.yahoo.com",
                    params: {
                        to: this.getValue("to"),
                        subject: this.getValue("subject"),
                        body: this.getValue("body")
                    }
                },
                wordpress: {
                    shareUrl: "https://wordpress.com/wp-admin/press-this.php",
                    params: {
                        u: this.getValue("url"),
                        t: this.getValue("title"),
                        s: this.getValue("title")
                    }
                },
                amazon: {
                    shareUrl: "https://www.amazon.com/gp/wishlist/static-add",
                    params: {
                        u: this.getValue("url"),
                        t: this.getValue("title")
                    }
                },
                pinboard: {
                    shareUrl: "https://pinboard.in/add",
                    params: {
                        url: this.getValue("url"),
                        title: this.getValue("title"),
                        description: this.getValue("description")
                    }
                },
                threema: {
                    shareUrl: "threema://compose",
                    params: {
                        text: this.getValue("text"),
                        id: this.getValue("id")
                    }
                },
                kakaostory: {
                    shareUrl: "https://story.kakao.com/share",
                    params: {
                        url: this.getValue("url")
                    }
                },
                yummly: {
                    shareUrl: "http://www.yummly.com/urb/verify",
                    params: {
                        url: this.getValue("url"),
                        title: this.getValue("title"),
                        yumtype: "button"
                    }
                }
            }, s = sharers[sharer];
            // custom popups sizes
            if (s) {
                s.width = this.getValue("width");
                s.height = this.getValue("height");
            }
            return s !== undefined ? this.urlSharer(s) : false;
        },
        /**
     * @event urlSharer
     * @param {Object} sharer
     */ urlSharer: function(sharer) {
            var p = sharer.params || {}, keys = Object.keys(p), i, str = keys.length > 0 ? "?" : "";
            for(i = 0; i < keys.length; i++){
                if (str !== "?") str += "&";
                if (p[keys[i]]) str += keys[i] + "=" + encodeURIComponent(p[keys[i]]);
            }
            sharer.shareUrl += str;
            var isLink = this.getValue("link") === "true";
            var isBlank = this.getValue("blank") === "true";
            if (isLink) {
                if (isBlank) window1.open(sharer.shareUrl, "_blank");
                else window1.location.href = sharer.shareUrl;
            } else {
                console.log(sharer.shareUrl);
                // defaults to popup if no data-link is provided
                var popWidth = sharer.width || 600, popHeight = sharer.height || 480, left = window1.innerWidth / 2 - popWidth / 2 + window1.screenX, top = window1.innerHeight / 2 - popHeight / 2 + window1.screenY, popParams = "scrollbars=no, width=" + popWidth + ", height=" + popHeight + ", top=" + top + ", left=" + left, newWindow = window1.open(sharer.shareUrl, "", popParams);
                if (window1.focus) newWindow.focus();
            }
        }
    };
    // adding sharer events on domcontentload
    if (document1.readyState === "complete" || document1.readyState !== "loading") Sharer.init();
    else document1.addEventListener("DOMContentLoaded", Sharer.init);
    // exporting sharer for external usage
    window1.Sharer = Sharer;
})(window, document);


var $7b22250fbed98fb8$exports = {};
!function(e, t) {
    $7b22250fbed98fb8$exports = t();
}($7b22250fbed98fb8$exports, function() {
    "use strict";
    function e(t) {
        return (e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(t);
    }
    function t(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
        for(var i = 0; i < t.length; i++){
            var n = t[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
    }
    function n(e, t, n) {
        return t && i(e.prototype, t), n && i(e, n), e;
    }
    var s = Date.now();
    function l() {
        var e = {}, t = !0, i = 0, n = arguments.length;
        "[object Boolean]" === Object.prototype.toString.call(arguments[0]) && (t = arguments[0], i++);
        for(var s = function(i) {
            for(var n in i)Object.prototype.hasOwnProperty.call(i, n) && (t && "[object Object]" === Object.prototype.toString.call(i[n]) ? e[n] = l(!0, e[n], i[n]) : e[n] = i[n]);
        }; i < n; i++){
            var o = arguments[i];
            s(o);
        }
        return e;
    }
    function o(e, t) {
        if ((k(e) || e === window || e === document) && (e = [
            e
        ]), A(e) || L(e) || (e = [
            e
        ]), 0 != P(e)) {
            if (A(e) && !L(e)) for(var i = e.length, n = 0; n < i && !1 !== t.call(e[n], e[n], n, e); n++);
            else if (L(e)) {
                for(var s in e)if (O(e, s) && !1 === t.call(e[s], e[s], s, e)) break;
            }
        }
    }
    function r(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, n = e[s] = e[s] || [], l = {
            all: n,
            evt: null,
            found: null
        };
        return t && i && P(n) > 0 && o(n, function(e, n) {
            if (e.eventName == t && e.fn.toString() == i.toString()) return l.found = !0, l.evt = n, !1;
        }), l;
    }
    function a(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, i = t.onElement, n = t.withCallback, s = t.avoidDuplicate, l = void 0 === s || s, a = t.once, h = void 0 !== a && a, d = t.useCapture, c = void 0 !== d && d, u = arguments.length > 2 ? arguments[2] : void 0, g = i || [];
        function v(e) {
            T(n) && n.call(u, e, this), h && v.destroy();
        }
        return C(g) && (g = document.querySelectorAll(g)), v.destroy = function() {
            o(g, function(t) {
                var i = r(t, e, v);
                i.found && i.all.splice(i.evt, 1), t.removeEventListener && t.removeEventListener(e, v, c);
            });
        }, o(g, function(t) {
            var i = r(t, e, v);
            (t.addEventListener && l && !i.found || !l) && (t.addEventListener(e, v, c), i.all.push({
                eventName: e,
                fn: v
            }));
        }), v;
    }
    function h(e, t) {
        o(t.split(" "), function(t) {
            return e.classList.add(t);
        });
    }
    function d(e, t) {
        o(t.split(" "), function(t) {
            return e.classList.remove(t);
        });
    }
    function c(e, t) {
        return e.classList.contains(t);
    }
    function u(e, t) {
        for(; e !== document.body;){
            if (!(e = e.parentElement)) return !1;
            if ("function" == typeof e.matches ? e.matches(t) : e.msMatchesSelector(t)) return e;
        }
    }
    function g(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "", i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
        if (!e || "" === t) return !1;
        if ("none" === t) return T(i) && i(), !1;
        var n = x(), s = t.split(" ");
        o(s, function(t) {
            h(e, "g" + t);
        }), a(n, {
            onElement: e,
            avoidDuplicate: !1,
            once: !0,
            withCallback: function(e, t) {
                o(s, function(e) {
                    d(t, "g" + e);
                }), T(i) && i();
            }
        });
    }
    function v(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
        if ("" === t) return e.style.webkitTransform = "", e.style.MozTransform = "", e.style.msTransform = "", e.style.OTransform = "", e.style.transform = "", !1;
        e.style.webkitTransform = t, e.style.MozTransform = t, e.style.msTransform = t, e.style.OTransform = t, e.style.transform = t;
    }
    function f(e) {
        e.style.display = "block";
    }
    function p(e) {
        e.style.display = "none";
    }
    function m(e) {
        var t = document.createDocumentFragment(), i = document.createElement("div");
        for(i.innerHTML = e; i.firstChild;)t.appendChild(i.firstChild);
        return t;
    }
    function y() {
        return {
            width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        };
    }
    function x() {
        var e, t = document.createElement("fakeelement"), i = {
            animation: "animationend",
            OAnimation: "oAnimationEnd",
            MozAnimation: "animationend",
            WebkitAnimation: "webkitAnimationEnd"
        };
        for(e in i)if (void 0 !== t.style[e]) return i[e];
    }
    function b(e, t, i, n) {
        if (e()) t();
        else {
            var s;
            i || (i = 100);
            var l = setInterval(function() {
                e() && (clearInterval(l), s && clearTimeout(s), t());
            }, i);
            n && (s = setTimeout(function() {
                clearInterval(l);
            }, n));
        }
    }
    function S(e, t, i) {
        if (I(e)) console.error("Inject assets error");
        else if (T(t) && (i = t, t = !1), C(t) && t in window) T(i) && i();
        else {
            var n;
            if (-1 !== e.indexOf(".css")) {
                if ((n = document.querySelectorAll('link[href="' + e + '"]')) && n.length > 0) return void (T(i) && i());
                var s = document.getElementsByTagName("head")[0], l = s.querySelectorAll('link[rel="stylesheet"]'), o = document.createElement("link");
                return o.rel = "stylesheet", o.type = "text/css", o.href = e, o.media = "all", l ? s.insertBefore(o, l[0]) : s.appendChild(o), void (T(i) && i());
            }
            if ((n = document.querySelectorAll('script[src="' + e + '"]')) && n.length > 0) {
                if (T(i)) {
                    if (C(t)) return b(function() {
                        return void 0 !== window[t];
                    }, function() {
                        i();
                    }), !1;
                    i();
                }
            } else {
                var r = document.createElement("script");
                r.type = "text/javascript", r.src = e, r.onload = function() {
                    if (T(i)) {
                        if (C(t)) return b(function() {
                            return void 0 !== window[t];
                        }, function() {
                            i();
                        }), !1;
                        i();
                    }
                }, document.body.appendChild(r);
            }
        }
    }
    function w() {
        return "navigator" in window && window.navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(Android)|(PlayBook)|(BB10)|(BlackBerry)|(Opera Mini)|(IEMobile)|(webOS)|(MeeGo)/i);
    }
    function T(e) {
        return "function" == typeof e;
    }
    function C(e) {
        return "string" == typeof e;
    }
    function k(e) {
        return !(!e || !e.nodeType || 1 != e.nodeType);
    }
    function E(e) {
        return Array.isArray(e);
    }
    function A(e) {
        return e && e.length && isFinite(e.length);
    }
    function L(t) {
        return "object" === e(t) && null != t && !T(t) && !E(t);
    }
    function I(e) {
        return null == e;
    }
    function O(e, t) {
        return null !== e && hasOwnProperty.call(e, t);
    }
    function P(e) {
        if (L(e)) {
            if (e.keys) return e.keys().length;
            var t = 0;
            for(var i in e)O(e, i) && t++;
            return t;
        }
        return e.length;
    }
    function M(e) {
        return !isNaN(parseFloat(e)) && isFinite(e);
    }
    function z() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : -1, t = document.querySelectorAll(".gbtn[data-taborder]:not(.disabled)");
        if (!t.length) return !1;
        if (1 == t.length) return t[0];
        "string" == typeof e && (e = parseInt(e));
        var i = [];
        o(t, function(e) {
            i.push(e.getAttribute("data-taborder"));
        });
        var n = Math.max.apply(Math, i.map(function(e) {
            return parseInt(e);
        })), s = e < 0 ? 1 : e + 1;
        s > n && (s = "1");
        var l = i.filter(function(e) {
            return e >= parseInt(s);
        }), r = l.sort()[0];
        return document.querySelector('.gbtn[data-taborder="'.concat(r, '"]'));
    }
    function X(e) {
        if (e.events.hasOwnProperty("keyboard")) return !1;
        e.events.keyboard = a("keydown", {
            onElement: window,
            withCallback: function(t, i) {
                var n = (t = t || window.event).keyCode;
                if (9 == n) {
                    var s = document.querySelector(".gbtn.focused");
                    if (!s) {
                        var l = !(!document.activeElement || !document.activeElement.nodeName) && document.activeElement.nodeName.toLocaleLowerCase();
                        if ("input" == l || "textarea" == l || "button" == l) return;
                    }
                    t.preventDefault();
                    var o = document.querySelectorAll(".gbtn[data-taborder]");
                    if (!o || o.length <= 0) return;
                    if (!s) {
                        var r = z();
                        return void (r && (r.focus(), h(r, "focused")));
                    }
                    var a = z(s.getAttribute("data-taborder"));
                    d(s, "focused"), a && (a.focus(), h(a, "focused"));
                }
                39 == n && e.nextSlide(), 37 == n && e.prevSlide(), 27 == n && e.close();
            }
        });
    }
    function Y(e) {
        return Math.sqrt(e.x * e.x + e.y * e.y);
    }
    function q(e, t) {
        var i = function(e, t) {
            var i = Y(e) * Y(t);
            if (0 === i) return 0;
            var n = function(e, t) {
                return e.x * t.x + e.y * t.y;
            }(e, t) / i;
            return n > 1 && (n = 1), Math.acos(n);
        }(e, t);
        return function(e, t) {
            return e.x * t.y - t.x * e.y;
        }(e, t) > 0 && (i *= -1), 180 * i / Math.PI;
    }
    var N = function() {
        function e(i) {
            t(this, e), this.handlers = [], this.el = i;
        }
        return n(e, [
            {
                key: "add",
                value: function(e) {
                    this.handlers.push(e);
                }
            },
            {
                key: "del",
                value: function(e) {
                    e || (this.handlers = []);
                    for(var t = this.handlers.length; t >= 0; t--)this.handlers[t] === e && this.handlers.splice(t, 1);
                }
            },
            {
                key: "dispatch",
                value: function() {
                    for(var e = 0, t = this.handlers.length; e < t; e++){
                        var i = this.handlers[e];
                        "function" == typeof i && i.apply(this.el, arguments);
                    }
                }
            }
        ]), e;
    }();
    function D(e, t) {
        var i = new N(e);
        return i.add(t), i;
    }
    var _ = function() {
        function e(i, n) {
            t(this, e), this.element = "string" == typeof i ? document.querySelector(i) : i, this.start = this.start.bind(this), this.move = this.move.bind(this), this.end = this.end.bind(this), this.cancel = this.cancel.bind(this), this.element.addEventListener("touchstart", this.start, !1), this.element.addEventListener("touchmove", this.move, !1), this.element.addEventListener("touchend", this.end, !1), this.element.addEventListener("touchcancel", this.cancel, !1), this.preV = {
                x: null,
                y: null
            }, this.pinchStartLen = null, this.zoom = 1, this.isDoubleTap = !1;
            var s = function() {};
            this.rotate = D(this.element, n.rotate || s), this.touchStart = D(this.element, n.touchStart || s), this.multipointStart = D(this.element, n.multipointStart || s), this.multipointEnd = D(this.element, n.multipointEnd || s), this.pinch = D(this.element, n.pinch || s), this.swipe = D(this.element, n.swipe || s), this.tap = D(this.element, n.tap || s), this.doubleTap = D(this.element, n.doubleTap || s), this.longTap = D(this.element, n.longTap || s), this.singleTap = D(this.element, n.singleTap || s), this.pressMove = D(this.element, n.pressMove || s), this.twoFingerPressMove = D(this.element, n.twoFingerPressMove || s), this.touchMove = D(this.element, n.touchMove || s), this.touchEnd = D(this.element, n.touchEnd || s), this.touchCancel = D(this.element, n.touchCancel || s), this.translateContainer = this.element, this._cancelAllHandler = this.cancelAll.bind(this), window.addEventListener("scroll", this._cancelAllHandler), this.delta = null, this.last = null, this.now = null, this.tapTimeout = null, this.singleTapTimeout = null, this.longTapTimeout = null, this.swipeTimeout = null, this.x1 = this.x2 = this.y1 = this.y2 = null, this.preTapPosition = {
                x: null,
                y: null
            };
        }
        return n(e, [
            {
                key: "start",
                value: function(e) {
                    if (e.touches) {
                        if (e.target && e.target.nodeName && [
                            "a",
                            "button",
                            "input"
                        ].indexOf(e.target.nodeName.toLowerCase()) >= 0) console.log("ignore drag for this touched element", e.target.nodeName.toLowerCase());
                        else {
                            this.now = Date.now(), this.x1 = e.touches[0].pageX, this.y1 = e.touches[0].pageY, this.delta = this.now - (this.last || this.now), this.touchStart.dispatch(e, this.element), null !== this.preTapPosition.x && (this.isDoubleTap = this.delta > 0 && this.delta <= 250 && Math.abs(this.preTapPosition.x - this.x1) < 30 && Math.abs(this.preTapPosition.y - this.y1) < 30, this.isDoubleTap && clearTimeout(this.singleTapTimeout)), this.preTapPosition.x = this.x1, this.preTapPosition.y = this.y1, this.last = this.now;
                            var t = this.preV;
                            if (e.touches.length > 1) {
                                this._cancelLongTap(), this._cancelSingleTap();
                                var i = {
                                    x: e.touches[1].pageX - this.x1,
                                    y: e.touches[1].pageY - this.y1
                                };
                                t.x = i.x, t.y = i.y, this.pinchStartLen = Y(t), this.multipointStart.dispatch(e, this.element);
                            }
                            this._preventTap = !1, this.longTapTimeout = setTimeout((function() {
                                this.longTap.dispatch(e, this.element), this._preventTap = !0;
                            }).bind(this), 750);
                        }
                    }
                }
            },
            {
                key: "move",
                value: function(e) {
                    if (e.touches) {
                        var t = this.preV, i = e.touches.length, n = e.touches[0].pageX, s = e.touches[0].pageY;
                        if (this.isDoubleTap = !1, i > 1) {
                            var l = e.touches[1].pageX, o = e.touches[1].pageY, r = {
                                x: e.touches[1].pageX - n,
                                y: e.touches[1].pageY - s
                            };
                            null !== t.x && (this.pinchStartLen > 0 && (e.zoom = Y(r) / this.pinchStartLen, this.pinch.dispatch(e, this.element)), e.angle = q(r, t), this.rotate.dispatch(e, this.element)), t.x = r.x, t.y = r.y, null !== this.x2 && null !== this.sx2 ? (e.deltaX = (n - this.x2 + l - this.sx2) / 2, e.deltaY = (s - this.y2 + o - this.sy2) / 2) : (e.deltaX = 0, e.deltaY = 0), this.twoFingerPressMove.dispatch(e, this.element), this.sx2 = l, this.sy2 = o;
                        } else {
                            if (null !== this.x2) {
                                e.deltaX = n - this.x2, e.deltaY = s - this.y2;
                                var a = Math.abs(this.x1 - this.x2), h = Math.abs(this.y1 - this.y2);
                                (a > 10 || h > 10) && (this._preventTap = !0);
                            } else e.deltaX = 0, e.deltaY = 0;
                            this.pressMove.dispatch(e, this.element);
                        }
                        this.touchMove.dispatch(e, this.element), this._cancelLongTap(), this.x2 = n, this.y2 = s, i > 1 && e.preventDefault();
                    }
                }
            },
            {
                key: "end",
                value: function(e) {
                    if (e.changedTouches) {
                        this._cancelLongTap();
                        var t = this;
                        e.touches.length < 2 && (this.multipointEnd.dispatch(e, this.element), this.sx2 = this.sy2 = null), this.x2 && Math.abs(this.x1 - this.x2) > 30 || this.y2 && Math.abs(this.y1 - this.y2) > 30 ? (e.direction = this._swipeDirection(this.x1, this.x2, this.y1, this.y2), this.swipeTimeout = setTimeout(function() {
                            t.swipe.dispatch(e, t.element);
                        }, 0)) : (this.tapTimeout = setTimeout(function() {
                            t._preventTap || t.tap.dispatch(e, t.element), t.isDoubleTap && (t.doubleTap.dispatch(e, t.element), t.isDoubleTap = !1);
                        }, 0), t.isDoubleTap || (t.singleTapTimeout = setTimeout(function() {
                            t.singleTap.dispatch(e, t.element);
                        }, 250))), this.touchEnd.dispatch(e, this.element), this.preV.x = 0, this.preV.y = 0, this.zoom = 1, this.pinchStartLen = null, this.x1 = this.x2 = this.y1 = this.y2 = null;
                    }
                }
            },
            {
                key: "cancelAll",
                value: function() {
                    this._preventTap = !0, clearTimeout(this.singleTapTimeout), clearTimeout(this.tapTimeout), clearTimeout(this.longTapTimeout), clearTimeout(this.swipeTimeout);
                }
            },
            {
                key: "cancel",
                value: function(e) {
                    this.cancelAll(), this.touchCancel.dispatch(e, this.element);
                }
            },
            {
                key: "_cancelLongTap",
                value: function() {
                    clearTimeout(this.longTapTimeout);
                }
            },
            {
                key: "_cancelSingleTap",
                value: function() {
                    clearTimeout(this.singleTapTimeout);
                }
            },
            {
                key: "_swipeDirection",
                value: function(e, t, i, n) {
                    return Math.abs(e - t) >= Math.abs(i - n) ? e - t > 0 ? "Left" : "Right" : i - n > 0 ? "Up" : "Down";
                }
            },
            {
                key: "on",
                value: function(e, t) {
                    this[e] && this[e].add(t);
                }
            },
            {
                key: "off",
                value: function(e, t) {
                    this[e] && this[e].del(t);
                }
            },
            {
                key: "destroy",
                value: function() {
                    return this.singleTapTimeout && clearTimeout(this.singleTapTimeout), this.tapTimeout && clearTimeout(this.tapTimeout), this.longTapTimeout && clearTimeout(this.longTapTimeout), this.swipeTimeout && clearTimeout(this.swipeTimeout), this.element.removeEventListener("touchstart", this.start), this.element.removeEventListener("touchmove", this.move), this.element.removeEventListener("touchend", this.end), this.element.removeEventListener("touchcancel", this.cancel), this.rotate.del(), this.touchStart.del(), this.multipointStart.del(), this.multipointEnd.del(), this.pinch.del(), this.swipe.del(), this.tap.del(), this.doubleTap.del(), this.longTap.del(), this.singleTap.del(), this.pressMove.del(), this.twoFingerPressMove.del(), this.touchMove.del(), this.touchEnd.del(), this.touchCancel.del(), this.preV = this.pinchStartLen = this.zoom = this.isDoubleTap = this.delta = this.last = this.now = this.tapTimeout = this.singleTapTimeout = this.longTapTimeout = this.swipeTimeout = this.x1 = this.x2 = this.y1 = this.y2 = this.preTapPosition = this.rotate = this.touchStart = this.multipointStart = this.multipointEnd = this.pinch = this.swipe = this.tap = this.doubleTap = this.longTap = this.singleTap = this.pressMove = this.touchMove = this.touchEnd = this.touchCancel = this.twoFingerPressMove = null, window.removeEventListener("scroll", this._cancelAllHandler), null;
                }
            }
        ]), e;
    }();
    function W(e) {
        var t = function() {
            var e, t = document.createElement("fakeelement"), i = {
                transition: "transitionend",
                OTransition: "oTransitionEnd",
                MozTransition: "transitionend",
                WebkitTransition: "webkitTransitionEnd"
            };
            for(e in i)if (void 0 !== t.style[e]) return i[e];
        }(), i = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth, n = c(e, "gslide-media") ? e : e.querySelector(".gslide-media"), s = u(n, ".ginner-container"), l = e.querySelector(".gslide-description");
        i > 769 && (n = s), h(n, "greset"), v(n, "translate3d(0, 0, 0)"), a(t, {
            onElement: n,
            once: !0,
            withCallback: function(e, t) {
                d(n, "greset");
            }
        }), n.style.opacity = "", l && (l.style.opacity = "");
    }
    function B(e) {
        if (e.events.hasOwnProperty("touch")) return !1;
        var t, i, n, s = y(), l = s.width, o = s.height, r = !1, a = null, g = null, f = null, p = !1, m = 1, x = 1, b = !1, S = !1, w = null, T = null, C = null, k = null, E = 0, A = 0, L = !1, I = !1, O = {}, P = {}, M = 0, z = 0, X = document.getElementById("glightbox-slider"), Y = document.querySelector(".goverlay"), q = new _(X, {
            touchStart: function(t) {
                if (r = !0, (c(t.targetTouches[0].target, "ginner-container") || u(t.targetTouches[0].target, ".gslide-desc") || "a" == t.targetTouches[0].target.nodeName.toLowerCase()) && (r = !1), u(t.targetTouches[0].target, ".gslide-inline") && !c(t.targetTouches[0].target.parentNode, "gslide-inline") && (r = !1), r) {
                    if (P = t.targetTouches[0], O.pageX = t.targetTouches[0].pageX, O.pageY = t.targetTouches[0].pageY, M = t.targetTouches[0].clientX, z = t.targetTouches[0].clientY, a = e.activeSlide, g = a.querySelector(".gslide-media"), n = a.querySelector(".gslide-inline"), f = null, c(g, "gslide-image") && (f = g.querySelector("img")), (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) > 769 && (g = a.querySelector(".ginner-container")), d(Y, "greset"), t.pageX > 20 && t.pageX < window.innerWidth - 20) return;
                    t.preventDefault();
                }
            },
            touchMove: function(s) {
                if (r && (P = s.targetTouches[0], !b && !S)) {
                    if (n && n.offsetHeight > o) {
                        var a = O.pageX - P.pageX;
                        if (Math.abs(a) <= 13) return !1;
                    }
                    p = !0;
                    var h, d = s.targetTouches[0].clientX, c = s.targetTouches[0].clientY, u = M - d, m = z - c;
                    if (Math.abs(u) > Math.abs(m) ? (L = !1, I = !0) : (I = !1, L = !0), t = P.pageX - O.pageX, E = 100 * t / l, i = P.pageY - O.pageY, A = 100 * i / o, L && f && (h = 1 - Math.abs(i) / o, Y.style.opacity = h, e.settings.touchFollowAxis && (E = 0)), I && (h = 1 - Math.abs(t) / l, g.style.opacity = h, e.settings.touchFollowAxis && (A = 0)), !f) return v(g, "translate3d(".concat(E, "%, 0, 0)"));
                    v(g, "translate3d(".concat(E, "%, ").concat(A, "%, 0)"));
                }
            },
            touchEnd: function() {
                if (r) {
                    if (p = !1, S || b) return C = w, void (k = T);
                    var t = Math.abs(parseInt(A)), i = Math.abs(parseInt(E));
                    if (!(t > 29 && f)) return t < 29 && i < 25 ? (h(Y, "greset"), Y.style.opacity = 1, W(g)) : void 0;
                    e.close();
                }
            },
            multipointEnd: function() {
                setTimeout(function() {
                    b = !1;
                }, 50);
            },
            multipointStart: function() {
                b = !0, m = x || 1;
            },
            pinch: function(e) {
                if (!f || p) return !1;
                b = !0, f.scaleX = f.scaleY = m * e.zoom;
                var t = m * e.zoom;
                if (S = !0, t <= 1) return S = !1, t = 1, k = null, C = null, w = null, T = null, void f.setAttribute("style", "");
                t > 4.5 && (t = 4.5), f.style.transform = "scale3d(".concat(t, ", ").concat(t, ", 1)"), x = t;
            },
            pressMove: function(e) {
                if (S && !b) {
                    var t = P.pageX - O.pageX, i = P.pageY - O.pageY;
                    C && (t += C), k && (i += k), w = t, T = i;
                    var n = "translate3d(".concat(t, "px, ").concat(i, "px, 0)");
                    x && (n += " scale3d(".concat(x, ", ").concat(x, ", 1)")), v(f, n);
                }
            },
            swipe: function(t) {
                if (!S) {
                    if (b) b = !1;
                    else {
                        if ("Left" == t.direction) {
                            if (e.index == e.elements.length - 1) return W(g);
                            e.nextSlide();
                        }
                        if ("Right" == t.direction) {
                            if (0 == e.index) return W(g);
                            e.prevSlide();
                        }
                    }
                }
            }
        });
        e.events.touch = q;
    }
    var H = function() {
        function e(i, n) {
            var s = this, l = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
            if (t(this, e), this.img = i, this.slide = n, this.onclose = l, this.img.setZoomEvents) return !1;
            this.active = !1, this.zoomedIn = !1, this.dragging = !1, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.img.addEventListener("mousedown", function(e) {
                return s.dragStart(e);
            }, !1), this.img.addEventListener("mouseup", function(e) {
                return s.dragEnd(e);
            }, !1), this.img.addEventListener("mousemove", function(e) {
                return s.drag(e);
            }, !1), this.img.addEventListener("click", function(e) {
                return s.slide.classList.contains("dragging-nav") ? (s.zoomOut(), !1) : s.zoomedIn ? void (s.zoomedIn && !s.dragging && s.zoomOut()) : s.zoomIn();
            }, !1), this.img.setZoomEvents = !0;
        }
        return n(e, [
            {
                key: "zoomIn",
                value: function() {
                    var e = this.widowWidth();
                    if (!(this.zoomedIn || e <= 768)) {
                        var t = this.img;
                        if (t.setAttribute("data-style", t.getAttribute("style")), t.style.maxWidth = t.naturalWidth + "px", t.style.maxHeight = t.naturalHeight + "px", t.naturalWidth > e) {
                            var i = e / 2 - t.naturalWidth / 2;
                            this.setTranslate(this.img.parentNode, i, 0);
                        }
                        this.slide.classList.add("zoomed"), this.zoomedIn = !0;
                    }
                }
            },
            {
                key: "zoomOut",
                value: function() {
                    this.img.parentNode.setAttribute("style", ""), this.img.setAttribute("style", this.img.getAttribute("data-style")), this.slide.classList.remove("zoomed"), this.zoomedIn = !1, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.onclose && "function" == typeof this.onclose && this.onclose();
                }
            },
            {
                key: "dragStart",
                value: function(e) {
                    e.preventDefault(), this.zoomedIn ? ("touchstart" === e.type ? (this.initialX = e.touches[0].clientX - this.xOffset, this.initialY = e.touches[0].clientY - this.yOffset) : (this.initialX = e.clientX - this.xOffset, this.initialY = e.clientY - this.yOffset), e.target === this.img && (this.active = !0, this.img.classList.add("dragging"))) : this.active = !1;
                }
            },
            {
                key: "dragEnd",
                value: function(e) {
                    var t = this;
                    e.preventDefault(), this.initialX = this.currentX, this.initialY = this.currentY, this.active = !1, setTimeout(function() {
                        t.dragging = !1, t.img.isDragging = !1, t.img.classList.remove("dragging");
                    }, 100);
                }
            },
            {
                key: "drag",
                value: function(e) {
                    this.active && (e.preventDefault(), "touchmove" === e.type ? (this.currentX = e.touches[0].clientX - this.initialX, this.currentY = e.touches[0].clientY - this.initialY) : (this.currentX = e.clientX - this.initialX, this.currentY = e.clientY - this.initialY), this.xOffset = this.currentX, this.yOffset = this.currentY, this.img.isDragging = !0, this.dragging = !0, this.setTranslate(this.img, this.currentX, this.currentY));
                }
            },
            {
                key: "onMove",
                value: function(e) {
                    if (this.zoomedIn) {
                        var t = e.clientX - this.img.naturalWidth / 2, i = e.clientY - this.img.naturalHeight / 2;
                        this.setTranslate(this.img, t, i);
                    }
                }
            },
            {
                key: "setTranslate",
                value: function(e, t, i) {
                    e.style.transform = "translate3d(" + t + "px, " + i + "px, 0)";
                }
            },
            {
                key: "widowWidth",
                value: function() {
                    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                }
            }
        ]), e;
    }(), V = function() {
        function e() {
            var i = this, n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            t(this, e);
            var s = n.dragEl, l = n.toleranceX, o = void 0 === l ? 40 : l, r = n.toleranceY, a = void 0 === r ? 65 : r, h = n.slide, d = void 0 === h ? null : h, c = n.instance, u = void 0 === c ? null : c;
            this.el = s, this.active = !1, this.dragging = !1, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.direction = null, this.lastDirection = null, this.toleranceX = o, this.toleranceY = a, this.toleranceReached = !1, this.dragContainer = this.el, this.slide = d, this.instance = u, this.el.addEventListener("mousedown", function(e) {
                return i.dragStart(e);
            }, !1), this.el.addEventListener("mouseup", function(e) {
                return i.dragEnd(e);
            }, !1), this.el.addEventListener("mousemove", function(e) {
                return i.drag(e);
            }, !1);
        }
        return n(e, [
            {
                key: "dragStart",
                value: function(e) {
                    if (this.slide.classList.contains("zoomed")) this.active = !1;
                    else {
                        "touchstart" === e.type ? (this.initialX = e.touches[0].clientX - this.xOffset, this.initialY = e.touches[0].clientY - this.yOffset) : (this.initialX = e.clientX - this.xOffset, this.initialY = e.clientY - this.yOffset);
                        var t = e.target.nodeName.toLowerCase();
                        e.target.classList.contains("nodrag") || u(e.target, ".nodrag") || -1 !== [
                            "input",
                            "select",
                            "textarea",
                            "button",
                            "a"
                        ].indexOf(t) ? this.active = !1 : (e.preventDefault(), (e.target === this.el || "img" !== t && u(e.target, ".gslide-inline")) && (this.active = !0, this.el.classList.add("dragging"), this.dragContainer = u(e.target, ".ginner-container")));
                    }
                }
            },
            {
                key: "dragEnd",
                value: function(e) {
                    var t = this;
                    e && e.preventDefault(), this.initialX = 0, this.initialY = 0, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.active = !1, this.doSlideChange && (this.instance.preventOutsideClick = !0, "right" == this.doSlideChange && this.instance.prevSlide(), "left" == this.doSlideChange && this.instance.nextSlide()), this.doSlideClose && this.instance.close(), this.toleranceReached || this.setTranslate(this.dragContainer, 0, 0, !0), setTimeout(function() {
                        t.instance.preventOutsideClick = !1, t.toleranceReached = !1, t.lastDirection = null, t.dragging = !1, t.el.isDragging = !1, t.el.classList.remove("dragging"), t.slide.classList.remove("dragging-nav"), t.dragContainer.style.transform = "", t.dragContainer.style.transition = "";
                    }, 100);
                }
            },
            {
                key: "drag",
                value: function(e) {
                    if (this.active) {
                        e.preventDefault(), this.slide.classList.add("dragging-nav"), "touchmove" === e.type ? (this.currentX = e.touches[0].clientX - this.initialX, this.currentY = e.touches[0].clientY - this.initialY) : (this.currentX = e.clientX - this.initialX, this.currentY = e.clientY - this.initialY), this.xOffset = this.currentX, this.yOffset = this.currentY, this.el.isDragging = !0, this.dragging = !0, this.doSlideChange = !1, this.doSlideClose = !1;
                        var t = Math.abs(this.currentX), i = Math.abs(this.currentY);
                        if (t > 0 && t >= Math.abs(this.currentY) && (!this.lastDirection || "x" == this.lastDirection)) {
                            this.yOffset = 0, this.lastDirection = "x", this.setTranslate(this.dragContainer, this.currentX, 0);
                            var n = this.shouldChange();
                            if (!this.instance.settings.dragAutoSnap && n && (this.doSlideChange = n), this.instance.settings.dragAutoSnap && n) return this.instance.preventOutsideClick = !0, this.toleranceReached = !0, this.active = !1, this.instance.preventOutsideClick = !0, this.dragEnd(null), "right" == n && this.instance.prevSlide(), void ("left" == n && this.instance.nextSlide());
                        }
                        if (this.toleranceY > 0 && i > 0 && i >= t && (!this.lastDirection || "y" == this.lastDirection)) {
                            this.xOffset = 0, this.lastDirection = "y", this.setTranslate(this.dragContainer, 0, this.currentY);
                            var s = this.shouldClose();
                            return !this.instance.settings.dragAutoSnap && s && (this.doSlideClose = !0), void (this.instance.settings.dragAutoSnap && s && this.instance.close());
                        }
                    }
                }
            },
            {
                key: "shouldChange",
                value: function() {
                    var e = !1;
                    if (Math.abs(this.currentX) >= this.toleranceX) {
                        var t = this.currentX > 0 ? "right" : "left";
                        ("left" == t && this.slide !== this.slide.parentNode.lastChild || "right" == t && this.slide !== this.slide.parentNode.firstChild) && (e = t);
                    }
                    return e;
                }
            },
            {
                key: "shouldClose",
                value: function() {
                    var e = !1;
                    return Math.abs(this.currentY) >= this.toleranceY && (e = !0), e;
                }
            },
            {
                key: "setTranslate",
                value: function(e, t, i) {
                    var n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                    e.style.transition = n ? "all .2s ease" : "", e.style.transform = "translate3d(".concat(t, "px, ").concat(i, "px, 0)");
                }
            }
        ]), e;
    }();
    function j(e, t, i, n) {
        var s = e.querySelector(".gslide-media"), l = new Image, o = "gSlideTitle_" + i, r = "gSlideDesc_" + i;
        l.addEventListener("load", function() {
            T(n) && n();
        }, !1), l.src = t.href, "" != t.sizes && "" != t.srcset && (l.sizes = t.sizes, l.srcset = t.srcset), l.alt = "", I(t.alt) || "" === t.alt || (l.alt = t.alt), "" !== t.title && l.setAttribute("aria-labelledby", o), "" !== t.description && l.setAttribute("aria-describedby", r), t.hasOwnProperty("_hasCustomWidth") && t._hasCustomWidth && (l.style.width = t.width), t.hasOwnProperty("_hasCustomHeight") && t._hasCustomHeight && (l.style.height = t.height), s.insertBefore(l, s.firstChild);
    }
    function F(e, t, i, n) {
        var s = this, l = e.querySelector(".ginner-container"), o = "gvideo" + i, r = e.querySelector(".gslide-media"), a = this.getAllPlayers();
        h(l, "gvideo-container"), r.insertBefore(m('<div class="gvideo-wrapper"></div>'), r.firstChild);
        var d = e.querySelector(".gvideo-wrapper");
        S(this.settings.plyr.css, "Plyr");
        var c = t.href, u = null == t ? void 0 : t.videoProvider, g = !1;
        r.style.maxWidth = t.width, S(this.settings.plyr.js, "Plyr", function() {
            if (!u && c.match(/vimeo\.com\/([0-9]*)/) && (u = "vimeo"), !u && (c.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/) || c.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) || c.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/)) && (u = "youtube"), "local" === u || !u) {
                u = "local";
                var l = '<video id="' + o + '" ';
                l += 'style="background:#000; max-width: '.concat(t.width, ';" '), l += 'preload="metadata" ', l += 'x-webkit-airplay="allow" ', l += "playsinline ", l += "controls ", l += 'class="gvideo-local">', l += '<source src="'.concat(c, '">'), g = m(l += "</video>");
            }
            var r = g || m('<div id="'.concat(o, '" data-plyr-provider="').concat(u, '" data-plyr-embed-id="').concat(c, '"></div>'));
            h(d, "".concat(u, "-video gvideo")), d.appendChild(r), d.setAttribute("data-id", o), d.setAttribute("data-index", i);
            var v = O(s.settings.plyr, "config") ? s.settings.plyr.config : {}, f = new Plyr("#" + o, v);
            f.on("ready", function(e) {
                a[o] = e.detail.plyr, T(n) && n();
            }), b(function() {
                return e.querySelector("iframe") && "true" == e.querySelector("iframe").dataset.ready;
            }, function() {
                s.resize(e);
            }), f.on("enterfullscreen", R), f.on("exitfullscreen", R);
        });
    }
    function R(e) {
        var t = u(e.target, ".gslide-media");
        "enterfullscreen" === e.type && h(t, "fullscreen"), "exitfullscreen" === e.type && d(t, "fullscreen");
    }
    function G(e, t, i, n) {
        var s, l = this, o = e.querySelector(".gslide-media"), r = !(!O(t, "href") || !t.href) && t.href.split("#").pop().trim(), d = !(!O(t, "content") || !t.content) && t.content;
        if (d && (C(d) && (s = m('<div class="ginlined-content">'.concat(d, "</div>"))), k(d))) {
            "none" == d.style.display && (d.style.display = "block");
            var c = document.createElement("div");
            c.className = "ginlined-content", c.appendChild(d), s = c;
        }
        if (r) {
            var u = document.getElementById(r);
            if (!u) return !1;
            var g = u.cloneNode(!0);
            g.style.height = t.height, g.style.maxWidth = t.width, h(g, "ginlined-content"), s = g;
        }
        if (!s) return console.error("Unable to append inline slide content", t), !1;
        o.style.height = t.height, o.style.width = t.width, o.appendChild(s), this.events["inlineclose" + r] = a("click", {
            onElement: o.querySelectorAll(".gtrigger-close"),
            withCallback: function(e) {
                e.preventDefault(), l.close();
            }
        }), T(n) && n();
    }
    function Z(e, t, i, n) {
        var s = e.querySelector(".gslide-media"), l = function(e) {
            var t = e.url, i = e.allow, n = e.callback, s = e.appendTo, l = document.createElement("iframe");
            return l.className = "vimeo-video gvideo", l.src = t, l.style.width = "100%", l.style.height = "100%", i && l.setAttribute("allow", i), l.onload = function() {
                l.onload = null, h(l, "node-ready"), T(n) && n();
            }, s && s.appendChild(l), l;
        }({
            url: t.href,
            callback: n
        });
        s.parentNode.style.maxWidth = t.width, s.parentNode.style.height = t.height, s.appendChild(l);
    }
    var U = function() {
        function e() {
            var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            t(this, e), this.defaults = {
                href: "",
                sizes: "",
                srcset: "",
                title: "",
                type: "",
                videoProvider: "",
                description: "",
                alt: "",
                descPosition: "bottom",
                effect: "",
                width: "",
                height: "",
                content: !1,
                zoomable: !0,
                draggable: !0
            }, L(i) && (this.defaults = l(this.defaults, i));
        }
        return n(e, [
            {
                key: "sourceType",
                value: function(e) {
                    var t = e;
                    if (null !== (e = e.toLowerCase()).match(/\.(jpeg|jpg|jpe|gif|png|apn|webp|avif|svg)/)) return "image";
                    if (e.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/) || e.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) || e.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/)) return "video";
                    if (e.match(/vimeo\.com\/([0-9]*)/)) return "video";
                    if (null !== e.match(/\.(mp4|ogg|webm|mov)/)) return "video";
                    if (null !== e.match(/\.(mp3|wav|wma|aac|ogg)/)) return "audio";
                    if (e.indexOf("#") > -1 && "" !== t.split("#").pop().trim()) return "inline";
                    return e.indexOf("goajax=true") > -1 ? "ajax" : "external";
                }
            },
            {
                key: "parseConfig",
                value: function(e, t) {
                    var i = this, n = l({
                        descPosition: t.descPosition
                    }, this.defaults);
                    if (L(e) && !k(e)) {
                        O(e, "type") || (O(e, "content") && e.content ? e.type = "inline" : O(e, "href") && (e.type = this.sourceType(e.href)));
                        var s = l(n, e);
                        return this.setSize(s, t), s;
                    }
                    var r = "", a = e.getAttribute("data-glightbox"), h = e.nodeName.toLowerCase();
                    if ("a" === h && (r = e.href), "img" === h && (r = e.src, n.alt = e.alt), n.href = r, o(n, function(s, l) {
                        O(t, l) && "width" !== l && (n[l] = t[l]);
                        var o = e.dataset[l];
                        I(o) || (n[l] = i.sanitizeValue(o));
                    }), n.content && (n.type = "inline"), !n.type && r && (n.type = this.sourceType(r)), I(a)) {
                        if (!n.title && "a" == h) {
                            var d = e.title;
                            I(d) || "" === d || (n.title = d);
                        }
                        if (!n.title && "img" == h) {
                            var c = e.alt;
                            I(c) || "" === c || (n.title = c);
                        }
                    } else {
                        var u = [];
                        o(n, function(e, t) {
                            u.push(";\\s?" + t);
                        }), u = u.join("\\s?:|"), "" !== a.trim() && o(n, function(e, t) {
                            var s = a, l = new RegExp("s?" + t + "s?:s?(.*?)(" + u + "s?:|$)"), o = s.match(l);
                            if (o && o.length && o[1]) {
                                var r = o[1].trim().replace(/;\s*$/, "");
                                n[t] = i.sanitizeValue(r);
                            }
                        });
                    }
                    if (n.description && "." === n.description.substring(0, 1)) {
                        var g;
                        try {
                            g = document.querySelector(n.description).innerHTML;
                        } catch (e) {
                            if (!(e instanceof DOMException)) throw e;
                        }
                        g && (n.description = g);
                    }
                    if (!n.description) {
                        var v = e.querySelector(".glightbox-desc");
                        v && (n.description = v.innerHTML);
                    }
                    return this.setSize(n, t, e), this.slideConfig = n, n;
                }
            },
            {
                key: "setSize",
                value: function(e, t) {
                    var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, n = "video" == e.type ? this.checkSize(t.videosWidth) : this.checkSize(t.width), s = this.checkSize(t.height);
                    return e.width = O(e, "width") && "" !== e.width ? this.checkSize(e.width) : n, e.height = O(e, "height") && "" !== e.height ? this.checkSize(e.height) : s, i && "image" == e.type && (e._hasCustomWidth = !!i.dataset.width, e._hasCustomHeight = !!i.dataset.height), e;
                }
            },
            {
                key: "checkSize",
                value: function(e) {
                    return M(e) ? "".concat(e, "px") : e;
                }
            },
            {
                key: "sanitizeValue",
                value: function(e) {
                    return "true" !== e && "false" !== e ? e : "true" === e;
                }
            }
        ]), e;
    }(), $ = function() {
        function e(i, n, s) {
            t(this, e), this.element = i, this.instance = n, this.index = s;
        }
        return n(e, [
            {
                key: "setContent",
                value: function() {
                    var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    if (c(t, "loaded")) return !1;
                    var n = this.instance.settings, s = this.slideConfig, l = w();
                    T(n.beforeSlideLoad) && n.beforeSlideLoad({
                        index: this.index,
                        slide: t,
                        player: !1
                    });
                    var o = s.type, r = s.descPosition, a = t.querySelector(".gslide-media"), d = t.querySelector(".gslide-title"), u = t.querySelector(".gslide-desc"), g = t.querySelector(".gdesc-inner"), v = i, f = "gSlideTitle_" + this.index, p = "gSlideDesc_" + this.index;
                    if (T(n.afterSlideLoad) && (v = function() {
                        T(i) && i(), n.afterSlideLoad({
                            index: e.index,
                            slide: t,
                            player: e.instance.getSlidePlayerInstance(e.index)
                        });
                    }), "" == s.title && "" == s.description ? g && g.parentNode.parentNode.removeChild(g.parentNode) : (d && "" !== s.title ? (d.id = f, d.innerHTML = s.title) : d.parentNode.removeChild(d), u && "" !== s.description ? (u.id = p, l && n.moreLength > 0 ? (s.smallDescription = this.slideShortDesc(s.description, n.moreLength, n.moreText), u.innerHTML = s.smallDescription, this.descriptionEvents(u, s)) : u.innerHTML = s.description) : u.parentNode.removeChild(u), h(a.parentNode, "desc-".concat(r)), h(g.parentNode, "description-".concat(r))), h(a, "gslide-".concat(o)), h(t, "loaded"), "video" !== o) {
                        if ("external" !== o) return "inline" === o ? (G.apply(this.instance, [
                            t,
                            s,
                            this.index,
                            v
                        ]), void (s.draggable && new V({
                            dragEl: t.querySelector(".gslide-inline"),
                            toleranceX: n.dragToleranceX,
                            toleranceY: n.dragToleranceY,
                            slide: t,
                            instance: this.instance
                        }))) : void ("image" !== o ? T(v) && v() : j(t, s, this.index, function() {
                            var i = t.querySelector("img");
                            s.draggable && new V({
                                dragEl: i,
                                toleranceX: n.dragToleranceX,
                                toleranceY: n.dragToleranceY,
                                slide: t,
                                instance: e.instance
                            }), s.zoomable && i.naturalWidth > i.offsetWidth && (h(i, "zoomable"), new H(i, t, function() {
                                e.instance.resize();
                            })), T(v) && v();
                        }));
                        Z.apply(this, [
                            t,
                            s,
                            this.index,
                            v
                        ]);
                    } else F.apply(this.instance, [
                        t,
                        s,
                        this.index,
                        v
                    ]);
                }
            },
            {
                key: "slideShortDesc",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 50, i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], n = document.createElement("div");
                    n.innerHTML = e;
                    var s = n.innerText, l = i;
                    if ((e = s.trim()).length <= t) return e;
                    var o = e.substr(0, t - 1);
                    return l ? (n = null, o + '... <a href="#" class="desc-more">' + i + "</a>") : o;
                }
            },
            {
                key: "descriptionEvents",
                value: function(e, t) {
                    var i = this, n = e.querySelector(".desc-more");
                    if (!n) return !1;
                    a("click", {
                        onElement: n,
                        withCallback: function(e, n) {
                            e.preventDefault();
                            var s = document.body, l = u(n, ".gslide-desc");
                            if (!l) return !1;
                            l.innerHTML = t.description, h(s, "gdesc-open");
                            var o = a("click", {
                                onElement: [
                                    s,
                                    u(l, ".gslide-description")
                                ],
                                withCallback: function(e, n) {
                                    "a" !== e.target.nodeName.toLowerCase() && (d(s, "gdesc-open"), h(s, "gdesc-closed"), l.innerHTML = t.smallDescription, i.descriptionEvents(l, t), setTimeout(function() {
                                        d(s, "gdesc-closed");
                                    }, 400), o.destroy());
                                }
                            });
                        }
                    });
                }
            },
            {
                key: "create",
                value: function() {
                    return m(this.instance.settings.slideHTML);
                }
            },
            {
                key: "getConfig",
                value: function() {
                    k(this.element) || this.element.hasOwnProperty("draggable") || (this.element.draggable = this.instance.settings.draggable);
                    var e = new U(this.instance.settings.slideExtraAttributes);
                    return this.slideConfig = e.parseConfig(this.element, this.instance.settings), this.slideConfig;
                }
            }
        ]), e;
    }(), J = w(), K = null !== w() || void 0 !== document.createTouch || "ontouchstart" in window || "onmsgesturechange" in window || navigator.msMaxTouchPoints, Q = document.getElementsByTagName("html")[0], ee = {
        selector: ".glightbox",
        elements: null,
        skin: "clean",
        theme: "clean",
        closeButton: !0,
        startAt: null,
        autoplayVideos: !0,
        autofocusVideos: !0,
        descPosition: "bottom",
        width: "900px",
        height: "506px",
        videosWidth: "960px",
        beforeSlideChange: null,
        afterSlideChange: null,
        beforeSlideLoad: null,
        afterSlideLoad: null,
        slideInserted: null,
        slideRemoved: null,
        slideExtraAttributes: null,
        onOpen: null,
        onClose: null,
        loop: !1,
        zoomable: !0,
        draggable: !0,
        dragAutoSnap: !1,
        dragToleranceX: 40,
        dragToleranceY: 65,
        preload: !0,
        oneSlidePerOpen: !1,
        touchNavigation: !0,
        touchFollowAxis: !0,
        keyboardNavigation: !0,
        closeOnOutsideClick: !0,
        plugins: !1,
        plyr: {
            css: "https://cdn.plyr.io/3.6.12/plyr.css",
            js: "https://cdn.plyr.io/3.6.12/plyr.js",
            config: {
                ratio: "16:9",
                fullscreen: {
                    enabled: !0,
                    iosNative: !0
                },
                youtube: {
                    noCookie: !0,
                    rel: 0,
                    showinfo: 0,
                    iv_load_policy: 3
                },
                vimeo: {
                    byline: !1,
                    portrait: !1,
                    title: !1,
                    transparent: !1
                }
            }
        },
        openEffect: "zoom",
        closeEffect: "zoom",
        slideEffect: "slide",
        moreText: "See more",
        moreLength: 60,
        cssEfects: {
            fade: {
                in: "fadeIn",
                out: "fadeOut"
            },
            zoom: {
                in: "zoomIn",
                out: "zoomOut"
            },
            slide: {
                in: "slideInRight",
                out: "slideOutLeft"
            },
            slideBack: {
                in: "slideInLeft",
                out: "slideOutRight"
            },
            none: {
                in: "none",
                out: "none"
            }
        },
        svg: {
            close: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve"><g><g><path d="M505.943,6.058c-8.077-8.077-21.172-8.077-29.249,0L6.058,476.693c-8.077,8.077-8.077,21.172,0,29.249C10.096,509.982,15.39,512,20.683,512c5.293,0,10.586-2.019,14.625-6.059L505.943,35.306C514.019,27.23,514.019,14.135,505.943,6.058z"/></g></g><g><g><path d="M505.942,476.694L35.306,6.059c-8.076-8.077-21.172-8.077-29.248,0c-8.077,8.076-8.077,21.171,0,29.248l470.636,470.636c4.038,4.039,9.332,6.058,14.625,6.058c5.293,0,10.587-2.019,14.624-6.057C514.018,497.866,514.018,484.771,505.942,476.694z"/></g></g></svg>',
            next: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"> <g><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"/></g></svg>',
            prev: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"><g><path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/></g></svg>'
        },
        slideHTML: '<div class="gslide">\n    <div class="gslide-inner-content">\n        <div class="ginner-container">\n            <div class="gslide-media">\n            </div>\n            <div class="gslide-description">\n                <div class="gdesc-inner">\n                    <h4 class="gslide-title"></h4>\n                    <div class="gslide-desc"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>',
        lightboxHTML: '<div id="glightbox-body" class="glightbox-container" tabindex="-1" role="dialog" aria-hidden="false">\n    <div class="gloader visible"></div>\n    <div class="goverlay"></div>\n    <div class="gcontainer">\n    <div id="glightbox-slider" class="gslider"></div>\n    <button class="gclose gbtn" aria-label="Close" data-taborder="3">{closeSVG}</button>\n    <button class="gprev gbtn" aria-label="Previous" data-taborder="2">{prevSVG}</button>\n    <button class="gnext gbtn" aria-label="Next" data-taborder="1">{nextSVG}</button>\n</div>\n</div>'
    }, te = function() {
        function e() {
            var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            t(this, e), this.customOptions = i, this.settings = l(ee, i), this.effectsClasses = this.getAnimationClasses(), this.videoPlayers = {}, this.apiEvents = [], this.fullElementsList = !1;
        }
        return n(e, [
            {
                key: "init",
                value: function() {
                    var e = this, t = this.getSelector();
                    t && (this.baseEvents = a("click", {
                        onElement: t,
                        withCallback: function(t, i) {
                            t.preventDefault(), e.open(i);
                        }
                    })), this.elements = this.getElements();
                }
            },
            {
                key: "open",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                    if (0 === this.elements.length) return !1;
                    this.activeSlide = null, this.prevActiveSlideIndex = null, this.prevActiveSlide = null;
                    var i = M(t) ? t : this.settings.startAt;
                    if (k(e)) {
                        var n = e.getAttribute("data-gallery");
                        n && (this.fullElementsList = this.elements, this.elements = this.getGalleryElements(this.elements, n)), I(i) && (i = this.getElementIndex(e)) < 0 && (i = 0);
                    }
                    M(i) || (i = 0), this.build(), g(this.overlay, "none" === this.settings.openEffect ? "none" : this.settings.cssEfects.fade.in);
                    var s = document.body, l = window.innerWidth - document.documentElement.clientWidth;
                    if (l > 0) {
                        var o = document.createElement("style");
                        o.type = "text/css", o.className = "gcss-styles", o.innerText = ".gscrollbar-fixer {margin-right: ".concat(l, "px}"), document.head.appendChild(o), h(s, "gscrollbar-fixer");
                    }
                    h(s, "glightbox-open"), h(Q, "glightbox-open"), J && (h(document.body, "glightbox-mobile"), this.settings.slideEffect = "slide"), this.showSlide(i, !0), 1 === this.elements.length ? (h(this.prevButton, "glightbox-button-hidden"), h(this.nextButton, "glightbox-button-hidden")) : (d(this.prevButton, "glightbox-button-hidden"), d(this.nextButton, "glightbox-button-hidden")), this.lightboxOpen = !0, this.trigger("open"), T(this.settings.onOpen) && this.settings.onOpen(), K && this.settings.touchNavigation && B(this), this.settings.keyboardNavigation && X(this);
                }
            },
            {
                key: "openAt",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                    this.open(null, e);
                }
            },
            {
                key: "showSlide",
                value: function() {
                    var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    f(this.loader), this.index = parseInt(t);
                    var n = this.slidesContainer.querySelector(".current");
                    n && d(n, "current"), this.slideAnimateOut();
                    var s = this.slidesContainer.querySelectorAll(".gslide")[t];
                    if (c(s, "loaded")) this.slideAnimateIn(s, i), p(this.loader);
                    else {
                        f(this.loader);
                        var l = this.elements[t], o = {
                            index: this.index,
                            slide: s,
                            slideNode: s,
                            slideConfig: l.slideConfig,
                            slideIndex: this.index,
                            trigger: l.node,
                            player: null
                        };
                        this.trigger("slide_before_load", o), l.instance.setContent(s, function() {
                            p(e.loader), e.resize(), e.slideAnimateIn(s, i), e.trigger("slide_after_load", o);
                        });
                    }
                    this.slideDescription = s.querySelector(".gslide-description"), this.slideDescriptionContained = this.slideDescription && c(this.slideDescription.parentNode, "gslide-media"), this.settings.preload && (this.preloadSlide(t + 1), this.preloadSlide(t - 1)), this.updateNavigationClasses(), this.activeSlide = s;
                }
            },
            {
                key: "preloadSlide",
                value: function(e) {
                    var t = this;
                    if (e < 0 || e > this.elements.length - 1) return !1;
                    if (I(this.elements[e])) return !1;
                    var i = this.slidesContainer.querySelectorAll(".gslide")[e];
                    if (c(i, "loaded")) return !1;
                    var n = this.elements[e], s = n.type, l = {
                        index: e,
                        slide: i,
                        slideNode: i,
                        slideConfig: n.slideConfig,
                        slideIndex: e,
                        trigger: n.node,
                        player: null
                    };
                    this.trigger("slide_before_load", l), "video" === s || "external" === s ? setTimeout(function() {
                        n.instance.setContent(i, function() {
                            t.trigger("slide_after_load", l);
                        });
                    }, 200) : n.instance.setContent(i, function() {
                        t.trigger("slide_after_load", l);
                    });
                }
            },
            {
                key: "prevSlide",
                value: function() {
                    this.goToSlide(this.index - 1);
                }
            },
            {
                key: "nextSlide",
                value: function() {
                    this.goToSlide(this.index + 1);
                }
            },
            {
                key: "goToSlide",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                    if (this.prevActiveSlide = this.activeSlide, this.prevActiveSlideIndex = this.index, !this.loop() && (e < 0 || e > this.elements.length - 1)) return !1;
                    e < 0 ? e = this.elements.length - 1 : e >= this.elements.length && (e = 0), this.showSlide(e);
                }
            },
            {
                key: "insertSlide",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1;
                    t < 0 && (t = this.elements.length);
                    var i = new $(e, this, t), n = i.getConfig(), s = l({}, n), o = i.create(), r = this.elements.length - 1;
                    s.index = t, s.node = !1, s.instance = i, s.slideConfig = n, this.elements.splice(t, 0, s);
                    var a = null, h = null;
                    if (this.slidesContainer) {
                        if (t > r) this.slidesContainer.appendChild(o);
                        else {
                            var d = this.slidesContainer.querySelectorAll(".gslide")[t];
                            this.slidesContainer.insertBefore(o, d);
                        }
                        (this.settings.preload && 0 == this.index && 0 == t || this.index - 1 == t || this.index + 1 == t) && this.preloadSlide(t), 0 === this.index && 0 === t && (this.index = 1), this.updateNavigationClasses(), a = this.slidesContainer.querySelectorAll(".gslide")[t], h = this.getSlidePlayerInstance(t), s.slideNode = a;
                    }
                    this.trigger("slide_inserted", {
                        index: t,
                        slide: a,
                        slideNode: a,
                        slideConfig: n,
                        slideIndex: t,
                        trigger: null,
                        player: h
                    }), T(this.settings.slideInserted) && this.settings.slideInserted({
                        index: t,
                        slide: a,
                        player: h
                    });
                }
            },
            {
                key: "removeSlide",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : -1;
                    if (e < 0 || e > this.elements.length - 1) return !1;
                    var t = this.slidesContainer && this.slidesContainer.querySelectorAll(".gslide")[e];
                    t && (this.getActiveSlideIndex() == e && (e == this.elements.length - 1 ? this.prevSlide() : this.nextSlide()), t.parentNode.removeChild(t)), this.elements.splice(e, 1), this.trigger("slide_removed", e), T(this.settings.slideRemoved) && this.settings.slideRemoved(e);
                }
            },
            {
                key: "slideAnimateIn",
                value: function(e, t) {
                    var i = this, n = e.querySelector(".gslide-media"), s = e.querySelector(".gslide-description"), l = {
                        index: this.prevActiveSlideIndex,
                        slide: this.prevActiveSlide,
                        slideNode: this.prevActiveSlide,
                        slideIndex: this.prevActiveSlide,
                        slideConfig: I(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].slideConfig,
                        trigger: I(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].node,
                        player: this.getSlidePlayerInstance(this.prevActiveSlideIndex)
                    }, o = {
                        index: this.index,
                        slide: this.activeSlide,
                        slideNode: this.activeSlide,
                        slideConfig: this.elements[this.index].slideConfig,
                        slideIndex: this.index,
                        trigger: this.elements[this.index].node,
                        player: this.getSlidePlayerInstance(this.index)
                    };
                    if (n.offsetWidth > 0 && s && (p(s), s.style.display = ""), d(e, this.effectsClasses), t) g(e, this.settings.cssEfects[this.settings.openEffect].in, function() {
                        i.settings.autoplayVideos && i.slidePlayerPlay(e), i.trigger("slide_changed", {
                            prev: l,
                            current: o
                        }), T(i.settings.afterSlideChange) && i.settings.afterSlideChange.apply(i, [
                            l,
                            o
                        ]);
                    });
                    else {
                        var r = this.settings.slideEffect, a = "none" !== r ? this.settings.cssEfects[r].in : r;
                        this.prevActiveSlideIndex > this.index && "slide" == this.settings.slideEffect && (a = this.settings.cssEfects.slideBack.in), g(e, a, function() {
                            i.settings.autoplayVideos && i.slidePlayerPlay(e), i.trigger("slide_changed", {
                                prev: l,
                                current: o
                            }), T(i.settings.afterSlideChange) && i.settings.afterSlideChange.apply(i, [
                                l,
                                o
                            ]);
                        });
                    }
                    setTimeout(function() {
                        i.resize(e);
                    }, 100), h(e, "current");
                }
            },
            {
                key: "slideAnimateOut",
                value: function() {
                    if (!this.prevActiveSlide) return !1;
                    var e = this.prevActiveSlide;
                    d(e, this.effectsClasses), h(e, "prev");
                    var t = this.settings.slideEffect, i = "none" !== t ? this.settings.cssEfects[t].out : t;
                    this.slidePlayerPause(e), this.trigger("slide_before_change", {
                        prev: {
                            index: this.prevActiveSlideIndex,
                            slide: this.prevActiveSlide,
                            slideNode: this.prevActiveSlide,
                            slideIndex: this.prevActiveSlideIndex,
                            slideConfig: I(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].slideConfig,
                            trigger: I(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].node,
                            player: this.getSlidePlayerInstance(this.prevActiveSlideIndex)
                        },
                        current: {
                            index: this.index,
                            slide: this.activeSlide,
                            slideNode: this.activeSlide,
                            slideIndex: this.index,
                            slideConfig: this.elements[this.index].slideConfig,
                            trigger: this.elements[this.index].node,
                            player: this.getSlidePlayerInstance(this.index)
                        }
                    }), T(this.settings.beforeSlideChange) && this.settings.beforeSlideChange.apply(this, [
                        {
                            index: this.prevActiveSlideIndex,
                            slide: this.prevActiveSlide,
                            player: this.getSlidePlayerInstance(this.prevActiveSlideIndex)
                        },
                        {
                            index: this.index,
                            slide: this.activeSlide,
                            player: this.getSlidePlayerInstance(this.index)
                        }
                    ]), this.prevActiveSlideIndex > this.index && "slide" == this.settings.slideEffect && (i = this.settings.cssEfects.slideBack.out), g(e, i, function() {
                        var t = e.querySelector(".ginner-container"), i = e.querySelector(".gslide-media"), n = e.querySelector(".gslide-description");
                        t.style.transform = "", i.style.transform = "", d(i, "greset"), i.style.opacity = "", n && (n.style.opacity = ""), d(e, "prev");
                    });
                }
            },
            {
                key: "getAllPlayers",
                value: function() {
                    return this.videoPlayers;
                }
            },
            {
                key: "getSlidePlayerInstance",
                value: function(e) {
                    var t = "gvideo" + e, i = this.getAllPlayers();
                    return !(!O(i, t) || !i[t]) && i[t];
                }
            },
            {
                key: "stopSlideVideo",
                value: function(e) {
                    if (k(e)) {
                        var t = e.querySelector(".gvideo-wrapper");
                        t && (e = t.getAttribute("data-index"));
                    }
                    console.log("stopSlideVideo is deprecated, use slidePlayerPause");
                    var i = this.getSlidePlayerInstance(e);
                    i && i.playing && i.pause();
                }
            },
            {
                key: "slidePlayerPause",
                value: function(e) {
                    if (k(e)) {
                        var t = e.querySelector(".gvideo-wrapper");
                        t && (e = t.getAttribute("data-index"));
                    }
                    var i = this.getSlidePlayerInstance(e);
                    i && i.playing && i.pause();
                }
            },
            {
                key: "playSlideVideo",
                value: function(e) {
                    if (k(e)) {
                        var t = e.querySelector(".gvideo-wrapper");
                        t && (e = t.getAttribute("data-index"));
                    }
                    console.log("playSlideVideo is deprecated, use slidePlayerPlay");
                    var i = this.getSlidePlayerInstance(e);
                    i && !i.playing && i.play();
                }
            },
            {
                key: "slidePlayerPlay",
                value: function(e) {
                    var t;
                    if (!J || null !== (t = this.settings.plyr.config) && void 0 !== t && t.muted) {
                        if (k(e)) {
                            var i = e.querySelector(".gvideo-wrapper");
                            i && (e = i.getAttribute("data-index"));
                        }
                        var n = this.getSlidePlayerInstance(e);
                        n && !n.playing && (n.play(), this.settings.autofocusVideos && n.elements.container.focus());
                    }
                }
            },
            {
                key: "setElements",
                value: function(e) {
                    var t = this;
                    this.settings.elements = !1;
                    var i = [];
                    e && e.length && o(e, function(e, n) {
                        var s = new $(e, t, n), o = s.getConfig(), r = l({}, o);
                        r.slideConfig = o, r.instance = s, r.index = n, i.push(r);
                    }), this.elements = i, this.lightboxOpen && (this.slidesContainer.innerHTML = "", this.elements.length && (o(this.elements, function() {
                        var e = m(t.settings.slideHTML);
                        t.slidesContainer.appendChild(e);
                    }), this.showSlide(0, !0)));
                }
            },
            {
                key: "getElementIndex",
                value: function(e) {
                    var t = !1;
                    return o(this.elements, function(i, n) {
                        if (O(i, "node") && i.node == e) return t = n, !0;
                    }), t;
                }
            },
            {
                key: "getElements",
                value: function() {
                    var e = this, t = [];
                    this.elements = this.elements ? this.elements : [], !I(this.settings.elements) && E(this.settings.elements) && this.settings.elements.length && o(this.settings.elements, function(i, n) {
                        var s = new $(i, e, n), o = s.getConfig(), r = l({}, o);
                        r.node = !1, r.index = n, r.instance = s, r.slideConfig = o, t.push(r);
                    });
                    var i = !1;
                    return this.getSelector() && (i = document.querySelectorAll(this.getSelector())), i ? (o(i, function(i, n) {
                        var s = new $(i, e, n), o = s.getConfig(), r = l({}, o);
                        r.node = i, r.index = n, r.instance = s, r.slideConfig = o, r.gallery = i.getAttribute("data-gallery"), t.push(r);
                    }), t) : t;
                }
            },
            {
                key: "getGalleryElements",
                value: function(e, t) {
                    return e.filter(function(e) {
                        return e.gallery == t;
                    });
                }
            },
            {
                key: "getSelector",
                value: function() {
                    return !this.settings.elements && (this.settings.selector && "data-" == this.settings.selector.substring(0, 5) ? "*[".concat(this.settings.selector, "]") : this.settings.selector);
                }
            },
            {
                key: "getActiveSlide",
                value: function() {
                    return this.slidesContainer.querySelectorAll(".gslide")[this.index];
                }
            },
            {
                key: "getActiveSlideIndex",
                value: function() {
                    return this.index;
                }
            },
            {
                key: "getAnimationClasses",
                value: function() {
                    var e = [];
                    for(var t in this.settings.cssEfects)if (this.settings.cssEfects.hasOwnProperty(t)) {
                        var i = this.settings.cssEfects[t];
                        e.push("g".concat(i.in)), e.push("g".concat(i.out));
                    }
                    return e.join(" ");
                }
            },
            {
                key: "build",
                value: function() {
                    var e = this;
                    if (this.built) return !1;
                    var t = document.body.childNodes, i = [];
                    o(t, function(e) {
                        e.parentNode == document.body && "#" !== e.nodeName.charAt(0) && e.hasAttribute && !e.hasAttribute("aria-hidden") && (i.push(e), e.setAttribute("aria-hidden", "true"));
                    });
                    var n = O(this.settings.svg, "next") ? this.settings.svg.next : "", s = O(this.settings.svg, "prev") ? this.settings.svg.prev : "", l = O(this.settings.svg, "close") ? this.settings.svg.close : "", r = this.settings.lightboxHTML;
                    r = m(r = (r = (r = r.replace(/{nextSVG}/g, n)).replace(/{prevSVG}/g, s)).replace(/{closeSVG}/g, l)), document.body.appendChild(r);
                    var d = document.getElementById("glightbox-body");
                    this.modal = d;
                    var g = d.querySelector(".gclose");
                    this.prevButton = d.querySelector(".gprev"), this.nextButton = d.querySelector(".gnext"), this.overlay = d.querySelector(".goverlay"), this.loader = d.querySelector(".gloader"), this.slidesContainer = document.getElementById("glightbox-slider"), this.bodyHiddenChildElms = i, this.events = {}, h(this.modal, "glightbox-" + this.settings.skin), this.settings.closeButton && g && (this.events.close = a("click", {
                        onElement: g,
                        withCallback: function(t, i) {
                            t.preventDefault(), e.close();
                        }
                    })), g && !this.settings.closeButton && g.parentNode.removeChild(g), this.nextButton && (this.events.next = a("click", {
                        onElement: this.nextButton,
                        withCallback: function(t, i) {
                            t.preventDefault(), e.nextSlide();
                        }
                    })), this.prevButton && (this.events.prev = a("click", {
                        onElement: this.prevButton,
                        withCallback: function(t, i) {
                            t.preventDefault(), e.prevSlide();
                        }
                    })), this.settings.closeOnOutsideClick && (this.events.outClose = a("click", {
                        onElement: d,
                        withCallback: function(t, i) {
                            e.preventOutsideClick || c(document.body, "glightbox-mobile") || u(t.target, ".ginner-container") || u(t.target, ".gbtn") || c(t.target, "gnext") || c(t.target, "gprev") || e.close();
                        }
                    })), o(this.elements, function(t, i) {
                        e.slidesContainer.appendChild(t.instance.create()), t.slideNode = e.slidesContainer.querySelectorAll(".gslide")[i];
                    }), K && h(document.body, "glightbox-touch"), this.events.resize = a("resize", {
                        onElement: window,
                        withCallback: function() {
                            e.resize();
                        }
                    }), this.built = !0;
                }
            },
            {
                key: "resize",
                value: function() {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                    if ((e = e || this.activeSlide) && !c(e, "zoomed")) {
                        var t = y(), i = e.querySelector(".gvideo-wrapper"), n = e.querySelector(".gslide-image"), s = this.slideDescription, l = t.width, o = t.height;
                        if (l <= 768 ? h(document.body, "glightbox-mobile") : d(document.body, "glightbox-mobile"), i || n) {
                            var r = !1;
                            if (s && (c(s, "description-bottom") || c(s, "description-top")) && !c(s, "gabsolute") && (r = !0), n) {
                                if (l <= 768) n.querySelector("img");
                                else if (r) {
                                    var a = s.offsetHeight, u = n.querySelector("img");
                                    u.setAttribute("style", "max-height: calc(100vh - ".concat(a, "px)")), s.setAttribute("style", "max-width: ".concat(u.offsetWidth, "px;"));
                                }
                            }
                            if (i) {
                                var g = O(this.settings.plyr.config, "ratio") ? this.settings.plyr.config.ratio : "";
                                if (!g) {
                                    var v = i.clientWidth, f = i.clientHeight, p = v / f;
                                    g = "".concat(v / p, ":").concat(f / p);
                                }
                                var m = g.split(":"), x = this.settings.videosWidth, b = this.settings.videosWidth, S = (b = M(x) || -1 !== x.indexOf("px") ? parseInt(x) : -1 !== x.indexOf("vw") ? l * parseInt(x) / 100 : -1 !== x.indexOf("vh") ? o * parseInt(x) / 100 : -1 !== x.indexOf("%") ? l * parseInt(x) / 100 : parseInt(i.clientWidth)) / (parseInt(m[0]) / parseInt(m[1]));
                                if (S = Math.floor(S), r && (o -= s.offsetHeight), b > l || S > o || o < S && l > b) {
                                    var w = i.offsetWidth, T = i.offsetHeight, C = o / T, k = {
                                        width: w * C,
                                        height: T * C
                                    };
                                    i.parentNode.setAttribute("style", "max-width: ".concat(k.width, "px")), r && s.setAttribute("style", "max-width: ".concat(k.width, "px;"));
                                } else i.parentNode.style.maxWidth = "".concat(x), r && s.setAttribute("style", "max-width: ".concat(x, ";"));
                            }
                        }
                    }
                }
            },
            {
                key: "reload",
                value: function() {
                    this.init();
                }
            },
            {
                key: "updateNavigationClasses",
                value: function() {
                    var e = this.loop();
                    d(this.nextButton, "disabled"), d(this.prevButton, "disabled"), 0 == this.index && this.elements.length - 1 == 0 ? (h(this.prevButton, "disabled"), h(this.nextButton, "disabled")) : 0 !== this.index || e ? this.index !== this.elements.length - 1 || e || h(this.nextButton, "disabled") : h(this.prevButton, "disabled");
                }
            },
            {
                key: "loop",
                value: function() {
                    var e = O(this.settings, "loopAtEnd") ? this.settings.loopAtEnd : null;
                    return e = O(this.settings, "loop") ? this.settings.loop : e, e;
                }
            },
            {
                key: "close",
                value: function() {
                    var e = this;
                    if (!this.lightboxOpen) {
                        if (this.events) {
                            for(var t in this.events)this.events.hasOwnProperty(t) && this.events[t].destroy();
                            this.events = null;
                        }
                        return !1;
                    }
                    if (this.closing) return !1;
                    this.closing = !0, this.slidePlayerPause(this.activeSlide), this.fullElementsList && (this.elements = this.fullElementsList), this.bodyHiddenChildElms.length && o(this.bodyHiddenChildElms, function(e) {
                        e.removeAttribute("aria-hidden");
                    }), h(this.modal, "glightbox-closing"), g(this.overlay, "none" == this.settings.openEffect ? "none" : this.settings.cssEfects.fade.out), g(this.activeSlide, this.settings.cssEfects[this.settings.closeEffect].out, function() {
                        if (e.activeSlide = null, e.prevActiveSlideIndex = null, e.prevActiveSlide = null, e.built = !1, e.events) {
                            for(var t in e.events)e.events.hasOwnProperty(t) && e.events[t].destroy();
                            e.events = null;
                        }
                        var i = document.body;
                        d(Q, "glightbox-open"), d(i, "glightbox-open touching gdesc-open glightbox-touch glightbox-mobile gscrollbar-fixer"), e.modal.parentNode.removeChild(e.modal), e.trigger("close"), T(e.settings.onClose) && e.settings.onClose();
                        var n = document.querySelector(".gcss-styles");
                        n && n.parentNode.removeChild(n), e.lightboxOpen = !1, e.closing = null;
                    });
                }
            },
            {
                key: "destroy",
                value: function() {
                    this.close(), this.clearAllEvents(), this.baseEvents && this.baseEvents.destroy();
                }
            },
            {
                key: "on",
                value: function(e, t) {
                    var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                    if (!e || !T(t)) throw new TypeError("Event name and callback must be defined");
                    this.apiEvents.push({
                        evt: e,
                        once: i,
                        callback: t
                    });
                }
            },
            {
                key: "once",
                value: function(e, t) {
                    this.on(e, t, !0);
                }
            },
            {
                key: "trigger",
                value: function(e) {
                    var t = this, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, n = [];
                    o(this.apiEvents, function(t, s) {
                        var l = t.evt, o = t.once, r = t.callback;
                        l == e && (r(i), o && n.push(s));
                    }), n.length && o(n, function(e) {
                        return t.apiEvents.splice(e, 1);
                    });
                }
            },
            {
                key: "clearAllEvents",
                value: function() {
                    this.apiEvents.splice(0, this.apiEvents.length);
                }
            },
            {
                key: "version",
                value: function() {
                    return "3.1.0";
                }
            }
        ]), e;
    }();
    return function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = new te(e);
        return t.init(), t;
    };
});


function $e784210fef036a05$export$9477d5792fdd966f() {
    window.recaptchaOnLoad = function() {
        grecaptcha.enterprise.ready(function() {
            document.querySelectorAll("[data-recaptcha-holder]").forEach(function(element) {
                let form = element.closest("form");
                let isCheckboxType = element.dataset.ischeckbox;
                if (isCheckboxType == "False") grecaptcha.enterprise.execute(element.dataset.sitekey).then(function(token) {
                    element.innerHTML = element.innerHTML + '<input type="hidden" name="g-recaptcha-response" value="' + token + '">';
                });
                else {
                    form.dataset.noRecaptcha = true;
                    form.addEventListener("submit", function(event) {
                        if (form.dataset.noRecaptcha) {
                            event.preventDefault();
                            alert("Please submit Recaptcha");
                        }
                    });
                    let button = form.querySelector('button[type="submit"], input[type="submit"]');
                    button.setAttribute("disabled", "disabled");
                    grecaptcha.enterprise.render(element.id, {
                        "sitekey": element.dataset.sitekey,
                        callback: function() {
                            button.removeAttribute("disabled");
                            form.removeAttribute("data-no-recaptcha");
                        }
                    });
                }
            });
        });
    };
}


function $2acb526bbfd6495c$var$correctHiddenFields() {
    const partnerByEmail = document.querySelector("[data-partner-by-email]")?.innerHTML;
    const partnerByPhone = document.querySelector("[data-partner-by-phone]")?.innerHTML;
    const amOnlineByPhone = document.querySelector("[data-am-online-by-phone]")?.innerHTML;
    if (partnerByEmail === "True") document.querySelector("input[name=PartnerByEmail]").value = "true";
    if (partnerByPhone === "True") document.querySelector("input[name=PartnerByPhone]").value = "true";
    if (amOnlineByPhone === "True") document.querySelector("input[name=AMOnlineByPhone]").value = "true";
}
function $2acb526bbfd6495c$var$checkPhoneRequirement() {
    const partnerByPhone = document.querySelector("input[name=PartnerByPhone]")?.value;
    const amOnlineByPhone = document.querySelector("input[name=AMOnlineByPhone]")?.value;
    const phoneNumber = document.querySelector("#PhoneNumber")?.value ?? "";
    const phoneValidationElement = document.querySelector("[data-phone-validation]");
    if (partnerByPhone === "true" || amOnlineByPhone === "false") {
        if (phoneNumber !== "") phoneValidationElement.classList.add("d-none");
        else phoneValidationElement.classList.remove("d-none");
    } else phoneValidationElement.classList.add("d-none");
}
function $2acb526bbfd6495c$var$onRegisterClick(e) {
    $2acb526bbfd6495c$var$checkPhoneRequirement();
    const form = document.querySelector("[data-registration-form]");
    if (!form?.checkValidity()) return;
    e.preventDefault();
    const button = form.querySelector('button[type="submit"], input[type="submit"]');
    const partnerByPhone = document.querySelector("input[name=PartnerByPhone]").value;
    const bauerByPhone = document.querySelector("input[name=BauerByPhone]").value;
    const phoneNumber = document.querySelector("#PhoneNumber")?.value ?? "";
    if (partnerByPhone === "true" || bauerByPhone === "false") {
        if (phoneNumber !== "") {
            button.setAttribute("disabled", "disabled");
            form.submit();
        } else document.querySelector("[data-phone-validation]").classList.remove("d-none");
    } else {
        button.setAttribute("disabled", "disabled");
        form.submit();
    }
}
function $2acb526bbfd6495c$export$b612431b20616c48() {
    const phoneNumberElement = document.querySelector("#PhoneNumber");
    phoneNumberElement?.addEventListener("keypress", ()=>{
        document.querySelector("[data-phone-validation]").classList.add("d-none");
    });
    let registerButton = document.querySelector("[data-btn-register]");
    if (registerButton) registerButton.addEventListener("click", $2acb526bbfd6495c$var$onRegisterClick);
    let permutiveId = window.localStorage.getItem("permutive-id");
    let permutiveIdEl = document.querySelector("#PermutiveId");
    if (permutiveIdEl) permutiveIdEl.value = permutiveId;
    document.querySelector("#PartnerByPhone")?.addEventListener("change", function() {
        document.querySelector("input[name=PartnerByPhone]").value = this.checked ? "true" : "false";
        $2acb526bbfd6495c$var$checkPhoneRequirement();
    });
    document.querySelector("#BauerByPhone")?.addEventListener("change", function() {
        document.querySelector("input[name=BauerByPhone]").value = this.checked ? "true" : "false";
        $2acb526bbfd6495c$var$checkPhoneRequirement();
    });
    $("nav.navbar .collapse").on("show.bs.collapse", $2acb526bbfd6495c$var$onShowNavbar);
    $("nav.navbar .collapse").on("hide.bs.collapse", $2acb526bbfd6495c$var$onHideNavbar);
    document.querySelector(".reveal")?.addEventListener("click", function() {
        let pwd = document.querySelector(".pwd");
        if (pwd.getAttribute("type") === "password") {
            pwd.setAttribute("type", "text");
            this.innerHTML = '<i class="bi bi-eye-fill"></i>';
        } else {
            pwd.setAttribute("type", "password");
            this.innerHTML = '<i class="bi bi-eye-slash-fill"></i>';
        }
    });
    let industrySector = document.querySelector("#Input_IndustrySector")?.value;
    if (industrySector === "PrivateSectorOther" || industrySector === "PublicSectorOther" || industrySector === "15" || industrySector === "25") document.querySelector("[data-other-industry-sector]").classList.remove("d-none");
    document.querySelector("[data-industry-sector]")?.addEventListener("change", function() {
        if (this.value === "PrivateSectorOther" || this.value === "PublicSectorOther" || this.value === "15" || this.value === "25") document.querySelector("[data-other-industry-sector]")?.classList.remove("d-none");
        else document.querySelector("[data-other-industry-sector]")?.classList.add("d-none");
    });
    let jobFunction = document.querySelector("#Input_JobFunction")?.value;
    if (jobFunction === "Other" || jobFunction === "18") document.querySelector("[data-other-job-function]")?.classList.remove("d-none");
    document.querySelector("#Input_JobFunction")?.addEventListener("change", function() {
        if (this.value === "Other" || this.value === "18") document.querySelector("[data-other-job-function]")?.classList.remove("d-none");
        else document.querySelector("[data-other-job-function]")?.classList.add("d-none");
    });
    if ($("#decision-making-Other").is(":checked")) document.querySelector("[data-other-decision-making-process]")?.classList.remove("d-none");
    $(document).on("change", "#decision-making-Other", function() {
        if ($(this).is(":checked")) document.querySelector("[data-other-decision-making-process]")?.classList.remove("d-none");
        else document.querySelector("[data-other-decision-making-process]")?.classList.add("d-none");
    });
    if ($("#how-is-your-fleet-funded-Other").is(":checked")) document.querySelector("[data-other-how-is-your-fleet-funded]")?.classList.remove("d-none");
    $(document).on("change", "#how-is-your-fleet-funded-Other", function() {
        if ($(this).is(":checked")) document.querySelector("[data-other-how-is-your-fleet-funded]")?.classList.remove("d-none");
        else document.querySelector("[data-other-how-is-your-fleet-funded]")?.classList.add("d-none");
    });
    //let decision = document.querySelector('#decision-making-Other')?.value;
    //if (decision === "21") {
    //    document.querySelector('[data-other-decision-making-process]')?.classList.remove('d-none');
    //}
    //document.querySelector('#Input_DecisionMakingProcess')?.addEventListener('change', function () {
    //    if (this.value === "Other" || this.value === "21") {
    //        document.querySelector('[data-other-decision-making-process]')?.classList.remove('d-none');
    //    } else {
    //        document.querySelector('[data-other-decision-making-process]')?.classList.add('d-none');
    //    }
    //});
    //let funded = document.querySelector('#Input_HowIsYourFleetFunded')?.value;
    //if (funded === "8") {
    //    document.querySelector('[data-other-how-is-your-fleet-funded]')?.classList.remove('d-none');
    //}
    //document.querySelector('#Input_HowIsYourFleetFunded')?.addEventListener('change', function () {
    //    if (this.value === "Other" || this.value === "8") {
    //        document.querySelector('[data-other-how-is-your-fleet-funded]')?.classList.remove('d-none');
    //    } else {
    //        document.querySelector('[data-other-how-is-your-fleet-funded]')?.classList.add('d-none');
    //    }
    //});
    var $checkbox = $("#Input_UnSubscribeFromAll");
    $checkbox.on("change", function() {
        // Check if the checkbox is checked
        if ($checkbox.is(":checked")) $(".checkbox-group").prop("checked", false);
    });
    $(".checkbox-group").on("change", function() {
        $checkbox.prop("checked", false);
    });
    $2acb526bbfd6495c$var$correctHiddenFields();
}
function $2acb526bbfd6495c$var$onShowNavbar(e) {
    let minusHeight = 85;
    if ($("html").hasClass("scrolled-past-header")) {
        minusHeight = 35;
        if ($("body").hasClass("mrcms-admin-bar-on")) minusHeight = 65;
    } else if ($("body").hasClass("mrcms-admin-bar-on")) minusHeight = 115;
    const windowHeight = $(window).innerHeight() - minusHeight;
    $(".navbar-collapse .nav.navbar-nav ").css({
        height: windowHeight
    });
    $("body").attr("style", "margin: 0; height: 0; overflow: hidden;");
    $("#main-content").attr("style", "visibility:hidden");
//$(".ad-scroll-fix").hide();
}
function $2acb526bbfd6495c$var$onHideNavbar(e) {
    $("body").attr("style", "");
    $("#main-content").attr("style", "");
//$(".ad-scroll-fix").show();
}


(0, $e784210fef036a05$export$9477d5792fdd966f)();
(0, (/*@__PURE__*/$parcel$interopDefault($7b22250fbed98fb8$exports)))({
    selector: ".glightbox"
});
//let sliderSwiper = new Swiper(".swiper-slider", {
//    slidesPerView: "auto",
//    navigation: {
//        nextEl: ".carousel-control-next",
//        prevEl: ".carousel-control-prev",
//    },
//});
(0, $2acb526bbfd6495c$export$b612431b20616c48)();
let $7d0af377de65fca7$var$lgMaxWidth = window.matchMedia("(max-width: 991.9px)");
$7d0af377de65fca7$var$matchMediaHandler($7d0af377de65fca7$var$lgMaxWidth, "[data-move][data-media-lg]");
$7d0af377de65fca7$var$lgMaxWidth.addEventListener("change", function(e) {
    $7d0af377de65fca7$var$matchMediaHandler(e, "[data-move][data-media-lg]");
});
let $7d0af377de65fca7$var$mdMaxWidth = window.matchMedia("(max-width: 767.9px)");
$7d0af377de65fca7$var$matchMediaHandler($7d0af377de65fca7$var$mdMaxWidth, "[data-move][data-media-md]");
$7d0af377de65fca7$var$mdMaxWidth.addEventListener("change", function(e) {
    $7d0af377de65fca7$var$matchMediaHandler(e, "[data-move][data-media-md]");
});
let $7d0af377de65fca7$var$smMaxWidth = window.matchMedia("(max-width: 575.9px)");
$7d0af377de65fca7$var$matchMediaHandler($7d0af377de65fca7$var$smMaxWidth, "[data-move][data-media-sm]");
$7d0af377de65fca7$var$smMaxWidth.addEventListener("change", function(e) {
    $7d0af377de65fca7$var$matchMediaHandler(e, "[data-move][data-media-sm]");
});
function $7d0af377de65fca7$var$matchMediaHandler(e, selector) {
    if (e.matches) $7d0af377de65fca7$var$dataMove(selector);
    else $7d0af377de65fca7$var$dataMove(selector, true);
}
// Function to activate tab based on hash after Bootstrap initialization
function $7d0af377de65fca7$var$activateTabFromHash() {
    const hash = window.location.hash;
    if (hash) {
        const tabLink = document.querySelector(`a[data-bs-toggle="pill"][href="${hash}"]`);
        if (tabLink) new bootstrap.Tab(tabLink).show();
    }
}
// Attach the function to the onload event and hash change event
window.onload = window.onhashchange = function() {
    // Delay activating the tab based on the hash tag in the URL
    setTimeout($7d0af377de65fca7$var$activateTabFromHash, 0);
};
// Update the hash tag when a tab is shown
const $7d0af377de65fca7$var$tabElements = document.querySelectorAll('[data-bs-toggle="pill"]');
$7d0af377de65fca7$var$tabElements.forEach((tabElement)=>{
    tabElement.addEventListener("shown.bs.tab", (event)=>{
        const tabTarget = event.target.getAttribute("href");
        if (tabTarget) window.location.hash = tabTarget;
    });
});
//swiper
//let carReviewSwiper = new Swiper(".carreview", {
//    loop: true,
//    spaceBetween: 30,
//    slidesPerView: 3,
//    freeMode: true,
//    watchSlidesProgress: true,
//    breakpoints: {
//        // mobile
//        0: {
//            spaceBetween: 10,
//        },
//        // small
//        576: {
//            spaceBetween: 10,
//        },
//        // medium
//        768: {
//            spaceBetween: 10,
//        },
//        // large
//        992: {
//            spaceBetween: 20,
//        },
//        // x-large
//        1200: {
//            spaceBetween: 25,
//        }
//    }
//});
//let mainSliderSwiper = new Swiper(".main-slider", {
//    loop: true,
//    spaceBetween: 30,
//    navigation: {
//        nextEl: ".swiper-button-next",
//        prevEl: ".swiper-button-prev",
//    },
//    thumbs: {
//        swiper: carReviewSwiper,
//    },
//});
//end swiper
//set focus on search input after click on search button (mobile)
let $7d0af377de65fca7$var$mobileSearchCollapse = document.getElementById("searchOffcanvasTop");
if ($7d0af377de65fca7$var$mobileSearchCollapse) $7d0af377de65fca7$var$mobileSearchCollapse.addEventListener("shown.bs.offcanvas", function() {
    $(this).find('input[name="term"]')[0].focus();
});
// Fix table responsiveness ***********************************************
// Select all tables in the document
let $7d0af377de65fca7$var$tables = document.getElementsByTagName("table");
// Loop through each table
for(let i = 0; i < $7d0af377de65fca7$var$tables.length; i++){
    let table = $7d0af377de65fca7$var$tables[i];
    // Check if the parent of the table has the 'table-responsive' class
    if (!table.parentNode.classList.contains("table-responsive")) {
        // If it doesn't, create a new div with the class 'table-responsive'
        var $7d0af377de65fca7$var$wrapper = document.createElement("div");
        $7d0af377de65fca7$var$wrapper.className = "table-responsive";
        // Insert the div before the table in the DOM
        table.parentNode.insertBefore($7d0af377de65fca7$var$wrapper, table);
        // Move the table into the div
        $7d0af377de65fca7$var$wrapper.appendChild(table);
    }
}
// End fix table responsiveness *******************************************
function $7d0af377de65fca7$var$dataMove(selector, moveBack = false) {
    const elements = document.querySelectorAll(selector);
    elements.forEach((sourceElement)=>{
        const target = sourceElement.getAttribute("data-move");
        const targetElement = document.querySelector(target);
        if (targetElement) {
            if (moveBack) $7d0af377de65fca7$var$moveChildElements(targetElement, sourceElement);
            else $7d0af377de65fca7$var$moveChildElements(sourceElement, targetElement);
        }
    });
}
function $7d0af377de65fca7$var$moveChildElements(sourceElement, destinationElement) {
    while(sourceElement.firstChild)destinationElement.appendChild(sourceElement.firstChild);
}
function $7d0af377de65fca7$var$handleBodyCopyToggle() {
    var textDiv = document.getElementById("text");
    var toggleBtn = document.getElementById("body-copy-toggle");
    if (textDiv && toggleBtn) {
        // Get the height of the 'textDiv' in pixels
        var textDivHeight = textDiv.scrollHeight; // use scrollHeight to get total content height
        // If 'textDiv' height is more than the height of 2 lines of text, show the toggle button
        if (textDivHeight > 50) {
            toggleBtn.style.display = "block";
            // Set initial collapsed state
            textDiv.style.maxHeight = "3.2em";
            toggleBtn.addEventListener("click", function(e) {
                e.preventDefault();
                var isCollapsed = textDiv.style.maxHeight === "3.2em";
                if (isCollapsed) {
                    textDiv.style.maxHeight = textDiv.scrollHeight + "px"; // Expand it to its full height
                    this.innerHTML = "Show less";
                } else {
                    textDiv.style.maxHeight = "3.2em"; // Collapse it
                    this.innerHTML = "Show more +";
                }
            });
        }
    }
}
// Example starter JavaScript for disabling form submissions if there are invalid fields
(function() {
    "use strict";
    $('section[id^="group-section-"]').on("inview", function(event, isInView) {
        if (isInView) {
            // Get the id of the section
            var sectionName = $(this).attr("id");
            console.log("section name: " + sectionName);
            // Push an event to the dataLayer with the section name
            dataLayer.push({
                "event": "virtualPageView",
                "virtualPageURL": window.location.pathname + "#" + sectionName,
                "virtualPageTitle": sectionName // or any other title you want to give
            });
        }
    });
    $7d0af377de65fca7$var$handleBodyCopyToggle();
    $("[data-past-events]").click(function() {
        $("html, body").animate({
            scrollTop: $("#past-events").offset().top
        }, 100);
    });
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.querySelectorAll(".needs-validation");
    // Loop over them and prevent submission
    Array.prototype.slice.call(forms).forEach(function(form) {
        form.addEventListener("submit", function(event) {
            if (!form.checkValidity()) {
                event.preventDefault();
                event.stopPropagation();
            }
            form.classList.add("was-validated");
        }, false);
    });
})();

})();
//# sourceMappingURL=am-online.js.map
